import {
  AbortOptimizationResponseSchema,
  AddDeliveryTeamManagerRequestSchema,
  AddHubSplitRequestSchema,
  AddHubSplitResponseSchema,
  AdminOrderPartitionDetailSchema,
  AdminOrderPartitionSchema,
  AdminPartitionFulfillmentStatusSchema,
  AdminPartitionFulfillmentTypeSchema,
  AdminPartitionItemSchema,
  AssignDestinationLicenseRequestSchema,
  AssignDestinationLicenseResponseSchema,
  AssignDriverToPartitionRequestSchema,
  AssignDriverToShipmentLegRequestSchema,
  AssignDriverToShipmentLegResponseSchema,
  AssignTaskRequestSchema,
  AssignVehicleRequestSchema,
  AssignVehicleToDriverRequestSchema,
  AuthValidationResponseSchema,
  AutoEnqueueRequestSchema,
  AutoEnqueueResponseSchema,
  B2BWaveOrderProductSummarySchema,
  B2BWaveOrderSummarySchema,
  BatchInsertHubRequestSchema,
  BatchInsertHubResponseSchema,
  BatchRoutesResponseSchema,
  CancelQueueEntryResponseSchema,
  CheckCarrierTrackingMetricsSchema,
  CheckCarrierTrackingResponseSchema,
  CompletionRequirementsSchema,
  CreateAuxiliaryTaskBodySchema,
  CreateAuxiliaryTaskResponseSchema,
  CreateDestinationAddressSchema,
  CreateDestinationRequestSchema,
  CreateDriverRequestSchema,
  CreateDriverVehicleInputSchema,
  CreateHubAddressSchema,
  CreateHubRequestSchema,
  CreateLinkedTasksRequestSchema,
  CreateOnfleetWebhookRequestSchema,
  CreatePartitionTaskRequestSchema,
  CreateRecipientRequestSchema,
  CreateRoutePlanInputSchema,
  CreateShipmentFromPartitionsConflictSchema,
  CreateShipmentFromPartitionsRequestSchema,
  CreateShipmentFromPartitionsResponseSchema,
  CreateShipmentPlanQueueErrorSchema,
  CreateShipmentPlanRequestSchema,
  CreateShipmentPlanResponseSchema,
  CreateSupplierDriverInputSchema,
  CreateSupplierLocationTeamRequestSchema,
  CreateSupplierVehicleInputSchema,
  CreateTaskRequestSchema,
  CreateTeamRequestSchema,
  CreateVehicleRequestSchema,
  DashboardStatsSchema,
  DeleteShipmentLegRequestSchema,
  DeleteShipmentLegResponseSchema,
  DeleteShipmentRequestSchema,
  DeleteShipmentResponseSchema,
  DeliveryTaskSchema,
  DeliveryTaskStatusSchema,
  DeliveryTaskTypeSchema,
  DeliveryTeamHubOptionSchema,
  DeliveryTeamManagerSchema,
  DestinationAddressSchema,
  DestinationLocationSchema,
  DestinationSchema,
  DispatchShipmentRequestSchema,
  DriverAnalyticsQuerySchema,
  DriverAnalyticsSchema,
  DriverPoolQuerySchema,
  DriverPoolResponseSchema,
  DriverPositionSchema,
  DriverReconcileMetricsSchema,
  DriverSchema,
  DriverStatusSchema,
  DriverTasksQuerySchema,
  EnqueuePartitionRequestSchema,
  EnqueuePartitionResponseSchema,
  EnrichedQueueEntrySchema,
  GeoLocationSchema,
  GetAssignmentQueueStatsQuerySchema,
  GetRoutesQuerySchema,
  GetShipmentDriverPositionsResponseSchema,
  GetShipmentLegManifestResponseSchema,
  GetSupplierRoutesQuerySchema,
  GetTeamTasksQuerySchema,
  HubAddressSchema,
  HubLocationSchema,
  HubSchema,
  InitializeOptimizationRequestSchema,
  InitializeOptimizationResponseSchema,
  InsertWaypointRequestSchema,
  InsertWaypointResponseSchema,
  InternalDatabaseFailoverStatusResponseSchema,
  InternalDatabaseFailoverSwitchResponseSchema,
  InternalDatabaseHealthSchema,
  InternalDatabaseStatusSchema,
  InternalDatabaseSwitchRequestSchema,
  InternalDatabaseSwitchResultSchema,
  LegConsistencyIssueSchema,
  LinkedTasksResponseSchema,
  ListAssignmentQueueQuerySchema,
  ListDestinationsQuerySchema,
  ListDriversQuerySchema,
  ListOrdersQuerySchema,
  ListPartitionsQuerySchema,
  ListRecipientsQuerySchema,
  ListRoutePlansQuerySchema,
  ListShipmentLegQueueQuerySchema,
  ListShipmentSummariesQuerySchema,
  ListSupplierDriversQuerySchema,
  ListSupplierVehiclesQuerySchema,
  ListTasksQuerySchema,
  ListVehiclesQuerySchema,
  OnfleetWebhookSchema,
  OnfleetWebhookTriggerSchema,
  OptimizationIssueSchema,
  OptimizationMetricsSchema,
  OptimizationResultSummarySchema,
  OptimizationStatusResponseSchema,
  OptimizationWorkerMetricsSchema,
  OptimizeShipmentRouteRequestSchema,
  OptimizeShipmentRouteResponseSchema,
  OptimizeShipmentRouteResponseSegmentSchema,
  PaginatedPartitionsResponseSchema,
  PartitionTaskResultSchema,
  PartitionTaskSkippedSchema,
  PhotoUploadResponseSchema,
  PollDriverLocationRequestSchema,
  PollDriverLocationResponseSchema,
  PrepareShipmentLegManifestRequestSchema,
  PrepareShipmentLegManifestResponseSchema,
  PrepareShipmentManifestsRequestSchema,
  PrepareShipmentManifestsResponseSchema,
  PublicTrackingResponseSchema,
  QueueListResponseSchema,
  RecipientSchema,
  RecipientSearchQuerySchema,
  ReconcileDriversResponseSchema,
  ReconcileFulfillmentsMetricsSchema,
  ReconcileFulfillmentsRequestSchema,
  ReconcileFulfillmentsResponseSchema,
  ReconcileShipmentLegMetrcRefsRequestSchema,
  ReconcileShipmentLegMetrcRefsResponseSchema,
  ReconcileShipmentLegMetrcRefsScopeSchema,
  RemoveHubSplitRequestSchema,
  RemoveHubSplitResponseSchema,
  ReorderStopsRequestSchema,
  ReorderStopsResponseSchema,
  RouteBoundsSchema,
  RouteOptimizationModeSchema,
  RouteOptimizationParamsSchema,
  RoutePlanSchema,
  RoutePlanSummarySchema,
  RoutePointSchema,
  ShipmentDetailResponseSchema,
  ShipmentLegManifestActionResponseSchema,
  ShipmentLegQueueListResponseSchema,
  ShipmentManifestActionResponseSchema,
  ShipmentQueueSummariesResponseSchema,
  SubmitShipmentLegManifestRequestSchema,
  SubmitShipmentManifestRequestSchema,
  SupplierDeliveryTeamSchema,
  SupplierLocationTeamSchema,
  SupplierLocationTeamWithDetailsSchema,
  SyncDeliveryProofAssetRequestSchema,
  SyncDeliveryProofAssetResponseSchema,
  SyncResponseSchema,
  SyncTeamResultSchema,
  TaskAddressSchema,
  TaskAssignmentResultSchema,
  TaskRouteSchema,
  TeamAutoDispatchRequestSchema,
  TeamAutoDispatchResponseSchema,
  TeamMembersSchema,
  TeamSchema,
  TimelineEntrySchema,
  UpdateDriverRequestSchema,
  UpdateDriverTeamsInputSchema,
  UpdateHubMetadataRequestSchema,
  UpdateHubMetadataResponseSchema,
  UpdateHubRequestSchema,
  UpdatePartitionRequestSchema,
  UpdatePriorityRequestSchema,
  UpdateRecipientRequestSchema,
  UpdateRoutePlanTasksInputSchema,
  UpdateShipmentLegManifestRequestSchema,
  UpdateShipmentLegRequestSchema,
  UpdateShipmentLegResponseSchema,
  UpdateSupplierDeliveryTeamRequestSchema,
  UpdateSupplierDriverInputSchema,
  UpdateSupplierVehicleInputSchema,
  UpdateTaskRequestSchema,
  UpdateTeamRequestSchema,
  UpdateVehicleRequestSchema,
  VEHICLE_TYPES_REQUIRING_MAKE_MODEL,
  VehicleSchema,
  VehicleStatusSchema,
  VehicleTypeSchema,
  VoidShipmentLegManifestRequestSchema,
  adminAuthContract,
  adminDashboardContract,
  adminDestinationsContract,
  adminDriversContract,
  adminHubsContract,
  adminOnfleetWebhooksContract,
  adminOrdersContract,
  adminPartitionsContract,
  adminRecipientsContract,
  adminRouteOptimizationContract,
  adminRoutesContract,
  adminTasksContract,
  adminTeamsContract,
  adminVehiclesContract,
  assignmentQueueContract,
  auxiliaryTasksContract,
  deliveryGatewayContract,
  internalAssignmentQueueContract,
  internalDatabaseFailoverContract,
  internalPartitionTasksContract,
  jobsContract,
  shipmentLegsContract,
  supplierDeliveryTeamContract,
  supplierDriversContract,
  supplierRoutePlansContract,
  supplierRoutesContract,
  supplierVehiclesContract,
  trackingContract,
  vehicleTypeRequiresMakeAndModel,
  webhooksContract
} from "../chunk-HQGWTMOO.js";

// src/http/index.ts
import { initContract as initContract43 } from "@ts-rest/core";

// src/http/analytics.contract.ts
import { initContract } from "@ts-rest/core";
import { z } from "zod";
var c = initContract();
var AnalyticsCaptureEventSchema = z.object({
  event: z.string().min(1),
  distinct_id: z.string().min(1),
  properties: z.record(z.unknown()).optional(),
  timestamp: z.string().optional(),
  $groups: z.record(z.string()).optional()
});
var AnalyticsBatchEventSchema = z.object({
  event: z.string().min(1),
  properties: z.object({
    distinct_id: z.string().min(1)
  }).and(z.record(z.unknown())),
  timestamp: z.string().optional()
});
var AnalyticsBatchRequestSchema = z.object({
  batch: z.array(AnalyticsBatchEventSchema).min(1).max(100),
  historical_migration: z.boolean().optional()
});
var AnalyticsIdentifySchema = z.object({
  distinct_id: z.string().min(1),
  $set: z.record(z.unknown()).optional(),
  $set_once: z.record(z.unknown()).optional()
});
var AnalyticsGroupIdentifySchema = z.object({
  distinct_id: z.string().min(1),
  group_type: z.string().min(1),
  group_key: z.string().min(1),
  properties: z.record(z.unknown()).optional()
});
var AnalyticsSuccessResponseSchema = z.object({
  status: z.literal(1).or(z.literal("ok")).optional()
});
var AnalyticsErrorResponseSchema = z.object({
  message: z.string()
});
var analyticsContract = c.router({
  /**
   * Capture a single analytics event
   * Proxies to PostHog /i/v0/e/
   */
  capture: {
    method: "POST",
    path: "/api/analytics/capture",
    body: AnalyticsCaptureEventSchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Capture a single analytics event"
  },
  /**
   * Capture multiple analytics events in a batch
   * Proxies to PostHog /batch/
   */
  batch: {
    method: "POST",
    path: "/api/analytics/batch",
    body: AnalyticsBatchRequestSchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Capture multiple analytics events in a batch"
  },
  /**
   * Identify a user with properties
   * Proxies to PostHog as $identify event
   */
  identify: {
    method: "POST",
    path: "/api/analytics/identify",
    body: AnalyticsIdentifySchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Identify a user with properties"
  },
  /**
   * Identify a group (company, brand, etc.)
   * Proxies to PostHog as $groupidentify event
   */
  groupIdentify: {
    method: "POST",
    path: "/api/analytics/group",
    body: AnalyticsGroupIdentifySchema,
    responses: {
      200: AnalyticsSuccessResponseSchema,
      400: AnalyticsErrorResponseSchema,
      500: AnalyticsErrorResponseSchema
    },
    summary: "Identify a group with properties"
  }
});

// src/http/brands.contract.ts
import { initContract as initContract2 } from "@ts-rest/core";
import { z as z3 } from "zod";
import { BrandDtoSchema } from "@flote/types/brand";

// src/http/error-response.schema.ts
import { z as z2 } from "zod";
var ErrorResponseSchema = z2.object({
  code: z2.string(),
  message: z2.string(),
  requestId: z2.string()
});

// src/http/brands.contract.ts
var c2 = initContract2();
var brandsContract = c2.router({
  list: {
    method: "GET",
    path: "/api/brands",
    responses: {
      200: z3.array(BrandDtoSchema),
      401: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "List all brands"
  },
  getById: {
    method: "GET",
    path: "/api/brands/:id",
    pathParams: z3.object({ id: z3.string() }),
    responses: {
      200: BrandDtoSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Get brand by ID"
  },
  create: {
    method: "POST",
    path: "/api/brands",
    body: z3.object({
      name: z3.string(),
      shortCode: z3.string().min(2).max(6).regex(/^[A-Z0-9]{2,6}$/),
      logoUrl: z3.string().nullable().optional(),
      description: z3.string().nullable().optional(),
      b2bwaveBrandId: z3.number().nullable().optional()
    }),
    responses: {
      201: BrandDtoSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      409: ErrorResponseSchema,
      422: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Create a new brand"
  },
  update: {
    method: "PUT",
    path: "/api/brands/:id",
    pathParams: z3.object({ id: z3.string() }),
    body: z3.object({
      name: z3.string().optional(),
      logoUrl: z3.string().nullable().optional(),
      description: z3.string().nullable().optional(),
      b2bwaveBrandId: z3.number().nullable().optional()
    }),
    responses: {
      200: BrandDtoSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      409: ErrorResponseSchema,
      422: ErrorResponseSchema,
      500: ErrorResponseSchema,
      501: ErrorResponseSchema
    },
    summary: "Update an existing brand"
  },
  delete: {
    method: "DELETE",
    path: "/api/brands/:id",
    pathParams: z3.object({ id: z3.string() }),
    responses: {
      204: z3.void(),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      409: ErrorResponseSchema,
      500: ErrorResponseSchema,
      501: ErrorResponseSchema
    },
    summary: "Delete a brand by ID"
  }
});

// src/http/b2bwave-brands.contract.ts
import { initContract as initContract3 } from "@ts-rest/core";
import { z as z4 } from "zod";
import { B2BWaveBrandDtoSchema } from "@flote/types/brand";
var c3 = initContract3();
var b2bwaveBrandsContract = c3.router({
  list: {
    method: "GET",
    path: "/api/providers/b2bwave/brands",
    responses: {
      200: z4.array(B2BWaveBrandDtoSchema),
      401: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "List all brands from B2BWave"
  },
  getById: {
    method: "GET",
    path: "/api/providers/b2bwave/brands/:id",
    pathParams: z4.object({ id: z4.string() }),
    responses: {
      200: B2BWaveBrandDtoSchema,
      400: z4.object({ message: z4.string() }),
      401: z4.object({ message: z4.string() }),
      404: z4.object({ message: z4.string() }),
      500: z4.object({ message: z4.string() })
    },
    summary: "Get B2BWave brand by ID"
  }
});

// src/http/auth.contract.ts
import { initContract as initContract4 } from "@ts-rest/core";
import { z as z5 } from "zod";
import { PaymentMethod } from "@flote/types/customer-capabilities";
var c4 = initContract4();
var PaymentMethodSchema = z5.nativeEnum(PaymentMethod);
var AuthCustomerSchema = z5.object({
  id: z5.number(),
  email: z5.string().email(),
  companyName: z5.string(),
  companyNumber: z5.string().nullable().optional(),
  role: z5.string(),
  name: z5.string().nullable().optional(),
  phone: z5.string().nullable().optional(),
  address: z5.string().nullable().optional(),
  city: z5.string().nullable().optional(),
  paymentWays: z5.array(z5.string()).default([]),
  companyActivities: z5.string().nullable().optional(),
  canConfirmOrder: z5.boolean().nullable().optional(),
  disableOrdering: z5.boolean().nullable().optional(),
  hasPortalAccess: z5.boolean().optional(),
  // Organization membership — resolved from member records
  organizationId: z5.string().uuid().nullable().optional(),
  // Customer capabilities - allowed payment methods for checkout
  allowedPaymentMethods: z5.array(PaymentMethodSchema).optional()
});
var SuccessResponse = z5.object({ success: z5.boolean() });
var authContract = c4.router({
  me: {
    method: "GET",
    path: "/api/auth/me",
    responses: {
      200: AuthCustomerSchema,
      401: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Get authenticated customer context"
  },
  verifyEmail: {
    method: "POST",
    path: "/api/auth/verify-email",
    body: z5.object({ email: z5.string().email() }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        companyName: z5.string().optional()
      }),
      400: z5.object({ message: z5.string() }),
      404: z5.object({ message: z5.string() }),
      429: z5.object({ message: z5.string(), retryAfter: z5.number().optional() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Start email verification and send OTP"
  },
  verifyOtp: {
    method: "POST",
    path: "/api/auth/verify-otp",
    body: z5.object({ email: z5.string().email(), otp: z5.string().min(1) }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        jwt: z5.string().optional(),
        refreshToken: z5.string().optional(),
        customer: AuthCustomerSchema.nullable().optional()
      }),
      400: z5.object({ message: z5.string() }),
      401: z5.object({ message: z5.string() }),
      429: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() }),
      503: z5.object({ message: z5.string() })
    },
    summary: "Validate OTP and issue session"
  },
  sendSmsOtp: {
    method: "POST",
    path: "/api/auth/send-sms-otp",
    body: z5.object({
      phoneNumber: z5.string().min(1, "Phone number is required"),
      email: z5.string().email()
    }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        verificationId: z5.string().optional()
      }),
      400: z5.object({ message: z5.string() }),
      404: z5.object({ message: z5.string() }),
      429: z5.object({ message: z5.string(), retryAfter: z5.number().optional() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Start SMS verification and send OTP to phone number"
  },
  verifySmsOtp: {
    method: "POST",
    path: "/api/auth/verify-sms-otp",
    body: z5.object({
      phoneNumber: z5.string().min(1, "Phone number is required"),
      otp: z5.string().min(1, "OTP code is required"),
      email: z5.string().email()
    }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        jwt: z5.string().optional(),
        refreshToken: z5.string().optional(),
        customer: AuthCustomerSchema.nullable().optional()
      }),
      400: z5.object({ message: z5.string() }),
      401: z5.object({ message: z5.string() }),
      429: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() }),
      503: z5.object({ message: z5.string() })
    },
    summary: "Validate SMS OTP and issue session"
  },
  refresh: {
    method: "POST",
    path: "/api/auth/refresh",
    body: z5.object({
      refreshToken: z5.string().optional()
    }),
    responses: {
      200: z5.object({
        success: z5.boolean(),
        message: z5.string().optional(),
        jwt: z5.string().optional(),
        refreshToken: z5.string().optional(),
        customer: AuthCustomerSchema.nullable().optional()
      }),
      401: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Refresh auth token using refresh token or valid access token"
  },
  updateProfile: {
    method: "PATCH",
    path: "/api/auth/me/profile",
    body: z5.object({
      firstName: z5.string().min(1).max(100),
      lastName: z5.string().min(1).max(100)
    }),
    responses: {
      200: z5.object({ success: z5.boolean(), name: z5.string() }),
      401: z5.object({ message: z5.string() }),
      404: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Update authenticated user profile name"
  },
  logout: {
    method: "POST",
    path: "/api/auth/logout",
    body: z5.object({}),
    responses: {
      200: SuccessResponse.extend({ message: z5.string().optional() }),
      401: z5.object({ message: z5.string() }),
      500: z5.object({ message: z5.string() })
    },
    summary: "Clear auth session"
  }
});

// src/http/portal-auth.contract.ts
import { initContract as initContract5 } from "@ts-rest/core";
import { z as z6 } from "zod";
var c5 = initContract5();
var PortalUserRoleSchema = z6.enum([
  "flote_admin",
  "flote_supplier_admin",
  "sales_rep",
  "supplier_admin",
  "supplier_member",
  "supplier"
  // @deprecated
]);
var PortalBrandSchema = z6.object({
  id: z6.string(),
  name: z6.string(),
  logoUrl: z6.string().nullable(),
  description: z6.string().nullable(),
  b2bwaveBrandId: z6.number().nullable()
});
var AccessibleEmbedSchema = z6.object({
  id: z6.number(),
  hostDomain: z6.string(),
  brand: PortalBrandSchema.nullable()
});
var PortalUserSchema = z6.object({
  id: z6.string().uuid(),
  email: z6.string().email(),
  name: z6.string(),
  role: PortalUserRoleSchema,
  supplierId: z6.string().uuid().nullable(),
  memberId: z6.string().uuid().nullable(),
  organizationId: z6.string().uuid().nullable(),
  /** @deprecated Use hasAnyLocalDeliveryBrand + brandFulfillmentMethods instead */
  organizationFulfillmentMethod: z6.enum(["local_delivery", "mail_carrier"]).nullable(),
  hasAnyLocalDeliveryBrand: z6.boolean().nullable().default(null),
  brandFulfillmentMethods: z6.record(z6.string(), z6.enum(["local_delivery", "mail_carrier"])).nullable().default(null),
  b2bwaveSalesRepId: z6.number().nullable(),
  isActive: z6.boolean(),
  createdAt: z6.coerce.date(),
  updatedAt: z6.coerce.date()
});
var SuccessResponse2 = z6.object({ success: z6.boolean() });
var portalAuthContract = c5.router({
  me: {
    method: "GET",
    path: "/api/portal-auth/me",
    responses: {
      200: PortalUserSchema,
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Get authenticated portal user context"
  },
  verifyEmail: {
    method: "POST",
    path: "/api/portal-auth/verify-email",
    body: z6.object({ email: z6.string().email() }),
    responses: {
      200: z6.object({
        success: z6.boolean(),
        message: z6.string().optional(),
        name: z6.string().optional(),
        role: PortalUserRoleSchema.optional()
      }),
      400: z6.object({ message: z6.string() }),
      403: z6.object({ message: z6.string() }),
      404: z6.object({ message: z6.string() }),
      429: z6.object({ message: z6.string(), retryAfter: z6.number().optional() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Verify email is a portal user and send OTP"
  },
  verifyOtp: {
    method: "POST",
    path: "/api/portal-auth/verify-otp",
    body: z6.object({
      email: z6.string().email(),
      otp: z6.string().min(1)
    }),
    responses: {
      200: z6.object({
        success: z6.boolean(),
        message: z6.string().optional(),
        jwt: z6.string().optional(),
        refreshToken: z6.string().optional(),
        portalUser: PortalUserSchema.nullable().optional()
      }),
      400: z6.object({ message: z6.string() }),
      401: z6.object({ message: z6.string() }),
      403: z6.object({ message: z6.string() }),
      429: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Validate OTP and issue portal session"
  },
  refresh: {
    method: "POST",
    path: "/api/portal-auth/refresh",
    body: z6.object({
      refreshToken: z6.string().optional()
    }),
    responses: {
      200: z6.object({
        success: z6.boolean(),
        message: z6.string().optional(),
        jwt: z6.string().optional(),
        refreshToken: z6.string().optional(),
        portalUser: PortalUserSchema.nullable().optional()
      }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Refresh portal auth token"
  },
  logout: {
    method: "POST",
    path: "/api/portal-auth/logout",
    body: z6.object({}),
    responses: {
      200: SuccessResponse2.extend({ message: z6.string().optional() }),
      401: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Clear portal auth session"
  },
  accessibleEmbeds: {
    method: "GET",
    path: "/api/portal-auth/accessible-embeds",
    responses: {
      200: z6.array(AccessibleEmbedSchema),
      401: z6.object({ message: z6.string() }),
      403: z6.object({ message: z6.string() }),
      500: z6.object({ message: z6.string() })
    },
    summary: "Get embed configs accessible by the authenticated portal user"
  }
});

// src/http/products.contract.ts
import { initContract as initContract6 } from "@ts-rest/core";
import { z as z7 } from "zod";
var c6 = initContract6();
var B2BWaveProductCustomerPriceDtoSchema = z7.object({
  id: z7.number(),
  productId: z7.number(),
  customerId: z7.number(),
  applyExtraDiscounts: z7.boolean(),
  price: z7.string(),
  createdAt: z7.string(),
  updatedAt: z7.string()
});
var B2BWaveProductPriceDtoSchema = z7.object({
  id: z7.number(),
  productId: z7.number(),
  pricelistId: z7.number(),
  price: z7.string(),
  createdAt: z7.string(),
  updatedAt: z7.string()
});
var B2BWaveProductFileDtoSchema = z7.object({
  id: z7.number(),
  productId: z7.number(),
  filename: z7.string(),
  title: z7.string(),
  url: z7.string(),
  createdAt: z7.string(),
  updatedAt: z7.string()
});
var B2BWaveProductVariantOptionSchema = z7.object({
  option: z7.string(),
  value: z7.string()
});
var B2BWaveProductVariantSchema = z7.object({
  code: z7.string(),
  optionValues: z7.array(B2BWaveProductVariantOptionSchema)
});
var B2BWaveWarehouseQuantitySchema = z7.object({
  warehouseId: z7.number(),
  warehouseCode: z7.string(),
  quantity: z7.string()
});
var B2BWaveProductDtoSchema = z7.object({
  id: z7.number(),
  name: z7.string(),
  brandId: z7.number().nullable(),
  description: z7.string(),
  partNumber: z7.string(),
  isActive: z7.boolean(),
  statusId: z7.number().nullable(),
  categoryId: z7.number(),
  canBackorder: z7.boolean().nullable(),
  quantity: z7.number().nullable().optional(),
  // Deprecated: Use quantities array instead
  promoteCategory: z7.boolean(),
  promoteFront: z7.boolean(),
  price1: z7.number().nullable(),
  price2: z7.number().nullable(),
  price3: z7.number().nullable(),
  createdAt: z7.string(),
  updatedAt: z7.string(),
  imageFileName: z7.string().nullable(),
  imageContentType: z7.string().nullable(),
  imageFileSize: z7.number().nullable(),
  imageUpdatedAt: z7.string().nullable(),
  oldId: z7.number().nullable(),
  minimumQuantity: z7.string(),
  vatClassId: z7.number(),
  metaDescription: z7.string().nullable(),
  measurementUnitId: z7.number().nullable(),
  packageQuantity: z7.number().nullable(),
  hasVariants: z7.boolean(),
  codeUpc: z7.string(),
  importImageUrl: z7.string().nullable(),
  importImageUrlUpdatedAt: z7.string().nullable(),
  importUuid: z7.string().nullable(),
  manufacturerId: z7.number().nullable(),
  priceMsrp: z7.number().nullable(),
  tagLine: z7.string().nullable(),
  code: z7.string(),
  imageUrl: z7.string(),
  galleryImageUrls: z7.array(z7.string()),
  categoryPath: z7.string(),
  productVariants: z7.array(B2BWaveProductVariantSchema),
  quantities: z7.array(B2BWaveWarehouseQuantitySchema).optional(),
  customerPrice: B2BWaveProductCustomerPriceDtoSchema.optional()
});
var BuyerPriceMatchSchema = z7.object({
  amount: z7.string(),
  priceId: z7.string().uuid(),
  scope: z7.enum(["org", "customer"])
});
var BuyerPriceTierSchema = BuyerPriceMatchSchema.extend({
  fromQuantity: z7.number().int().positive(),
  maxQuantity: z7.number().int().positive().nullable()
});
var B2BWaveProductDiscountDtoSchema = z7.object({
  id: z7.number(),
  productId: z7.number(),
  pricelistId: z7.number(),
  fromQuantity: z7.number(),
  price: z7.string(),
  hasCustomPrice: z7.boolean(),
  percentage: z7.number(),
  dateFrom: z7.string().nullable(),
  dateTo: z7.string().nullable(),
  createdAt: z7.string(),
  updatedAt: z7.string()
});
var EnrichedB2BWaveProductSchema = B2BWaveProductDtoSchema.extend({
  pricing: B2BWaveProductPriceDtoSchema.optional(),
  buyerPrice: BuyerPriceMatchSchema.optional(),
  buyerPriceTiers: z7.array(BuyerPriceTierSchema).optional(),
  discountTiers: z7.array(B2BWaveProductDiscountDtoSchema).optional(),
  effectivePrice: z7.number().optional(),
  appliedPriceId: z7.string().uuid().nullable().optional(),
  unitsPerCase: z7.number().int().positive().nullable().optional()
});
var GetB2BWaveProductsInputDtoSchema = z7.object({
  codeEq: z7.string().optional(),
  idEq: z7.coerce.number().optional(),
  nameEq: z7.string().optional(),
  statusIdEq: z7.coerce.number().optional(),
  categoryIdEq: z7.coerce.number().optional(),
  brandIdEq: z7.coerce.number().optional(),
  isActiveEq: z7.preprocess(
    (val) => val === "true" || val === true,
    z7.boolean()
  ).optional(),
  codeCont: z7.string().optional(),
  nameCont: z7.string().optional(),
  descriptionCont: z7.string().optional(),
  // The provider expects paginated=1; coerce string "1" to number, then validate literal
  paginated: z7.coerce.number().pipe(z7.literal(1)).optional(),
  perPage: z7.coerce.number().optional(),
  page: z7.coerce.number().optional()
});
var GetB2BWaveProductCustomerPricesInputDtoSchema = z7.object({
  productIdEq: z7.coerce.number().optional(),
  customerIdEq: z7.coerce.number().optional()
});
var CreateProductBody = z7.object({
  name: z7.string(),
  imageUrl: z7.string(),
  categoryId: z7.string().nullable(),
  brandId: z7.string(),
  price: z7.number(),
  description: z7.string(),
  thcContent: z7.string().nullable(),
  weight: z7.string().nullable(),
  packageQuantity: z7.number(),
  inventory: z7.number(),
  featured: z7.boolean(),
  backordered: z7.boolean(),
  type: z7.string()
});
var productsContract = c6.router({
  // B2BWave backed product endpoints
  b2bwaveList: {
    method: "GET",
    path: "/api/b2bwave/products",
    query: GetB2BWaveProductsInputDtoSchema.optional(),
    responses: {
      200: z7.array(B2BWaveProductDtoSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "List B2BWave products"
  },
  b2bwaveListWithPricing: {
    method: "GET",
    path: "/api/b2bwave/products-with-pricing",
    query: GetB2BWaveProductsInputDtoSchema.optional(),
    responses: {
      200: z7.array(EnrichedB2BWaveProductSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "List all B2BWave products with pricing (includes customer pricing when authenticated)"
  },
  b2bwaveByBrand: {
    method: "GET",
    path: "/api/b2bwave/brands/:brandId/products",
    pathParams: z7.object({ brandId: z7.string() }),
    responses: {
      200: z7.array(B2BWaveProductDtoSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      404: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "List B2BWave products by brand ID"
  },
  byBrandIds: {
    method: "GET",
    path: "/api/products/by-brand-ids",
    query: z7.object({
      brandIds: z7.string().transform((s) => s.split(",").filter(Boolean)).pipe(z7.array(z7.string().uuid()).min(1).max(20)),
      customerId: z7.coerce.number().optional()
    }),
    responses: {
      200: z7.array(EnrichedB2BWaveProductSchema),
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      422: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Aggregate products across N native brand UUIDs (multi-brand embeds)"
  },
  b2bwaveByBrandWithPricing: {
    method: "GET",
    path: "/api/b2bwave/brands/:brandId/products-with-pricing",
    pathParams: z7.object({ brandId: z7.string() }),
    responses: {
      200: z7.array(EnrichedB2BWaveProductSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      404: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "List B2BWave products by brand ID, including pricing/customer pricing where applicable"
  },
  b2bwaveCustomerPricingForProducts: {
    method: "GET",
    path: "/api/b2bwave/customer-pricing/products",
    query: z7.object({
      productIds: z7.array(z7.coerce.number()),
      customerId: z7.coerce.number()
    }),
    responses: {
      200: z7.array(B2BWaveProductCustomerPriceDtoSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      404: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "Get customer pricing for multiple products"
  },
  b2bwaveCustomerPricingByCustomerId: {
    method: "GET",
    path: "/api/b2bwave/customer-pricing/customer/:customerId",
    pathParams: z7.object({ customerId: z7.coerce.number() }),
    responses: {
      200: z7.array(B2BWaveProductCustomerPriceDtoSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      404: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "Get all customer pricing entries for a customer"
  },
  b2bwaveCustomerPricingForProduct: {
    method: "GET",
    path: "/api/b2bwave/customer-pricing/product",
    query: GetB2BWaveProductCustomerPricesInputDtoSchema,
    responses: {
      200: B2BWaveProductCustomerPriceDtoSchema.nullable(),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "Get customer pricing for a specific product/customer pair"
  },
  b2bwaveInvalidateProductsCache: {
    method: "POST",
    body: z7.object({}),
    path: "/api/b2bwave/products/cache/invalidate",
    responses: {
      200: z7.object({ success: z7.boolean() }),
      401: z7.object({ message: z7.string() }),
      403: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() })
    },
    summary: "Invalidate B2BWave products cache"
  },
  b2bwaveListPaginated: {
    method: "GET",
    path: "/api/b2bwave/products-paginated",
    query: z7.object({
      limit: z7.coerce.number().min(1).max(100).default(24),
      cursor: z7.string().optional(),
      brandIdEq: z7.coerce.number().optional(),
      categoryIdEq: z7.coerce.number().optional(),
      nameCont: z7.string().optional()
    }),
    responses: {
      200: z7.object({
        products: z7.array(EnrichedB2BWaveProductSchema),
        nextCursor: z7.string().nullable(),
        hasMore: z7.boolean()
      }),
      401: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "List B2BWave products with cursor-based pagination (filters samples and inactive brands)"
  },
  b2bwaveListByIds: {
    method: "GET",
    path: "/api/b2bwave/products-by-ids",
    query: z7.object({
      ids: z7.string().transform((val) => val.split(",").map(Number))
    }),
    responses: {
      200: z7.array(EnrichedB2BWaveProductSchema),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "Get B2BWave products by IDs (for cart sync)"
  },
  b2bwaveBulkUpsertCustomerPricing: {
    method: "POST",
    path: "/api/b2bwave/customer-pricing/bulk-upsert",
    body: z7.object({
      productIds: z7.array(z7.number()),
      customerIds: z7.array(z7.number()),
      price: z7.number()
    }),
    responses: {
      200: z7.object({
        created: z7.number(),
        updated: z7.number(),
        failed: z7.number(),
        errors: z7.array(z7.object({
          productId: z7.number(),
          customerId: z7.number(),
          error: z7.string()
        }))
      }),
      400: z7.object({ message: z7.string() }),
      401: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "Bulk create or update customer pricing for multiple product/customer combinations"
  },
  b2bwaveProductFiles: {
    method: "GET",
    path: "/api/b2bwave/products/:productId/files",
    pathParams: z7.object({ productId: z7.coerce.number() }),
    responses: {
      200: z7.array(B2BWaveProductFileDtoSchema),
      400: z7.object({ message: z7.string() }),
      404: z7.object({ message: z7.string() }),
      500: z7.object({ message: z7.string() }),
      502: z7.object({ message: z7.string() })
    },
    summary: "Get files/documents associated with a product (COAs, labels, etc.)"
  }
});

// src/http/product-sync.contract.ts
import { initContract as initContract7 } from "@ts-rest/core";
import { z as z8 } from "zod";
var c7 = initContract7();
var SyncErrorSchema = z8.object({
  entityType: z8.string(),
  externalId: z8.string(),
  message: z8.string()
});
var DryRunActionSchema = z8.object({
  type: z8.enum(["create", "update", "skip", "delete"]),
  entityType: z8.enum([
    "product",
    "brand",
    "category",
    "variant",
    "image",
    "file",
    "stock_location",
    "brand_stock_location",
    "inventory_adjustment",
    "price"
  ]),
  externalId: z8.string(),
  name: z8.string().optional(),
  reason: z8.string().optional(),
  details: z8.record(z8.unknown()).optional()
});
var SyncResultSchema = z8.object({
  success: z8.boolean(),
  created: z8.number(),
  updated: z8.number(),
  skipped: z8.number(),
  failed: z8.number(),
  errors: z8.array(SyncErrorSchema),
  duration: z8.number(),
  dryRun: z8.boolean().optional(),
  dryRunActions: z8.array(DryRunActionSchema).optional()
});
var OrchestrateSyncResultSchema = z8.object({
  success: z8.boolean(),
  brands: SyncResultSchema,
  categories: SyncResultSchema,
  products: SyncResultSchema,
  inventoryLevels: SyncResultSchema.optional(),
  basePricing: SyncResultSchema.optional(),
  bulkDiscounts: SyncResultSchema.optional(),
  totalDuration: z8.number(),
  dryRun: z8.boolean()
});
var productSyncContract = c7.router({
  syncAll: {
    method: "POST",
    path: "/api/admin/product-sync",
    body: z8.object({}).optional(),
    responses: {
      200: SyncResultSchema,
      401: z8.object({ message: z8.string() }),
      403: z8.object({ message: z8.string() }),
      500: z8.object({ message: z8.string() })
    },
    summary: "Sync all products from B2BWave to local database"
  },
  syncOne: {
    method: "POST",
    path: "/api/admin/product-sync/:b2bwaveProductId",
    pathParams: z8.object({ b2bwaveProductId: z8.string() }),
    body: z8.object({}).optional(),
    responses: {
      200: SyncResultSchema,
      400: z8.object({ message: z8.string() }),
      401: z8.object({ message: z8.string() }),
      403: z8.object({ message: z8.string() }),
      404: z8.object({ message: z8.string() }),
      500: z8.object({ message: z8.string() })
    },
    summary: "Sync a single product by B2BWave ID"
  },
  syncInventory: {
    method: "POST",
    path: "/api/admin/product-sync/inventory",
    body: z8.object({}).optional(),
    responses: {
      200: SyncResultSchema,
      401: z8.object({ message: z8.string() }),
      403: z8.object({ message: z8.string() }),
      500: z8.object({ message: z8.string() })
    },
    summary: "Sync inventory levels from B2BWave to local database"
  },
  orchestrate: {
    method: "POST",
    path: "/api/admin/product-sync/orchestrate",
    body: z8.object({
      dryRun: z8.boolean().optional().default(false)
    }),
    responses: {
      200: OrchestrateSyncResultSchema,
      401: z8.object({ message: z8.string() }),
      403: z8.object({ message: z8.string() }),
      500: z8.object({ message: z8.string() })
    },
    summary: "Orchestrate full catalog sync (brands, categories, products)"
  }
});

// src/http/categories.contract.ts
import { initContract as initContract8 } from "@ts-rest/core";
import { z as z9 } from "zod";
import { CategoryDtoSchema } from "@flote/types/category";
import { ProductRealmSchema } from "@flote/types/product";
var c8 = initContract8();
var CreateCategoryBody = z9.object({
  name: z9.string(),
  description: z9.string().nullable().optional(),
  parentId: z9.string().nullable().optional()
});
var B2BWaveCategoryDtoSchema = z9.object({
  id: z9.number(),
  name: z9.string(),
  description: z9.string().optional(),
  metaDescription: z9.string().optional(),
  parentId: z9.number().nullable().optional(),
  isActive: z9.boolean(),
  discount: z9.number().nullable().optional(),
  sort: z9.number().nullable().optional(),
  isPrivate: z9.boolean().optional(),
  subcategoriesPrivate: z9.boolean().optional(),
  categoryPath: z9.string().optional(),
  depth: z9.number().optional(),
  lft: z9.number().optional(),
  rgt: z9.number().optional(),
  createdAt: z9.string().optional(),
  updatedAt: z9.string().optional()
});
var GetB2BWaveCategoriesInputDtoSchema = z9.object({
  nameEq: z9.string().optional(),
  nameCont: z9.string().optional(),
  isActiveEq: z9.preprocess(
    (val) => val === "true" || val === true,
    z9.boolean()
  ).optional(),
  parentIdEq: z9.coerce.number().nullable().optional(),
  paginated: z9.coerce.number().pipe(z9.literal(1)).optional(),
  perPage: z9.coerce.number().optional(),
  page: z9.coerce.number().optional()
});
var categoriesContract = c8.router({
  // Internal DB-backed endpoints
  list: {
    method: "GET",
    path: "/api/categories",
    query: z9.object({
      realm: ProductRealmSchema.optional()
    }).optional(),
    responses: {
      200: z9.array(CategoryDtoSchema)
    },
    summary: "List categories, optionally filtered by realm"
  },
  getById: {
    method: "GET",
    path: "/api/categories/:id",
    pathParams: z9.object({ id: z9.string() }),
    responses: {
      200: CategoryDtoSchema,
      404: z9.object({ message: z9.string() })
    },
    summary: "Get category by ID"
  },
  create: {
    method: "POST",
    path: "/api/categories",
    body: CreateCategoryBody,
    responses: {
      201: CategoryDtoSchema,
      400: z9.object({ message: z9.string() })
    },
    summary: "Create a new category"
  },
  // B2BWave-backed category endpoints
  b2bwaveList: {
    method: "GET",
    path: "/api/b2bwave/categories",
    query: GetB2BWaveCategoriesInputDtoSchema.optional(),
    responses: {
      200: z9.array(B2BWaveCategoryDtoSchema),
      400: z9.object({ message: z9.string() }),
      500: z9.object({ message: z9.string() }),
      502: z9.object({ message: z9.string() })
    },
    summary: "List B2BWave categories"
  },
  b2bwaveGetById: {
    method: "GET",
    path: "/api/b2bwave/categories/:id",
    pathParams: z9.object({ id: z9.string() }),
    responses: {
      200: B2BWaveCategoryDtoSchema,
      400: z9.object({ message: z9.string() }),
      404: z9.object({ message: z9.string() }),
      500: z9.object({ message: z9.string() }),
      502: z9.object({ message: z9.string() })
    },
    summary: "Get B2BWave category by ID"
  }
});

// src/http/customers.contract.ts
import { initContract as initContract9 } from "@ts-rest/core";
import { z as z10 } from "zod";
import { B2BWaveCustomerDtoSchema, CreateCustomerDtoSchema } from "@flote/types/customer";
var c9 = initContract9();
var GetB2BWaveCustomersInputDtoSchema = z10.object({
  idEq: z10.coerce.number().optional(),
  emailEq: z10.string().email().optional(),
  companyNameEq: z10.string().optional(),
  nameEq: z10.string().optional(),
  pricelistIdEq: z10.number().optional(),
  emailCont: z10.string().optional(),
  companyNameCont: z10.string().optional(),
  nameCont: z10.string().optional()
});
var customersContract = c9.router({
  list: {
    method: "GET",
    path: "/api/b2bwave/customers",
    query: GetB2BWaveCustomersInputDtoSchema.optional(),
    responses: {
      200: z10.array(B2BWaveCustomerDtoSchema),
      400: z10.object({ message: z10.string() }),
      401: z10.object({ message: z10.string() }),
      500: z10.object({ message: z10.string() })
    },
    summary: "List B2BWave customers"
  },
  getByEmail: {
    method: "GET",
    path: "/api/b2bwave/customers/by-email",
    query: z10.object({ email: z10.string().email() }),
    responses: {
      200: B2BWaveCustomerDtoSchema,
      400: z10.object({ message: z10.string() }),
      401: z10.object({ message: z10.string() }),
      404: z10.object({ message: z10.string() }),
      500: z10.object({ message: z10.string() })
    },
    summary: "Get B2BWave customer by email"
  },
  create: {
    method: "POST",
    path: "/api/b2bwave/customers",
    body: CreateCustomerDtoSchema,
    responses: {
      201: B2BWaveCustomerDtoSchema,
      400: z10.object({ message: z10.string() }),
      401: z10.object({ message: z10.string() }),
      409: z10.object({ message: z10.string() }),
      422: z10.object({ message: z10.string() }),
      500: z10.object({ message: z10.string() })
    },
    summary: "Create B2BWave customer"
  },
  getByIds: {
    method: "GET",
    path: "/api/b2bwave/customers/by-ids",
    query: z10.object({ ids: z10.string() }),
    // Comma-separated list of IDs
    responses: {
      200: z10.array(B2BWaveCustomerDtoSchema),
      400: z10.object({ message: z10.string() }),
      401: z10.object({ message: z10.string() }),
      500: z10.object({ message: z10.string() })
    },
    summary: "Get B2BWave customers by IDs"
  }
});

// src/http/addresses.contract.ts
import { initContract as initContract10 } from "@ts-rest/core";
import { z as z11 } from "zod";
import { B2BWaveAddressDtoSchema, CreateB2BWaveAddressDtoSchema } from "@flote/types/address";
var c10 = initContract10();
var addressesContract = c10.router({
  listByCustomerId: {
    method: "GET",
    path: "/api/b2bwave/customers/:customerId/addresses",
    pathParams: z11.object({ customerId: z11.coerce.number() }),
    responses: {
      200: z11.array(B2BWaveAddressDtoSchema),
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      404: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() })
    },
    summary: "List B2BWave addresses by customer ID"
  },
  create: {
    method: "POST",
    path: "/api/b2bwave/addresses",
    body: CreateB2BWaveAddressDtoSchema,
    responses: {
      201: B2BWaveAddressDtoSchema,
      400: z11.object({ message: z11.string() }),
      401: z11.object({ message: z11.string() }),
      409: z11.object({ message: z11.string() }),
      422: z11.object({ message: z11.string() }),
      500: z11.object({ message: z11.string() })
    },
    summary: "Create B2BWave address"
  }
});

// src/http/orders.contract.ts
import { initContract as initContract11 } from "@ts-rest/core";
import { z as z12 } from "zod";
import {
  B2BWaveOrderWithProductsDtoSchema,
  B2BWaveOrderResponseDtoSchema,
  CreateB2BWaveOrderDtoSchema,
  GetB2BWaveOrdersQueryDtoSchema,
  GetB2BWaveOrderDocumentsDTOResponseSchema
} from "@flote/types/orders";
var c11 = initContract11();
var ordersContract = c11.router({
  list: {
    method: "GET",
    path: "/api/b2bwave/orders",
    query: GetB2BWaveOrdersQueryDtoSchema.optional(),
    responses: {
      200: z12.array(B2BWaveOrderWithProductsDtoSchema),
      400: z12.object({ message: z12.string() }),
      401: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() })
    },
    summary: "List B2BWave orders with their line items"
  },
  getById: {
    method: "GET",
    path: "/api/b2bwave/orders/:id",
    pathParams: z12.object({ id: z12.coerce.number() }),
    responses: {
      200: B2BWaveOrderWithProductsDtoSchema,
      400: z12.object({ message: z12.string() }),
      401: z12.object({ message: z12.string() }),
      403: z12.object({ message: z12.string() }),
      404: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() })
    },
    summary: "Get B2BWave order by ID with line items"
  },
  getDocuments: {
    method: "GET",
    path: "/api/b2bwave/orders/:id/documents",
    pathParams: z12.object({ id: z12.coerce.number() }),
    responses: {
      200: GetB2BWaveOrderDocumentsDTOResponseSchema,
      400: z12.object({ message: z12.string() }),
      401: z12.object({ message: z12.string() }),
      403: z12.object({ message: z12.string() }),
      404: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() })
    },
    summary: "Get B2BWave order documents by order ID"
  },
  create: {
    method: "POST",
    path: "/api/b2bwave/orders",
    body: CreateB2BWaveOrderDtoSchema,
    responses: {
      201: B2BWaveOrderResponseDtoSchema,
      400: z12.object({ message: z12.string() }),
      401: z12.object({ message: z12.string() }),
      409: z12.object({ message: z12.string() }),
      422: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() }),
      503: z12.object({ message: z12.string() })
    },
    summary: "Create B2BWave order"
  },
  updateStatus: {
    method: "PATCH",
    path: "/api/b2bwave/orders/:id/status",
    pathParams: z12.object({ id: z12.coerce.number() }),
    body: z12.object({
      statusOrderId: z12.number()
    }),
    responses: {
      200: B2BWaveOrderResponseDtoSchema,
      400: z12.object({ message: z12.string() }),
      401: z12.object({ message: z12.string() }),
      404: z12.object({ message: z12.string() }),
      500: z12.object({ message: z12.string() }),
      503: z12.object({ message: z12.string() })
    },
    summary: "Update B2BWave order status"
  }
});

// src/http/embed-config.contract.ts
import { initContract as initContract12 } from "@ts-rest/core";
import { z as z13 } from "zod";
import { BrandDtoSchema as BrandDtoSchema2 } from "@flote/types/brand";
import { ProductRealmSchema as ProductRealmSchema2 } from "@flote/types/product";
var c12 = initContract12();
var EmbedBrandingSchema = z13.object({
  primaryColor: z13.string().optional(),
  secondaryColor: z13.string().optional(),
  primaryTextColor: z13.string().optional(),
  secondaryTextColor: z13.string().optional()
});
var EmbedConfigResponseSchema = z13.object({
  brands: BrandDtoSchema2.array().min(1),
  displayName: z13.string().optional(),
  branding: EmbedBrandingSchema.optional(),
  settings: z13.record(z13.unknown()),
  realm: ProductRealmSchema2
});
var embedConfigContract = c12.router({
  getByDomain: {
    method: "GET",
    path: "/api/embed-config",
    query: z13.object({ domain: z13.string() }),
    responses: {
      200: EmbedConfigResponseSchema.nullable(),
      400: z13.object({ message: z13.string() }),
      500: z13.object({ message: z13.string() })
    },
    summary: "Get embed config by domain"
  },
  invalidateCache: {
    method: "POST",
    path: "/api/embed-config/cache/invalidate",
    body: z13.object({ domain: z13.string() }),
    responses: {
      200: z13.object({ success: z13.boolean() }),
      400: z13.object({ message: z13.string() }),
      401: z13.object({ message: z13.string() }),
      403: z13.object({ message: z13.string() }),
      404: z13.object({ message: z13.string() }),
      500: z13.object({ message: z13.string() })
    },
    summary: "Invalidate embed config cache for domain"
  }
});

// src/http/email.contract.ts
import { initContract as initContract13 } from "@ts-rest/core";
import { z as z14 } from "zod";
var c13 = initContract13();
var ResendCreateEmailResponseSchema = z14.object({
  data: z14.object({ id: z14.string() }).nullable(),
  error: z14.object({ message: z14.string(), name: z14.string() }).nullable()
});
var MemberSchema = z14.object({
  name: z14.string(),
  email: z14.string().email()
});
var FileAttachmentSchema = z14.object({
  filename: z14.string(),
  content: z14.string(),
  contentType: z14.string(),
  size: z14.number()
});
var CreditApplicationSchema = z14.object({
  members: z14.array(MemberSchema),
  einNumber: z14.string(),
  operatingAgreementFile: FileAttachmentSchema,
  articlesOfIncorporationFile: FileAttachmentSchema,
  additionalNotes: z14.string().optional()
});
var emailContract = c13.router({
  sendEmail: {
    method: "POST",
    path: "/api/email/send",
    body: z14.object({
      to: z14.string().email(),
      subject: z14.string(),
      body: z14.string(),
      from: z14.string().email().optional()
    }),
    responses: {
      200: ResendCreateEmailResponseSchema,
      400: z14.object({ message: z14.string() }),
      401: z14.object({ message: z14.string() }),
      422: z14.object({ message: z14.string() }),
      500: z14.object({ message: z14.string() }),
      503: z14.object({ message: z14.string() })
    },
    summary: "Send a general email"
  },
  sendCreditApplicationEmail: {
    method: "POST",
    path: "/api/email/send-credit-application",
    body: z14.object({
      to: z14.string().email().optional(),
      from: z14.string().email().optional(),
      subject: z14.string().optional(),
      body: z14.string().optional(),
      creditApplication: CreditApplicationSchema
    }),
    responses: {
      200: ResendCreateEmailResponseSchema,
      400: z14.object({ message: z14.string() }),
      401: z14.object({ message: z14.string() }),
      413: z14.object({ message: z14.string() }),
      422: z14.object({ message: z14.string() }),
      500: z14.object({ message: z14.string() }),
      503: z14.object({ message: z14.string() })
    },
    summary: "Send a credit application email with attachments"
  }
});

// src/http/signnow.contract.ts
import { initContract as initContract14 } from "@ts-rest/core";
import { z as z15 } from "zod";
var c14 = initContract14();
var SignNowThumbnailSchema = z15.object({
  small: z15.string(),
  medium: z15.string(),
  large: z15.string()
});
var SignNowTemplateSchema = z15.object({
  id: z15.string(),
  name: z15.string(),
  thumbnail: SignNowThumbnailSchema,
  roles: z15.array(z15.string())
});
var SignNowDocumentGroupTemplateSchema = z15.object({
  id: z15.string(),
  name: z15.string(),
  ownerEmail: z15.string(),
  templates: z15.array(SignNowTemplateSchema),
  isPrepared: z15.boolean(),
  lastUpdated: z15.string()
});
var SignNowDocumentGroupTemplatesResponseSchema = z15.object({
  documentGroupTemplates: z15.array(SignNowDocumentGroupTemplateSchema),
  documentGroupTemplateTotalCount: z15.number()
});
var SignNowEmbeddedInviteLinkSchema = z15.object({ link: z15.string() });
var SignNowSigningLinkSchema = z15.object({ url: z15.string(), urlNoSignup: z15.string() });
var signnowContract = c14.router({
  getTemplates: {
    method: "GET",
    path: "/api/signnow/templates",
    responses: {
      200: SignNowDocumentGroupTemplatesResponseSchema
    },
    summary: "Get SignNow document group templates overview"
  },
  createEmbeddedInviteLink: {
    method: "POST",
    path: "/api/signnow/embedded-invite-link",
    body: z15.object({ email: z15.string().email() }),
    responses: {
      200: SignNowEmbeddedInviteLinkSchema,
      400: z15.object({ message: z15.string() })
    },
    summary: "Create an embedded invite link for a signer"
  },
  createSigningLink: {
    method: "POST",
    path: "/api/signnow/signing-link",
    body: z15.object({ documentId: z15.string() }),
    responses: {
      200: SignNowSigningLinkSchema,
      400: z15.object({ message: z15.string() })
    },
    summary: "Create a signing link for a document"
  }
});

// src/http/telnyx.contract.ts
import { initContract as initContract15 } from "@ts-rest/core";
import { z as z16 } from "zod";
var c15 = initContract15();
var TelnyxErrorSchema = z16.object({
  success: z16.literal(false),
  error: z16.object({
    code: z16.string(),
    message: z16.string(),
    help: z16.string().optional()
  })
});
var SendVerificationRequestSchema = z16.object({
  phoneNumber: z16.string().min(1, "Phone number is required"),
  customCode: z16.string().optional(),
  timeoutSecs: z16.number().positive().optional()
});
var SendVerificationResponseSchema = z16.object({
  id: z16.string(),
  phoneNumber: z16.string(),
  method: z16.enum(["sms", "call"]),
  expiresAt: z16.string().datetime(),
  status: z16.string()
});
var VerifyCodeRequestSchema = z16.object({
  phoneNumber: z16.string().min(1, "Phone number is required"),
  code: z16.string().min(1, "Verification code is required"),
  status: z16.enum(["accepted", "rejected"]).optional()
});
var VerifyCodeResponseSchema = z16.object({
  phoneNumber: z16.string(),
  verified: z16.boolean(),
  responseCode: z16.enum(["accepted", "rejected", "expired"]),
  verifiedAt: z16.string().datetime().optional()
});
var telnyxContract = c15.router({
  /**
   * Send verification code
   *
   * Initiates OTP verification flow by sending a code to the specified phone number.
   */
  sendVerification: {
    method: "POST",
    path: "/api/telnyx/verify/send",
    body: SendVerificationRequestSchema,
    responses: {
      200: SendVerificationResponseSchema,
      400: TelnyxErrorSchema,
      500: TelnyxErrorSchema
    },
    summary: "Send OTP verification code to a phone number"
  },
  /**
   * Verify OTP code
   *
   * Verifies the OTP code entered by the user against the verification ID.
   */
  verifyCode: {
    method: "POST",
    path: "/api/telnyx/verify/:verificationId/verify",
    pathParams: z16.object({
      verificationId: z16.string().min(1, "Verification ID is required")
    }),
    body: VerifyCodeRequestSchema,
    responses: {
      200: VerifyCodeResponseSchema,
      400: TelnyxErrorSchema,
      404: TelnyxErrorSchema,
      500: TelnyxErrorSchema
    },
    summary: "Verify OTP code for a verification session"
  }
});

// src/http/transactions.contract.ts
import { initContract as initContract16 } from "@ts-rest/core";
import { z as z17 } from "zod";
import {
  CreateTransactionRequestSchema,
  FloteTransactionSchema,
  TransactionValidationResultSchema,
  RefundTransactionRequestSchema,
  TransactionStatus
} from "@flote/types/transaction";
import {
  TransactionVerificationResultSchema,
  VerificationResultStatus
} from "@flote/types/scheduled-transaction";
var c16 = initContract16();
var transactionsContract = c16.router({
  createTransaction: {
    method: "POST",
    path: "/api/transactions",
    body: CreateTransactionRequestSchema,
    responses: {
      201: FloteTransactionSchema,
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      422: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Create transaction"
  },
  validateTransaction: {
    method: "POST",
    path: "/api/transactions/validate",
    body: CreateTransactionRequestSchema,
    responses: {
      200: TransactionValidationResultSchema,
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Validate transaction request"
  },
  getTransactionById: {
    method: "GET",
    path: "/api/transactions/:id",
    pathParams: z17.object({
      id: z17.string().uuid()
    }),
    responses: {
      200: FloteTransactionSchema,
      401: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Get transaction by ID"
  },
  getTransactionsByOrderId: {
    method: "GET",
    path: "/api/transactions/order/:orderId",
    pathParams: z17.object({
      orderId: z17.string().min(1)
    }),
    responses: {
      200: z17.array(FloteTransactionSchema),
      401: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Get transactions by order ID"
  },
  updateTransactionStatus: {
    method: "PATCH",
    path: "/api/transactions/:id/status",
    pathParams: z17.object({
      id: z17.string().uuid()
    }),
    body: z17.object({
      status: z17.nativeEnum(TransactionStatus),
      providerMetadata: z17.record(z17.unknown()).optional()
    }),
    responses: {
      204: z17.void(),
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Update transaction status"
  },
  cancelTransaction: {
    method: "POST",
    path: "/api/transactions/:id/cancel",
    pathParams: z17.object({
      id: z17.string().uuid()
    }),
    body: z17.object({
      reason: z17.string().optional()
    }),
    responses: {
      200: FloteTransactionSchema,
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Cancel transaction"
  },
  refundTransaction: {
    method: "POST",
    path: "/api/transactions/:id/refund",
    pathParams: z17.object({
      id: z17.string().uuid()
    }),
    body: RefundTransactionRequestSchema,
    responses: {
      200: FloteTransactionSchema,
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Refund transaction"
  },
  verifyAchTransaction: {
    method: "POST",
    path: "/api/transactions/verify-ach",
    body: z17.object({
      providerTransactionId: z17.string(),
      checkSerialNumber: z17.string().optional()
    }),
    responses: {
      200: TransactionVerificationResultSchema,
      400: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Verify ACH transaction status with payment provider"
  },
  notifyFundsDebited: {
    method: "POST",
    path: "/api/transactions/notify-funds-debited",
    body: z17.object({
      orderId: z17.string(),
      customerId: z17.string(),
      transactionId: z17.string(),
      amount: z17.number(),
      currency: z17.string().default("USD")
    }),
    responses: {
      200: z17.object({ success: z17.boolean(), eventId: z17.string().optional() }),
      400: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string() }),
      500: z17.object({ message: z17.string() })
    },
    summary: "Publish ACH funds debited event for notification"
  },
  /**
   * Job endpoint for ACH status checks.
   * Called by job-worker to verify ACH transaction status and trigger appropriate actions.
   * This endpoint orchestrates: verification → status update → event publishing
   */
  checkAchStatusJob: {
    method: "POST",
    path: "/api/jobs/transactions/check-ach-status",
    body: z17.object({
      transactionId: z17.string().uuid(),
      providerTransactionId: z17.string(),
      checkSerialNumber: z17.string(),
      orderId: z17.string(),
      customerId: z17.number().positive(),
      previousStatus: z17.string().optional()
    }),
    responses: {
      200: z17.object({
        success: z17.boolean(),
        status: z17.nativeEnum(VerificationResultStatus),
        statusChanged: z17.boolean(),
        providerStatus: z17.string().optional(),
        message: z17.string().optional(),
        eventPublished: z17.boolean().optional()
      }),
      400: z17.object({ message: z17.string() }),
      401: z17.object({ message: z17.string() }),
      404: z17.object({ message: z17.string(), details: z17.string().optional() }),
      500: z17.object({ message: z17.string(), details: z17.string().optional() })
    },
    summary: "Job endpoint: Check ACH transaction status and orchestrate side effects"
  }
});

// src/http/bank-accounts.contract.ts
import { initContract as initContract17 } from "@ts-rest/core";
import { z as z18 } from "zod";
var c17 = initContract17();
var BankAccountDtoSchema = z18.object({
  id: z18.string(),
  customerId: z18.number(),
  accountName: z18.string().optional(),
  accountType: z18.enum(["checking", "savings"]).optional(),
  lastFour: z18.string().optional(),
  // Last 4 digits of account number (if available)
  isDefault: z18.boolean(),
  isDeleted: z18.boolean(),
  createdAt: z18.string(),
  // ISO date string
  updatedAt: z18.string()
  // ISO date string
});
var StoreBankAccountRequestSchema = z18.object({
  accountName: z18.string().min(1, "Account name is required"),
  accountNumber: z18.string().min(4, "Account number must be at least 4 digits"),
  routingNumber: z18.string().length(9, "Routing number must be exactly 9 digits"),
  accountType: z18.enum(["checking", "savings"], {
    errorMap: () => ({ message: "Account type must be checking or savings" })
  }),
  isDefault: z18.boolean().optional()
});
var SetDefaultBankAccountRequestSchema = z18.object({
  accountId: z18.string().uuid("Invalid account ID format")
});
var bankAccountsContract = c17.router({
  /**
   * List customer's bank accounts
   * Uses authenticated customer from request context
   */
  list: {
    method: "GET",
    path: "/api/bank-accounts",
    responses: {
      200: z18.object({ accounts: z18.array(BankAccountDtoSchema) }),
      401: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Get customer bank accounts"
  },
  /**
   * Store a new bank account
   * Creates account token via ACHPC and saves mapping
   */
  create: {
    method: "POST",
    path: "/api/bank-accounts",
    body: StoreBankAccountRequestSchema,
    responses: {
      201: z18.object({ account: BankAccountDtoSchema }),
      400: z18.object({ message: z18.string() }),
      401: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Store new bank account"
  },
  /**
   * Get specific bank account by ID
   * Validates ownership via authenticated customer
   */
  getById: {
    method: "GET",
    path: "/api/bank-accounts/:accountId",
    pathParams: z18.object({
      accountId: z18.string()
    }),
    responses: {
      200: z18.object({ account: BankAccountDtoSchema }),
      401: z18.object({ message: z18.string() }),
      403: z18.object({ message: z18.string() }),
      404: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Get bank account by ID"
  },
  /**
   * Set a bank account as default
   */
  setDefault: {
    method: "PATCH",
    path: "/api/bank-accounts/:accountId/default",
    pathParams: z18.object({
      accountId: z18.string()
    }),
    body: z18.object({}),
    // Empty body, accountId comes from path
    responses: {
      200: z18.object({ message: z18.string() }),
      401: z18.object({ message: z18.string() }),
      403: z18.object({ message: z18.string() }),
      404: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Set bank account as default"
  },
  /**
   * Remove a bank account
   */
  remove: {
    method: "DELETE",
    path: "/api/bank-accounts/:accountId",
    pathParams: z18.object({
      accountId: z18.string()
    }),
    body: z18.object({}),
    // Empty body
    responses: {
      200: z18.object({ message: z18.string() }),
      401: z18.object({ message: z18.string() }),
      403: z18.object({ message: z18.string() }),
      404: z18.object({ message: z18.string() }),
      500: z18.object({ message: z18.string() })
    },
    summary: "Remove bank account"
  }
});

// src/http/checkout.contract.ts
import { initContract as initContract18 } from "@ts-rest/core";
import {
  CheckoutRequestSchema,
  CheckoutResponseSchema,
  VerifyDestinationLicenseRequestSchema,
  VerifyDestinationLicenseResponseSchema
} from "@flote/types/checkout";
import {
  CreateDeliveryDestinationSchema,
  DeliveryDestinationSchema,
  DeliveryDestinationsResponseSchema
} from "@flote/types/delivery";
import { z as z19 } from "zod";
var c18 = initContract18();
var checkoutContract = c18.router({
  checkout: {
    method: "POST",
    path: "/api/checkout",
    body: CheckoutRequestSchema,
    headers: z19.object({
      "idempotency-key": z19.string().optional()
    }).optional(),
    responses: {
      200: CheckoutResponseSchema,
      400: z19.object({ message: z19.string() }),
      401: z19.object({ message: z19.string() }),
      403: z19.object({ message: z19.string() }),
      422: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Process checkout and create order"
  },
  getDeliveryDestinations: {
    method: "GET",
    path: "/api/checkout/delivery-destinations",
    responses: {
      200: DeliveryDestinationsResponseSchema,
      401: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Get available delivery destinations for the authenticated customer"
  },
  createDeliveryDestination: {
    method: "POST",
    path: "/api/checkout/delivery-destinations",
    body: CreateDeliveryDestinationSchema,
    responses: {
      201: DeliveryDestinationSchema,
      401: z19.object({ message: z19.string() }),
      404: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Create a delivery destination (org location) for the authenticated customer"
  },
  verifyDestinationLicense: {
    method: "POST",
    path: "/api/checkout/verify-destination-license",
    body: VerifyDestinationLicenseRequestSchema,
    responses: {
      200: VerifyDestinationLicenseResponseSchema,
      401: z19.object({ message: z19.string() }),
      500: z19.object({ message: z19.string() })
    },
    summary: "Verify a Metrc license number and link it to a delivery location"
  }
});

// src/http/scheduled-checks.contract.ts
import { initContract as initContract19 } from "@ts-rest/core";
import { z as z20 } from "zod";
import {
  ScheduledTransactionSchema,
  ScheduledTransactionWithTransactionSchema,
  UpdateScheduledTransactionDtoSchema,
  FindScheduledTransactionsDtoSchema
} from "@flote/types/scheduled-transaction";
var c19 = initContract19();
var scheduledChecksContract = c19.router({
  findPending: {
    method: "GET",
    path: "/api/scheduled-checks/pending",
    query: FindScheduledTransactionsDtoSchema,
    responses: {
      200: z20.array(ScheduledTransactionWithTransactionSchema),
      400: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Find pending scheduled transaction checks with transaction data"
  },
  getById: {
    method: "GET",
    path: "/api/scheduled-checks/:id",
    pathParams: z20.object({
      id: z20.string().uuid()
    }),
    responses: {
      200: ScheduledTransactionSchema,
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Get scheduled check by ID"
  },
  update: {
    method: "PATCH",
    path: "/api/scheduled-checks/:id",
    pathParams: z20.object({
      id: z20.string().uuid()
    }),
    body: UpdateScheduledTransactionDtoSchema,
    responses: {
      204: z20.void(),
      400: z20.object({ message: z20.string() }),
      404: z20.object({ message: z20.string() }),
      500: z20.object({ message: z20.string() })
    },
    summary: "Update scheduled check status and metadata"
  }
});

// src/http/discount-codes.contract.ts
import { initContract as initContract20 } from "@ts-rest/core";
import { z as z21 } from "zod";
import {
  DiscountCodeSchema,
  CreateDiscountCodeDtoSchema,
  UpdateDiscountCodeDtoSchema,
  FindDiscountCodesDtoSchema,
  ValidateDiscountCodeDtoSchema,
  DiscountCodeValidationResultSchema,
  ApplyDiscountCodeDtoSchema
} from "@flote/types/discount-codes";
import {
  DiscountCodeRedemptionSchema,
  CustomerEligibilityResponseDtoSchema
} from "@flote/types/discount-code-redemptions";
var c20 = initContract20();
var discountCodesContract = c20.router({
  create: {
    method: "POST",
    path: "/api/discount-codes",
    body: CreateDiscountCodeDtoSchema,
    responses: {
      201: DiscountCodeSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      409: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Create a new discount code"
  },
  list: {
    method: "GET",
    path: "/api/discount-codes",
    query: FindDiscountCodesDtoSchema.optional(),
    responses: {
      200: z21.array(DiscountCodeSchema),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "List discount codes with optional filters"
  },
  getById: {
    method: "GET",
    path: "/api/discount-codes/:id",
    pathParams: z21.object({ id: z21.string().uuid() }),
    responses: {
      200: DiscountCodeSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get discount code by ID"
  },
  getByCode: {
    method: "GET",
    path: "/api/discount-codes/code/:code",
    pathParams: z21.object({ code: z21.string() }),
    responses: {
      200: DiscountCodeSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get discount code by code"
  },
  update: {
    method: "PATCH",
    path: "/api/discount-codes/:id",
    pathParams: z21.object({ id: z21.string().uuid() }),
    body: UpdateDiscountCodeDtoSchema,
    responses: {
      200: z21.object({ success: z21.boolean() }),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Update discount code"
  },
  delete: {
    method: "DELETE",
    path: "/api/discount-codes/:id",
    pathParams: z21.object({ id: z21.string().uuid() }),
    body: c20.noBody(),
    responses: {
      200: z21.object({ success: z21.boolean() }),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Soft delete discount code"
  },
  validate: {
    method: "POST",
    path: "/api/discount-codes/validate",
    body: ValidateDiscountCodeDtoSchema,
    responses: {
      200: DiscountCodeValidationResultSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Validate a discount code against order criteria"
  },
  checkCustomerEligibility: {
    method: "GET",
    path: "/api/discount-codes/:discountCodeId/customers/:customerId/eligibility",
    pathParams: z21.object({
      discountCodeId: z21.string().uuid(),
      customerId: z21.coerce.number()
    }),
    responses: {
      200: CustomerEligibilityResponseDtoSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Check if a customer is eligible to use a discount code"
  },
  redeem: {
    method: "POST",
    path: "/api/discount-codes/redeem",
    body: ApplyDiscountCodeDtoSchema,
    responses: {
      201: DiscountCodeRedemptionSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      409: z21.object({ message: z21.string() }),
      422: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Redeem a discount code for an order"
  },
  getRedemptionById: {
    method: "GET",
    path: "/api/discount-code-redemptions/:id",
    pathParams: z21.object({ id: z21.string().uuid() }),
    responses: {
      200: DiscountCodeRedemptionSchema,
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get discount code redemption by ID"
  },
  getRedemptionsByCode: {
    method: "GET",
    path: "/api/discount-codes/:discountCodeId/redemptions",
    pathParams: z21.object({ discountCodeId: z21.string().uuid() }),
    responses: {
      200: z21.array(DiscountCodeRedemptionSchema),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get all redemptions for a discount code"
  },
  getRedemptionsByCustomer: {
    method: "GET",
    path: "/api/customers/:customerId/discount-code-redemptions",
    pathParams: z21.object({ customerId: z21.coerce.number() }),
    responses: {
      200: z21.array(DiscountCodeRedemptionSchema),
      400: z21.object({ message: z21.string() }),
      401: z21.object({ message: z21.string() }),
      404: z21.object({ message: z21.string() }),
      500: z21.object({ message: z21.string() })
    },
    summary: "Get all discount code redemptions for a customer"
  }
});

// src/http/fulfillment-offers.contract.ts
import { initContract as initContract21 } from "@ts-rest/core";
import { z as z22 } from "zod";
import {
  FulfillmentOfferWithPartitionDtoSchema,
  FulfillmentOfferWithPartitionAndItemsDtoSchema,
  OfferResponseDtoSchema,
  ExpireOffersResponseDtoSchema,
  FulfillmentOfferStatusSchema,
  OrderPartitionDtoSchema,
  OrderPartitionFulfillmentTypeSchema,
  OrderPartitionFulfillmentStatusSchema,
  FulfillmentResultSchema,
  CarrierTrackingSnapshotSchema
} from "@flote/types/delivery";
var c21 = initContract21();
var FulfillmentStatusesQueryParamSchema = z22.preprocess(
  (val) => {
    if (val === void 0 || val === null || val === "") return void 0;
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
      return val.split(",").map((s) => s.trim()).filter(Boolean);
    }
    return val;
  },
  z22.array(OrderPartitionFulfillmentStatusSchema)
).optional();
var fulfillmentOffersContract = c21.router({
  // =============================================================================
  // Brand-Scoped Offer Queries
  // =============================================================================
  /**
   * Get fulfillment offers for a brand.
   * Used by supplier portal to show pending self-delivery offers.
   */
  getOffersForBrand: {
    method: "GET",
    path: "/api/brands/:brandId/fulfillment-offers",
    pathParams: z22.object({ brandId: z22.string().uuid() }),
    query: z22.object({
      status: FulfillmentOfferStatusSchema.optional()
    }),
    responses: {
      200: z22.array(FulfillmentOfferWithPartitionDtoSchema),
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get fulfillment offers for a brand"
  },
  /**
   * Get fulfillment offers for a brand with partition items.
   * Includes line item details (quantity, price, product name) for each offer.
   * Used by supplier portal to display full order contents for decision-making.
   */
  getOffersForBrandWithItems: {
    method: "GET",
    path: "/api/brands/:brandId/fulfillment-offers-with-items",
    pathParams: z22.object({ brandId: z22.string().uuid() }),
    query: z22.object({
      status: FulfillmentOfferStatusSchema.optional()
    }),
    responses: {
      200: z22.array(FulfillmentOfferWithPartitionAndItemsDtoSchema),
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get fulfillment offers for a brand with partition line items"
  },
  /**
   * Get order partitions for a brand.
   * Used by supplier portal to show accepted deliveries (brand_driver partitions).
   */
  getPartitionsForBrand: {
    method: "GET",
    path: "/api/brands/:brandId/order-partitions",
    pathParams: z22.object({ brandId: z22.string().uuid() }),
    query: z22.object({
      fulfillmentType: OrderPartitionFulfillmentTypeSchema.optional(),
      fulfillmentStatus: OrderPartitionFulfillmentStatusSchema.optional(),
      fulfillmentStatuses: FulfillmentStatusesQueryParamSchema,
      productSku: z22.string().optional(),
      trackingId: z22.string().optional(),
      search: z22.string().optional(),
      stockLocationId: z22.string().uuid().optional()
    }),
    responses: {
      200: z22.array(OrderPartitionDtoSchema),
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get order partitions for a brand with optional filters"
  },
  /**
   * Manually fulfill an order partition.
   * Used by supplier portal for manual delivery confirmation (fallback if webhook fails).
   * Releases reserved inventory and creates fulfillment audit records.
   * Idempotent - safe to call multiple times.
   */
  fulfillPartition: {
    method: "POST",
    path: "/api/brands/:brandId/order-partitions/:partitionId/fulfill",
    pathParams: z22.object({
      brandId: z22.string().uuid(),
      partitionId: z22.string().uuid()
    }),
    body: z22.object({
      fulfilledQuantities: z22.record(z22.string(), z22.number().int().positive()).optional()
    }),
    responses: {
      200: FulfillmentResultSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Manually fulfill an order partition and release inventory"
  },
  // =============================================================================
  // Mail Carrier Shipping Actions
  // =============================================================================
  /**
   * Ship a mail-carrier partition by setting carrier and tracking number.
   * Only valid for partitions with fulfillmentType='mail_carrier' and status='accepted'.
   */
  shipPartition: {
    method: "POST",
    path: "/api/brands/:brandId/order-partitions/:partitionId/ship",
    pathParams: z22.object({
      brandId: z22.string().uuid(),
      partitionId: z22.string().uuid()
    }),
    body: z22.object({
      shippingCarrier: z22.enum(["usps", "ups", "fedex"]),
      carrierTrackingNumber: z22.string().min(1)
    }),
    responses: {
      200: OrderPartitionDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      409: z22.object({ message: z22.string() }),
      410: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Ship a mail-carrier partition with carrier and tracking number"
  },
  /**
   * Mark a shipped partition as delivered.
   * Only valid for partitions with fulfillmentStatus='shipped'.
   * Creates fulfillment records and marks completed.
   */
  markDelivered: {
    method: "POST",
    path: "/api/brands/:brandId/order-partitions/:partitionId/mark-delivered",
    pathParams: z22.object({
      brandId: z22.string().uuid(),
      partitionId: z22.string().uuid()
    }),
    body: z22.object({}),
    responses: {
      200: OrderPartitionDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Mark a shipped partition as delivered"
  },
  /**
   * Get live carrier tracking for a shipped mail-carrier partition.
   * Fetches current tracking status, timeline events, and estimated delivery from EasyPost.
   * Requires the partition to have a registered EasyPost tracker (easypostTrackerId).
   */
  getPartitionTracking: {
    method: "GET",
    path: "/api/brands/:brandId/order-partitions/:partitionId/tracking",
    pathParams: z22.object({
      brandId: z22.string().uuid(),
      partitionId: z22.string().uuid()
    }),
    responses: {
      200: CarrierTrackingSnapshotSchema,
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Get live carrier tracking for a shipped mail-carrier partition"
  },
  // =============================================================================
  // Offer Response Actions
  // =============================================================================
  /**
   * Accept a fulfillment offer (brand will self-deliver).
   * Sets partition to brand_driver fulfillment with 4% spread.
   */
  acceptOffer: {
    method: "POST",
    path: "/api/fulfillment-offers/:id/accept",
    pathParams: z22.object({ id: z22.string().uuid() }),
    body: c21.noBody(),
    responses: {
      200: OfferResponseDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      409: z22.object({ message: z22.string() }),
      410: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Accept a fulfillment offer (brand self-delivers)"
  },
  /**
   * Decline a fulfillment offer (Flote will deliver).
   * Sets partition to flote_driver fulfillment with 10% spread.
   */
  declineOffer: {
    method: "POST",
    path: "/api/fulfillment-offers/:id/decline",
    pathParams: z22.object({ id: z22.string().uuid() }),
    body: z22.object({
      reason: z22.string().optional()
    }),
    responses: {
      200: OfferResponseDtoSchema,
      400: z22.object({ message: z22.string() }),
      401: z22.object({ message: z22.string() }),
      403: z22.object({ message: z22.string() }),
      404: z22.object({ message: z22.string() }),
      409: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Decline a fulfillment offer (Flote delivers)"
  },
  // =============================================================================
  // Job Endpoints (Internal)
  // =============================================================================
  /**
   * Expire all pending offers past deadline.
   * Called by scheduled job every minute.
   * Auto-assigns expired partitions to Flote with 10% spread.
   */
  expireOffers: {
    method: "POST",
    path: "/api/jobs/fulfillment-offers/expire",
    body: c21.noBody(),
    responses: {
      200: ExpireOffersResponseDtoSchema,
      401: z22.object({ message: z22.string() }),
      500: z22.object({ message: z22.string() })
    },
    summary: "Expire pending fulfillment offers past deadline (job endpoint)"
  }
});

// src/http/inventory.contract.ts
import { initContract as initContract22 } from "@ts-rest/core";
import { z as z23 } from "zod";
import {
  StockLocationDetailDtoSchema,
  InventoryListingQuerySchema,
  InventoryListingResponseSchema,
  UpdateInventoryLevelDtoSchema,
  InventoryLevelDtoSchema,
  AddProductToInventoryInputSchema,
  TransferListingQuerySchema,
  TransferListingResponseSchema,
  InventoryTransferListingDtoSchema,
  CreateInventoryTransferInputSchema,
  UpdateTransferStatusInputSchema,
  InventoryPackageDtoSchema,
  UpdateInventoryPackageInputSchema
} from "@flote/types/inventory";
var c22 = initContract22();
var ReservationMismatchDirectionSchema = z23.enum([
  "item_shortfall",
  "package_excess",
  "missing_inventory_item_link"
]);
var ReservationMismatchIncidentRowSchema = z23.object({
  orderPartitionItemId: z23.string().uuid(),
  orderPartitionId: z23.string().uuid(),
  inventoryItemId: z23.string().uuid().nullable(),
  stockLocationId: z23.string().uuid().nullable(),
  fulfillmentStatus: z23.string(),
  preparationStatus: z23.string(),
  direction: ReservationMismatchDirectionSchema,
  itemReservedQuantity: z23.number(),
  packageReservedQuantity: z23.number(),
  deltaQuantity: z23.number(),
  reason: z23.string()
});
var ReconcilePartitionItemReservationMismatchesResultSchema = z23.object({
  scanned: z23.number().int(),
  consistent: z23.number().int(),
  itemShortfallCount: z23.number().int(),
  packageExcessCount: z23.number().int(),
  reReservedCount: z23.number().int(),
  releasedExcessCount: z23.number().int(),
  unresolvedCount: z23.number().int(),
  incidentRequired: z23.array(ReservationMismatchIncidentRowSchema),
  durationMs: z23.number().int()
});
var ReconcileReservationCountersResultSchema = z23.object({
  batchesCorrected: z23.number().int(),
  orphanedMissingBatches: z23.number().int(),
  partitionItemsCorrected: z23.number().int(),
  partitionItemsReported: z23.number().int(),
  partitionItemMismatches: ReconcilePartitionItemReservationMismatchesResultSchema,
  durationMs: z23.number().int()
});
var ReconcileStockedQuantitiesResultSchema = z23.object({
  levelsCorrected: z23.number().int(),
  durationMs: z23.number().int()
});
var ReconcileInventoryCountersResultSchema = z23.object({
  reservationCounters: ReconcileReservationCountersResultSchema,
  stockedQuantities: ReconcileStockedQuantitiesResultSchema,
  durationMs: z23.number().int()
});
var inventoryContract = c22.router({
  // =============================================================================
  // Stock Location Endpoints (for supplier portal)
  // =============================================================================
  /**
   * Get stock locations accessible to a supplier with full details.
   * Returns locations with address info and supplier's permissions.
   */
  getSupplierStockLocations: {
    method: "GET",
    path: "/api/suppliers/:supplierId/inventory/stock-locations",
    pathParams: z23.object({ supplierId: z23.string().uuid() }),
    responses: {
      200: z23.array(StockLocationDetailDtoSchema),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get stock locations accessible to supplier with details"
  },
  // =============================================================================
  // Inventory Listing Endpoints
  // =============================================================================
  /**
   * Get inventory at a stock location filtered by supplier's brands.
   * Returns paginated list of inventory items with quantities.
   */
  getStockLocationInventory: {
    method: "GET",
    path: "/api/stock-locations/:locationId/inventory",
    pathParams: z23.object({ locationId: z23.string().uuid() }),
    query: InventoryListingQuerySchema,
    responses: {
      200: InventoryListingResponseSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get inventory at a stock location (filtered by supplier brands)"
  },
  // =============================================================================
  // Inventory Level Endpoints (for Phase 4)
  // =============================================================================
  /**
   * Update inventory level quantity.
   * Requires supplier to have canEdit permission on the location.
   */
  updateInventoryLevel: {
    method: "PATCH",
    path: "/api/inventory-levels/:id",
    pathParams: z23.object({ id: z23.string().uuid() }),
    body: UpdateInventoryLevelDtoSchema,
    query: z23.object({
      // Required for authorization - must verify supplier has edit access
      supplierId: z23.string().uuid()
    }),
    responses: {
      200: InventoryLevelDtoSchema,
      400: z23.object({ message: z23.string() }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Update inventory level stocked quantity"
  },
  /**
   * Add a product to inventory at a specific stock location.
   * Creates inventory item and level if they don't exist.
   * Requires supplier to have canEdit permission on the location.
   */
  addProductToLocation: {
    method: "POST",
    path: "/api/stock-locations/:locationId/inventory",
    pathParams: z23.object({ locationId: z23.string().uuid() }),
    body: AddProductToInventoryInputSchema,
    query: z23.object({
      // Required for authorization - must verify supplier has edit access
      supplierId: z23.string().uuid()
    }),
    responses: {
      201: InventoryLevelDtoSchema,
      400: z23.object({ message: z23.string() }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      409: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Add a product to inventory at a stock location"
  },
  // =============================================================================
  // Inventory Transfer Endpoints
  // =============================================================================
  /**
   * List inventory transfers for a supplier.
   * Returns transfers where supplier has access to both locations.
   */
  listTransfers: {
    method: "GET",
    path: "/api/suppliers/:supplierId/inventory/transfers",
    pathParams: z23.object({ supplierId: z23.string().uuid() }),
    query: TransferListingQuerySchema,
    responses: {
      200: TransferListingResponseSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "List inventory transfers for supplier"
  },
  /**
   * Get a single transfer by ID.
   * Returns transfer with enriched data (locations, users, product info).
   */
  getTransfer: {
    method: "GET",
    path: "/api/inventory/transfers/:id",
    pathParams: z23.object({ id: z23.string().uuid() }),
    query: z23.object({
      supplierId: z23.string().uuid()
    }),
    responses: {
      200: InventoryTransferListingDtoSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get a single inventory transfer"
  },
  /**
   * Create a new inventory transfer.
   * Supplier must have canEdit on both source and destination locations.
   * Set instant=true to complete transfer immediately without shipping flow.
   */
  createTransfer: {
    method: "POST",
    path: "/api/inventory/transfers",
    body: CreateInventoryTransferInputSchema,
    query: z23.object({
      supplierId: z23.string().uuid()
    }),
    responses: {
      201: InventoryTransferListingDtoSchema,
      400: z23.object({ message: z23.string() }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      422: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Create a new inventory transfer"
  },
  /**
   * Update transfer status (ship, receive, or cancel).
   * - Ship: Decrements source inventory, sets shipped_at
   * - Receive: Increments destination inventory, sets received_at
   * - Cancel: Restores source if shipped, sets cancelled_at
   */
  updateTransferStatus: {
    method: "PATCH",
    path: "/api/inventory/transfers/:id/status",
    pathParams: z23.object({ id: z23.string().uuid() }),
    body: UpdateTransferStatusInputSchema,
    query: z23.object({
      supplierId: z23.string().uuid()
    }),
    responses: {
      200: InventoryTransferListingDtoSchema,
      400: z23.object({ message: z23.string() }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      409: z23.object({ message: z23.string() }),
      422: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Update transfer status"
  },
  // =============================================================================
  // Inventory Batch Endpoints (FIFO/Lot Tracking)
  // =============================================================================
  // =============================================================================
  // Metrc Integration Endpoints
  // =============================================================================
  /**
   * Get total inventory for a specific item at a Metrc-licensed facility.
   * Pages through all active packages and sums quantities for the matching item.
   */
  getMetrcItemInventory: {
    method: "GET",
    path: "/api/inventory/metrc/item",
    query: z23.object({
      licenseNumber: z23.string().min(1),
      itemId: z23.coerce.number().int().positive().optional(),
      itemName: z23.string().min(1).optional(),
      unitWeight: z23.coerce.number().positive().optional(),
      unitsPerCase: z23.coerce.number().int().positive().optional()
    }).refine((data) => data.itemId || data.itemName, {
      message: "Either itemId or itemName must be provided"
    }),
    responses: {
      200: z23.object({
        itemId: z23.number().nullable(),
        itemName: z23.string(),
        licenseNumber: z23.string(),
        totalQuantity: z23.number(),
        unitOfMeasure: z23.string().nullable(),
        caseBreakdown: z23.object({
          unitWeight: z23.number(),
          unitsPerCase: z23.number(),
          caseWeight: z23.number(),
          completeCases: z23.number(),
          bulkCases: z23.number(),
          masterCases: z23.number(),
          loosePackages: z23.number()
        }).nullable(),
        packages: z23.array(z23.object({
          label: z23.string().nullable(),
          quantity: z23.number().nullable(),
          location: z23.string().nullable(),
          packagedDate: z23.string().nullable(),
          labTestingState: z23.string().nullable()
        }))
      }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get total Metrc inventory for a specific item at a license"
  },
  /**
   * Get all unique items across active packages at a Metrc license.
   * Returns item IDs, names, categories, and aggregate quantities.
   */
  getMetrcItemsAtLocation: {
    method: "GET",
    path: "/api/inventory/metrc/items",
    query: z23.object({
      licenseNumber: z23.string().min(1)
    }),
    responses: {
      200: z23.object({
        licenseNumber: z23.string(),
        items: z23.array(z23.object({
          itemId: z23.number(),
          itemName: z23.string(),
          productCategoryName: z23.string().nullable(),
          totalQuantity: z23.number(),
          unitOfMeasure: z23.string().nullable(),
          packageCount: z23.number()
        })),
        totalPackages: z23.number()
      }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Get all unique Metrc items at a license"
  },
  updatePackage: {
    method: "PATCH",
    path: "/api/inventory/packages/:id",
    pathParams: z23.object({ id: z23.string().uuid() }),
    body: UpdateInventoryPackageInputSchema,
    query: z23.object({
      supplierId: z23.string().uuid()
    }),
    responses: {
      200: InventoryPackageDtoSchema,
      400: z23.object({ message: z23.string() }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      404: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Update package facts (not quantities or reservations)"
  },
  // =============================================================================
  // Metrc Sync Endpoints
  // =============================================================================
  /**
   * Trigger a Metrc inventory sync.
   * Syncs Metrc package quantities to local inventory levels.
   * Requires flote_admin or inventory:edit permission.
   */
  triggerMetrcSync: {
    method: "POST",
    path: "/api/inventory/metrc-sync",
    body: z23.object({
      mode: z23.enum(["full", "delta"])
    }),
    responses: {
      200: z23.object({
        success: z23.boolean(),
        locationsProcessed: z23.number().int(),
        itemsUpdated: z23.number().int(),
        itemsSkipped: z23.number().int(),
        errors: z23.number().int(),
        durationMs: z23.number().int(),
        locationResults: z23.array(z23.object({
          locationId: z23.string(),
          locationName: z23.string(),
          licenseNumber: z23.string(),
          packagesScanned: z23.number().int(),
          uniqueItems: z23.number().int(),
          itemsMatched: z23.number().int(),
          itemsSkipped: z23.number().int(),
          errors: z23.number().int()
        }))
      }),
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Trigger Metrc inventory sync (admin or inventory:edit)"
  },
  // =============================================================================
  // Inventory Reconciliation Endpoints
  // =============================================================================
  /**
   * Detect and safely repair partition-item reserved counters against active
   * package reservation rows.
   */
  reconcilePartitionItemReservationMismatches: {
    method: "POST",
    path: "/api/inventory/reconciliation/partition-item-reservation-mismatches",
    body: z23.object({}),
    responses: {
      200: ReconcilePartitionItemReservationMismatchesResultSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Reconcile partition-item reservation counters from package reservations"
  },
  /**
   * Recompute Metrc-tracked stocked quantities from active package rows.
   */
  reconcileStockedQuantities: {
    method: "POST",
    path: "/api/inventory/reconciliation/stocked-quantities",
    body: z23.object({}),
    responses: {
      200: ReconcileStockedQuantitiesResultSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Reconcile stocked quantities from active package rows"
  },
  /**
   * Run all inventory counter reconcilers, covering reservation counters and
   * Metrc-tracked stocked quantities.
   */
  reconcileInventoryCounters: {
    method: "POST",
    path: "/api/inventory/reconciliation/counters",
    body: z23.object({}),
    responses: {
      200: ReconcileInventoryCountersResultSchema,
      401: z23.object({ message: z23.string() }),
      403: z23.object({ message: z23.string() }),
      500: z23.object({ message: z23.string() })
    },
    summary: "Run all inventory counter reconcilers"
  }
});

// src/http/inventory-access.contract.ts
import { initContract as initContract23 } from "@ts-rest/core";
import { z as z24 } from "zod";
import {
  StockLocationAccessResponseSchema,
  StockLocationActivityResponseSchema,
  StockLocationActivityQuerySchema
} from "@flote/types/inventory";
var c23 = initContract23();
var inventoryAccessContract = c23.router({
  /**
   * Get users who have access to a stock location.
   * flote_admin: See ALL users with access (across all suppliers)
   * Supplier users: Only see users from their OWN supplier
   */
  getStockLocationAccess: {
    method: "GET",
    path: "/api/stock-locations/:locationId/access",
    pathParams: z24.object({ locationId: z24.string().uuid() }),
    query: z24.object({
      supplierId: z24.string().uuid().optional()
    }),
    responses: {
      200: StockLocationAccessResponseSchema,
      401: z24.object({ message: z24.string() }),
      403: z24.object({ message: z24.string() }),
      404: z24.object({ message: z24.string() }),
      500: z24.object({ message: z24.string() })
    },
    summary: "Get users with access to a stock location"
  },
  /**
   * Get recent inventory activity (adjustments) at a stock location.
   * Returns adjustments with user attribution and product context.
   */
  getStockLocationActivity: {
    method: "GET",
    path: "/api/stock-locations/:locationId/activity",
    pathParams: z24.object({ locationId: z24.string().uuid() }),
    query: StockLocationActivityQuerySchema.extend({
      supplierId: z24.string().uuid().optional()
    }),
    responses: {
      200: StockLocationActivityResponseSchema,
      401: z24.object({ message: z24.string() }),
      403: z24.object({ message: z24.string() }),
      404: z24.object({ message: z24.string() }),
      500: z24.object({ message: z24.string() })
    },
    summary: "Get recent inventory activity at a stock location"
  }
});

// src/http/product-management.contract.ts
import { initContract as initContract24 } from "@ts-rest/core";
import { z as z25 } from "zod";
import {
  UpdateProductInfoInputSchema,
  UploadProductImageDataInputSchema,
  ProductAuditQuerySchema,
  ProductAuditResponseSchema,
  ProductEditorsResponseSchema,
  ProductVariantsResponseSchema,
  UpdateProductVariantInputSchema,
  UpdateProductVariantResponseSchema,
  AddProductVariantInputSchema,
  AddProductVariantResponseSchema,
  DeleteProductVariantResponseSchema,
  AddProductImageInputSchema,
  ReorderProductGalleryInputSchema,
  DeleteProductGalleryImageResponseSchema,
  ProductImageDtoSchema
} from "@flote/types/product";
import { ProductFileDtoSchema } from "@flote/types/product";
var c24 = initContract24();
var UpdateProductResponseSchema = z25.object({
  id: z25.string().uuid(),
  title: z25.string(),
  description: z25.string().nullable(),
  thumbnail: z25.string().nullable(),
  updatedAt: z25.string().datetime()
});
var UploadProductImageResponseSchema = z25.object({
  id: z25.string().uuid(),
  thumbnail: z25.string().url(),
  updatedAt: z25.string().datetime()
});
var DeleteImageResponseSchema = z25.object({
  id: z25.string().uuid(),
  thumbnail: z25.null(),
  updatedAt: z25.string().datetime()
});
var UploadProductFileInputSchema = z25.object({
  fileData: z25.string(),
  // Base64 encoded file data
  fileName: z25.string().max(255),
  title: z25.string().max(255),
  contentType: z25.string()
});
var UploadedProductFileResponseSchema = z25.object({
  id: z25.string().uuid(),
  productId: z25.string().uuid(),
  file: ProductFileDtoSchema
});
var DeleteProductFileResponseSchema = z25.object({
  success: z25.boolean(),
  deletedFileId: z25.string().uuid()
});
var ErrorResponseSchema2 = z25.object({ message: z25.string() });
var productManagementContract = c24.router({
  /**
   * Update product info (title, description).
   * Requires PRODUCTS_EDIT permission.
   */
  updateProductInfo: {
    method: "PATCH",
    path: "/api/products/:productId",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: UpdateProductInfoInputSchema,
    responses: {
      200: UpdateProductResponseSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Update product info (title, description)"
  },
  /**
   * Upload or replace product image.
   * Requires PRODUCTS_EDIT permission.
   */
  uploadProductImage: {
    method: "POST",
    path: "/api/products/:productId/image",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: UploadProductImageDataInputSchema,
    responses: {
      200: UploadProductImageResponseSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Upload or replace product image"
  },
  /**
   * Delete product image.
   * Requires PRODUCTS_EDIT permission.
   */
  deleteProductImage: {
    method: "DELETE",
    path: "/api/products/:productId/image",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: z25.undefined(),
    responses: {
      200: DeleteImageResponseSchema,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Delete product image"
  },
  /**
   * Get files attached to a product.
   */
  getProductFiles: {
    method: "GET",
    path: "/api/products/:productId/files",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    responses: {
      200: z25.object({
        productId: z25.string().uuid(),
        files: z25.array(ProductFileDtoSchema)
      }),
      401: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Get files attached to a product"
  },
  /**
   * Upload a file to attach to a product.
   * Requires PRODUCTS_EDIT permission.
   */
  uploadProductFile: {
    method: "POST",
    path: "/api/products/:productId/files",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: UploadProductFileInputSchema,
    responses: {
      201: UploadedProductFileResponseSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Upload a file to attach to a product"
  },
  /**
   * Remove a file from a product.
   * Requires PRODUCTS_EDIT permission.
   */
  removeProductFile: {
    method: "DELETE",
    path: "/api/products/:productId/files/:fileId",
    pathParams: z25.object({
      productId: z25.string().uuid(),
      fileId: z25.string().uuid()
    }),
    body: z25.undefined(),
    responses: {
      200: DeleteProductFileResponseSchema,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Remove a file from a product"
  },
  /**
   * Get product variants with pricing.
   */
  getProductVariants: {
    method: "GET",
    path: "/api/products/:productId/variants",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    responses: {
      200: ProductVariantsResponseSchema,
      401: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Get product variants with pricing"
  },
  /**
   * Update a product variant.
   * Requires PRODUCTS_EDIT permission.
   */
  updateProductVariant: {
    method: "PATCH",
    path: "/api/products/:productId/variants/:variantId",
    pathParams: z25.object({
      productId: z25.string().uuid(),
      variantId: z25.string().uuid()
    }),
    body: UpdateProductVariantInputSchema,
    responses: {
      200: UpdateProductVariantResponseSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Update a product variant"
  },
  /**
   * Add a new variant to an existing product.
   * Requires PRODUCTS_EDIT permission.
   */
  addProductVariant: {
    method: "POST",
    path: "/api/products/:productId/variants",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: AddProductVariantInputSchema,
    responses: {
      201: AddProductVariantResponseSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Add a new variant to a product"
  },
  /**
   * Delete a product variant.
   * Cannot delete the last variant (product must have ≥1).
   * Requires PRODUCTS_EDIT permission.
   */
  deleteProductVariant: {
    method: "DELETE",
    path: "/api/products/:productId/variants/:variantId",
    pathParams: z25.object({
      productId: z25.string().uuid(),
      variantId: z25.string().uuid()
    }),
    body: z25.undefined(),
    responses: {
      200: DeleteProductVariantResponseSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Delete a product variant (cannot delete last variant)"
  },
  /**
   * Add an image to the product gallery.
   * Requires PRODUCTS_EDIT permission.
   */
  addProductGalleryImage: {
    method: "POST",
    path: "/api/products/:productId/images",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: AddProductImageInputSchema,
    responses: {
      201: ProductImageDtoSchema,
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Add an image to the product gallery"
  },
  /**
   * Remove an image from the product gallery.
   * Requires PRODUCTS_EDIT permission.
   */
  deleteProductGalleryImage: {
    method: "DELETE",
    path: "/api/products/:productId/images/:imageId",
    pathParams: z25.object({
      productId: z25.string().uuid(),
      imageId: z25.string().uuid()
    }),
    body: z25.undefined(),
    responses: {
      200: DeleteProductGalleryImageResponseSchema,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Remove an image from the product gallery"
  },
  /**
   * Reorder product gallery images.
   * Requires PRODUCTS_EDIT permission.
   */
  reorderProductGalleryImages: {
    method: "PATCH",
    path: "/api/products/:productId/images/reorder",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    body: ReorderProductGalleryInputSchema,
    responses: {
      200: z25.object({ success: z25.boolean() }),
      400: ErrorResponseSchema2,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Reorder product gallery images"
  },
  /**
   * Get audit log for a product (edit history).
   * Returns chronological list of changes with user attribution.
   */
  getProductAuditLog: {
    method: "GET",
    path: "/api/products/:productId/audit",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    query: ProductAuditQuerySchema,
    responses: {
      200: ProductAuditResponseSchema,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Get product edit history (audit log)"
  },
  /**
   * Get users who can edit this product.
   * Returns users with PRODUCTS_EDIT permission for the product's brand.
   */
  getProductEditors: {
    method: "GET",
    path: "/api/products/:productId/editors",
    pathParams: z25.object({ productId: z25.string().uuid() }),
    responses: {
      200: ProductEditorsResponseSchema,
      401: ErrorResponseSchema2,
      403: ErrorResponseSchema2,
      404: ErrorResponseSchema2,
      500: ErrorResponseSchema2
    },
    summary: "Get users who can edit this product"
  }
});

// src/http/variant-buyer-prices.contract.ts
import { initContract as initContract25 } from "@ts-rest/core";
import { z as z26 } from "zod";
import { PriceWithRulesDtoSchema, SetTiersForScopeRequestSchema } from "@flote/types/pricing";
var c25 = initContract25();
var VariantBuyerPriceScopeSchema = z26.discriminatedUnion("kind", [
  z26.object({
    kind: z26.literal("org"),
    buyerOrganizationId: z26.string().uuid()
  }),
  z26.object({
    kind: z26.literal("customer"),
    buyerOrganizationId: z26.string().uuid(),
    customerUuid: z26.string().uuid()
  })
]);
var CreateVariantBuyerPriceRequestSchema = z26.object({
  amount: z26.number().nonnegative(),
  currencyCode: z26.string().length(3).optional(),
  minQuantity: z26.number().int().positive().nullable().optional(),
  maxQuantity: z26.number().int().positive().nullable().optional(),
  startsAt: z26.string().datetime().nullable().optional(),
  endsAt: z26.string().datetime().nullable().optional(),
  notes: z26.string().nullable().optional(),
  scope: VariantBuyerPriceScopeSchema
});
var UpdateVariantBuyerPriceRequestSchema = z26.object({
  amount: z26.number().nonnegative().optional(),
  minQuantity: z26.number().int().positive().nullable().optional(),
  maxQuantity: z26.number().int().positive().nullable().optional(),
  startsAt: z26.string().datetime().nullable().optional(),
  endsAt: z26.string().datetime().nullable().optional(),
  notes: z26.string().nullable().optional()
});
var ListResponseSchema = z26.object({
  variantId: z26.string().uuid(),
  prices: z26.array(PriceWithRulesDtoSchema)
});
var DeleteResponseSchema = z26.object({
  success: z26.literal(true),
  deletedPriceId: z26.string().uuid()
});
var variantBuyerPricesContract = c25.router({
  /** List supplier-authored rule-based prices for a variant. */
  listForVariant: {
    method: "GET",
    path: "/api/products/:productId/variants/:variantId/buyer-prices",
    pathParams: z26.object({
      productId: z26.string().uuid(),
      variantId: z26.string().uuid()
    }),
    responses: {
      200: ListResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "List rule-based buyer prices for a variant"
  },
  /** Create a new scoped buyer price (org- or customer-level). */
  create: {
    method: "POST",
    path: "/api/products/:productId/variants/:variantId/buyer-prices",
    pathParams: z26.object({
      productId: z26.string().uuid(),
      variantId: z26.string().uuid()
    }),
    body: CreateVariantBuyerPriceRequestSchema,
    responses: {
      201: PriceWithRulesDtoSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      409: ErrorResponseSchema,
      422: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Create a buyer-scoped price for a variant"
  },
  /** Update an existing buyer price (amount, validity, notes). */
  update: {
    method: "PATCH",
    path: "/api/products/:productId/variants/:variantId/buyer-prices/:priceId",
    pathParams: z26.object({
      productId: z26.string().uuid(),
      variantId: z26.string().uuid(),
      priceId: z26.string().uuid()
    }),
    body: UpdateVariantBuyerPriceRequestSchema,
    responses: {
      200: PriceWithRulesDtoSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Update a buyer-scoped price"
  },
  /**
   * Replace the entire tier ladder for a (variant, scope) pair.
   * Atomically deletes existing prices and inserts the new tiers.
   */
  setTiersForScope: {
    method: "PUT",
    path: "/api/products/:productId/variants/:variantId/buyer-prices/scope",
    pathParams: z26.object({
      productId: z26.string().uuid(),
      variantId: z26.string().uuid()
    }),
    body: SetTiersForScopeRequestSchema,
    responses: {
      200: ListResponseSchema,
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      409: ErrorResponseSchema,
      422: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Replace the tier ladder for a (variant, scope) pair"
  },
  /** Soft-delete a buyer price and its rules. */
  delete: {
    method: "DELETE",
    path: "/api/products/:productId/variants/:variantId/buyer-prices/:priceId",
    pathParams: z26.object({
      productId: z26.string().uuid(),
      variantId: z26.string().uuid(),
      priceId: z26.string().uuid()
    }),
    body: z26.undefined(),
    responses: {
      200: DeleteResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Delete a buyer-scoped price"
  }
});

// src/http/permissions.contract.ts
import { initContract as initContract26 } from "@ts-rest/core";
import { z as z27 } from "zod";
var c26 = initContract26();
var PermissionSchema = z27.string();
var permissionsContract = c26.router({
  /**
   * Get permissions for a role.
   * Returns array of permission strings mapped to the role.
   */
  getForRole: {
    method: "GET",
    path: "/api/permissions/role/:role",
    pathParams: z27.object({
      role: z27.string()
    }),
    responses: {
      200: z27.array(PermissionSchema),
      400: z27.object({ message: z27.string() }),
      401: z27.object({ message: z27.string() }),
      404: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Get permissions for a role"
  },
  /**
   * Get permissions for the current authenticated user.
   * Returns permissions across all roles assigned to the user.
   */
  getForCurrentUser: {
    method: "GET",
    path: "/api/permissions/me",
    responses: {
      200: z27.object({
        permissions: z27.array(PermissionSchema),
        roles: z27.array(z27.string())
      }),
      401: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Get permissions for current user"
  },
  /**
   * Replace all permissions for a role.
   * Requires portal_users:manage permission (flote_admin only).
   */
  updateForRole: {
    method: "PUT",
    path: "/api/permissions/role/:role",
    pathParams: z27.object({
      role: z27.string()
    }),
    body: z27.object({
      permissions: z27.array(PermissionSchema)
    }),
    responses: {
      200: z27.array(PermissionSchema),
      400: z27.object({ message: z27.string() }),
      401: z27.object({ message: z27.string() }),
      403: z27.object({ message: z27.string() }),
      404: z27.object({ message: z27.string() }),
      500: z27.object({ message: z27.string() })
    },
    summary: "Update permissions for a role"
  }
});

// src/http/portal-admin.contract.ts
import { initContract as initContract27 } from "@ts-rest/core";
import { z as z28 } from "zod";
import { SupplierProductListingDtoSchema } from "@flote/types/product";
import { StockLocationDetailDtoSchema as StockLocationDetailDtoSchema2 } from "@flote/types/inventory";
import {
  OrderPartitionFulfillmentStatusSchema as OrderPartitionFulfillmentStatusSchema2,
  OrderPartitionFulfillmentTypeSchema as OrderPartitionFulfillmentTypeSchema2,
  OrderPartitionPreparationStatusSchema,
  OrderPartitionPaymentStatusSchema,
  PendingOfferSummarySchema,
  FulfillmentOfferSummarySchema
} from "@flote/types/delivery";
import {
  TransferTemplateDtoSchema,
  TransferTemplateReadinessDtoSchema,
  TransferTemplateBatchStatusItemSchema,
  TransferTemplateSegmentDtoSchema,
  TransferTemplateHandoffDtoSchema,
  TransferTemplateLayoverDtoSchema,
  PrepareTransferTemplateRequestSchema
} from "@flote/types/compliance";
import { ProductRealmSchema as ProductRealmSchema3 } from "@flote/types/product";
var EmbedConfigListItemDtoSchema = z28.object({
  hostDomain: z28.string(),
  displayName: z28.string().nullable(),
  brands: z28.array(z28.object({
    id: z28.string().uuid(),
    name: z28.string()
  })),
  realm: ProductRealmSchema3.nullable()
});
var c27 = initContract27();
var FulfillmentStatusesQueryParamSchema2 = z28.preprocess(
  (val) => {
    if (val === void 0 || val === null || val === "") return void 0;
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
      return val.split(",").map((s) => s.trim()).filter(Boolean);
    }
    return val;
  },
  z28.array(OrderPartitionFulfillmentStatusSchema2)
).optional();
var AdminProductListingDtoSchema = SupplierProductListingDtoSchema.extend({
  supplierId: z28.string().uuid().nullable(),
  supplierName: z28.string().nullable()
});
var AdminProductListingResponseSchema = z28.object({
  products: z28.array(AdminProductListingDtoSchema),
  total: z28.number().int(),
  page: z28.number().int(),
  pageSize: z28.number().int(),
  hasMore: z28.boolean()
});
var AdminStockLocationDtoSchema = StockLocationDetailDtoSchema2.extend({
  supplierId: z28.string().uuid().nullable(),
  supplierName: z28.string().nullable()
});
var AdminStockLocationListResponseSchema = z28.object({
  locations: z28.array(AdminStockLocationDtoSchema),
  total: z28.number().int(),
  page: z28.number().int(),
  pageSize: z28.number().int(),
  hasMore: z28.boolean()
});
var AdminPartitionListItemSchema = z28.object({
  id: z28.string().uuid(),
  orderId: z28.string().uuid().nullable(),
  b2bwaveOrderId: z28.string(),
  brandId: z28.string().uuid(),
  brandName: z28.string().optional(),
  brandRealm: z28.enum(["cannabis", "hemp", "general"]).optional(),
  trackingId: z28.string(),
  displayReference: z28.string().optional(),
  portionSubtotal: z28.number(),
  portionTotal: z28.number(),
  fulfillmentType: OrderPartitionFulfillmentTypeSchema2.nullable(),
  fulfillmentStatus: OrderPartitionFulfillmentStatusSchema2,
  preparationStatus: OrderPartitionPreparationStatusSchema,
  paymentStatus: OrderPartitionPaymentStatusSchema.nullable(),
  paymentMethod: z28.string().nullable(),
  stockLocationId: z28.string().uuid().nullable(),
  stockLocationName: z28.string().optional(),
  onfleetTaskId: z28.string().nullable(),
  spreadRate: z28.number().nullable(),
  spreadAmount: z28.number().nullable(),
  hasSignature: z28.boolean(),
  photoCount: z28.number().int().nonnegative(),
  destinationOrganizationLocationId: z28.string().uuid().nullable().optional(),
  destinationComplianceLicenseId: z28.string().uuid().nullable().optional(),
  shippingCarrier: z28.string().nullable(),
  carrierTrackingNumber: z28.string().nullable(),
  shippedAt: z28.string().nullable(),
  easypostTrackerId: z28.string().nullable(),
  metadata: z28.record(z28.unknown()),
  createdAt: z28.string(),
  updatedAt: z28.string(),
  customerName: z28.string().optional(),
  companyName: z28.string().optional(),
  customerLicenseNumber: z28.string().optional(),
  destinationCity: z28.string().optional(),
  totalQuantity: z28.number().int().nonnegative().optional(),
  itemCount: z28.number().int().nonnegative().optional(),
  pendingOffer: PendingOfferSummarySchema.nullish()
});
var AdminPartitionItemPackageAllocationSchema = z28.object({
  id: z28.string().uuid(),
  inventoryPackageId: z28.string().uuid(),
  reservedQuantity: z28.number().int().nonnegative(),
  releasedQuantity: z28.number().int().nonnegative(),
  consumedQuantity: z28.number().int().nonnegative(),
  remainingQuantity: z28.number().int().nonnegative(),
  packageLabel: z28.string().nullable(),
  productionBatchNumber: z28.string().nullable(),
  lotNumber: z28.string().nullable(),
  receivedDate: z28.string(),
  expiryDate: z28.string().nullable(),
  reservedAt: z28.string(),
  releasedAt: z28.string().nullable(),
  consumedAt: z28.string().nullable()
});
var AdminPackageAllocationMetrcTagConflictCodeSchema = z28.enum([
  "TAG_IN_HISTORICAL_FULFILLMENT",
  "TAG_RESERVED_ON_ACTIVE_ORDER",
  "MANIFEST_LOCKED",
  "ALLOCATION_IMMUTABLE",
  "INSUFFICIENT_REPLACEMENT_INVENTORY",
  "UNSUPPORTED_MULTI_SPLIT_REALLOCATION"
]);
var AdminPackageAllocationMetrcTagConflictSchema = z28.object({
  allocationId: z28.string().uuid(),
  orderPartitionId: z28.string().uuid(),
  trackingId: z28.string().nullable(),
  fulfillmentStatus: z28.string(),
  reservedQuantity: z28.number().int().nonnegative(),
  remainingQuantity: z28.number().int().nonnegative()
});
var AdminPackageAllocationMetrcTagUpdateResponseSchema = z28.object({
  allocation: AdminPartitionItemPackageAllocationSchema,
  metrcValidated: z28.boolean(),
  resolution: z28.enum(["direct_assign", "force_reassign", "no_op"]),
  impactedAllocations: z28.array(z28.object({
    allocationId: z28.string().uuid(),
    orderPartitionId: z28.string().uuid(),
    trackingId: z28.string().nullable(),
    oldPackageLabel: z28.string().nullable(),
    newPackageLabel: z28.string().nullable()
  }))
});
var AdminPackageAllocationMetrcTagConflictResponseSchema = z28.object({
  code: AdminPackageAllocationMetrcTagConflictCodeSchema,
  message: z28.string(),
  canForceReassign: z28.boolean().optional(),
  conflicts: z28.array(AdminPackageAllocationMetrcTagConflictSchema).optional()
});
var AutoAssignPackageAllocationsModeSchema = z28.enum(["auto_fifo"]);
var AutoAssignPackageAllocationsResponseSchema = z28.object({
  partitionItemId: z28.string().uuid(),
  requestedQuantity: z28.number().int().nonnegative(),
  assignedQuantity: z28.number().int().nonnegative(),
  /** IDs of the inventory_package_reservations rows created by this call. Empty when no-op or failed. */
  assignedAllocationIds: z28.array(z28.string().uuid())
});
var AutoAssignPackageAllocationsErrorCodeSchema = z28.enum([
  "STOCK_LOCATION_REQUIRED",
  "INVALID_PARTITION_STATE",
  "ITEM_NOT_METRC_TRACKED",
  "INSUFFICIENT_INVENTORY",
  "NO_MAPPED_PACKAGES",
  "FACILITY_LICENSE_REQUIRED",
  "RESERVATION_DEPS_MISSING"
]);
var AutoAssignPackageAllocationsErrorResponseSchema = z28.object({
  code: AutoAssignPackageAllocationsErrorCodeSchema,
  message: z28.string(),
  partitionItemId: z28.string().uuid().optional(),
  requestedQuantity: z28.number().int().nonnegative().optional(),
  assignedQuantity: z28.number().int().nonnegative().optional()
});
var AdminPartitionItemDetailSchema = z28.object({
  id: z28.string().uuid(),
  productVariantId: z28.string().uuid(),
  productId: z28.string().uuid().optional(),
  productName: z28.string().optional(),
  productCode: z28.string().optional(),
  productThumbnail: z28.string().optional(),
  quantity: z28.number().int(),
  reservedQuantity: z28.number().int(),
  fulfilledQuantity: z28.number().int(),
  unitPrice: z28.number(),
  lineTotal: z28.number(),
  requiresMetrcTracking: z28.boolean(),
  packageAllocations: z28.array(AdminPartitionItemPackageAllocationSchema)
});
var AdminPartitionDetailSchema = AdminPartitionListItemSchema.extend({
  items: z28.array(AdminPartitionItemDetailSchema),
  customerName: z28.string().optional(),
  customerPhone: z28.string().optional(),
  customerAddress: z28.string().optional(),
  customerNotes: z28.string().optional(),
  fulfillmentOffer: FulfillmentOfferSummarySchema.nullish(),
  stockLocationOrganizationId: z28.string().uuid().nullable(),
  stockLocationLicenseNumber: z28.string().nullable()
});
var OrderPartitionNoteDtoSchema = z28.object({
  id: z28.string().uuid(),
  orderPartitionId: z28.string().uuid(),
  portalUserId: z28.string().uuid(),
  authorName: z28.string(),
  authorEmail: z28.string(),
  content: z28.string(),
  isEdited: z28.boolean(),
  createdAt: z28.string(),
  updatedAt: z28.string()
});
var ListOrderPartitionNotesResponseSchema = z28.object({
  notes: z28.array(OrderPartitionNoteDtoSchema)
});
var CreateOrderPartitionNoteRequestSchema = z28.object({
  content: z28.string().trim().min(1).max(5e3)
});
var UpdateOrderPartitionNoteRequestSchema = z28.object({
  content: z28.string().trim().min(1).max(5e3)
});
var AdminPartitionListResponseSchema = z28.object({
  partitions: z28.array(AdminPartitionListItemSchema),
  nextCursor: z28.string().optional()
});
var CreateTestOrderItemSchema = z28.object({
  productId: z28.string().uuid(),
  productName: z28.string(),
  productCode: z28.string(),
  brandId: z28.string().uuid(),
  quantity: z28.number().int().positive(),
  unitPrice: z28.number().nonnegative()
});
var CreateTestOrderInputSchema = z28.object({
  customerId: z28.string().uuid(),
  items: z28.array(CreateTestOrderItemSchema).min(1),
  notes: z28.string().optional()
});
var TestOrderListItemSchema = z28.object({
  id: z28.string().uuid(),
  displayId: z28.number().int(),
  externalId: z28.string().nullable(),
  customerName: z28.string().nullable(),
  companyName: z28.string().nullable(),
  status: z28.string(),
  itemCount: z28.number().int(),
  total: z28.number(),
  partitionCount: z28.number().int(),
  createdAt: z28.string()
});
var TestOrderListResponseSchema = z28.object({
  orders: z28.array(TestOrderListItemSchema),
  total: z28.number().int()
});
var TestOrderDetailSchema = z28.object({
  id: z28.string().uuid(),
  displayId: z28.number().int(),
  externalId: z28.string().nullable(),
  customerName: z28.string().nullable(),
  companyName: z28.string().nullable(),
  email: z28.string().nullable(),
  status: z28.string(),
  paymentMethod: z28.string(),
  items: z28.array(z28.object({
    id: z28.string().uuid(),
    productName: z28.string().nullable(),
    productCode: z28.string().nullable(),
    quantity: z28.number().int(),
    unitPrice: z28.number(),
    lineTotal: z28.number()
  })),
  totals: z28.object({
    subtotal: z28.number(),
    total: z28.number(),
    itemCount: z28.number().int()
  }),
  partitions: z28.array(z28.object({
    id: z28.string().uuid(),
    brandId: z28.string().uuid(),
    brandName: z28.string().optional(),
    trackingId: z28.string(),
    portionTotal: z28.number(),
    fulfillmentStatus: z28.string(),
    itemCount: z28.number().int()
  })),
  createdAt: z28.string()
});
var CustomerSearchResultSchema = z28.object({
  id: z28.string().uuid(),
  externalId: z28.string().nullable(),
  companyName: z28.string().nullable(),
  contactName: z28.string().nullable(),
  email: z28.string().nullable()
});
var OrderExportRowSchema = z28.object({
  orderId: z28.string(),
  trackingId: z28.string(),
  orderDate: z28.string(),
  preparationStatus: z28.string(),
  paymentStatus: z28.string().nullable(),
  fulfillmentStatus: z28.string(),
  fulfillmentType: z28.string().nullable(),
  customerCompany: z28.string().nullable(),
  customerName: z28.string().nullable(),
  customerLicense: z28.string().nullable(),
  brandName: z28.string().nullable(),
  stockLocationName: z28.string().nullable(),
  paymentMethod: z28.string().nullable(),
  productCode: z28.string().nullable(),
  productName: z28.string().nullable(),
  quantity: z28.number(),
  unitPrice: z28.number(),
  lineTotal: z28.number(),
  orderSubtotal: z28.number(),
  orderTotal: z28.number()
});
var OrderExportResponseSchema = z28.object({
  rows: z28.array(OrderExportRowSchema),
  partitionCount: z28.number().int()
});
var portalAdminContract = c27.router({
  // ===========================================================================
  // Order Partition Endpoints
  // ===========================================================================
  /**
   * Get all order partitions with enriched data (brand names, stock locations).
   * Supports filtering by status, type, brand, and date range.
   */
  getAllOrderPartitions: {
    method: "GET",
    path: "/api/portal-admin/order-partitions",
    query: z28.object({
      fulfillmentStatus: OrderPartitionFulfillmentStatusSchema2.optional(),
      fulfillmentStatuses: FulfillmentStatusesQueryParamSchema2,
      preparationStatus: OrderPartitionPreparationStatusSchema.optional(),
      paymentStatus: OrderPartitionPaymentStatusSchema.optional(),
      fulfillmentType: OrderPartitionFulfillmentTypeSchema2.optional(),
      brandId: z28.string().uuid().optional(),
      trackingId: z28.string().optional(),
      productSku: z28.string().optional(),
      search: z28.string().optional(),
      stockLocationId: z28.string().uuid().optional(),
      fromDate: z28.string().optional(),
      toDate: z28.string().optional(),
      limit: z28.coerce.number().int().positive().max(100).optional().default(25),
      cursor: z28.string().optional()
    }),
    responses: {
      200: AdminPartitionListResponseSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get all order partitions (flote_admin only)"
  },
  /**
   * Export order partitions as denormalized rows (one row per line item).
   * Used for CSV export with optional date range filtering.
   */
  exportOrderPartitions: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/export",
    query: z28.object({
      fromDate: z28.string().optional(),
      toDate: z28.string().optional(),
      brandId: z28.string().uuid().optional()
    }),
    responses: {
      200: OrderExportResponseSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Export order partitions with line items for CSV (flote_admin only)"
  },
  /**
   * Get order partition details including items and customer info.
   */
  getOrderPartitionById: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/:id",
    pathParams: z28.object({ id: z28.string().uuid() }),
    responses: {
      200: AdminPartitionDetailSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get order partition details with items (flote_admin only)"
  },
  /**
   * Update an order partition (preparation status, fulfillment type/status, stock location).
   */
  updateOrderPartition: {
    method: "PATCH",
    path: "/api/portal-admin/order-partitions/:id",
    pathParams: z28.object({ id: z28.string().uuid() }),
    body: z28.object({
      preparationStatus: OrderPartitionPreparationStatusSchema.optional(),
      paymentStatus: OrderPartitionPaymentStatusSchema.nullable().optional(),
      fulfillmentType: OrderPartitionFulfillmentTypeSchema2.optional(),
      fulfillmentStatus: OrderPartitionFulfillmentStatusSchema2.optional(),
      stockLocationId: z28.string().uuid().nullable().optional()
    }),
    responses: {
      200: AdminPartitionListItemSchema,
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Update an order partition (flote_admin only)"
  },
  // ===========================================================================
  // Order Partition Notes Endpoints
  // ===========================================================================
  /**
   * List notes attached to an order partition (oldest first).
   */
  listOrderPartitionNotes: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/:partitionId/notes",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    responses: {
      200: ListOrderPartitionNotesResponseSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "List notes for an order partition"
  },
  /**
   * Add a new note to an order partition.
   */
  addOrderPartitionNote: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/notes",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    body: CreateOrderPartitionNoteRequestSchema,
    responses: {
      201: OrderPartitionNoteDtoSchema,
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Add a note to an order partition"
  },
  /**
   * Edit an existing note (author only).
   */
  editOrderPartitionNote: {
    method: "POST",
    path: "/api/portal-admin/order-partition-notes/:noteId/edit",
    pathParams: z28.object({ noteId: z28.string().uuid() }),
    body: UpdateOrderPartitionNoteRequestSchema,
    responses: {
      200: OrderPartitionNoteDtoSchema,
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Edit an order partition note (author only)"
  },
  /**
   * Soft-delete an existing note (author only).
   */
  deleteOrderPartitionNote: {
    method: "POST",
    path: "/api/portal-admin/order-partition-notes/:noteId/delete",
    pathParams: z28.object({ noteId: z28.string().uuid() }),
    body: z28.object({}),
    responses: {
      200: z28.object({ success: z28.boolean() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Soft-delete an order partition note (author only)"
  },
  /**
   * Assign a compliance license to the partition's destination organization location.
   */
  assignDestinationLicense: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:id/destination-license",
    pathParams: z28.object({ id: z28.string().uuid() }),
    body: z28.object({
      complianceLicenseId: z28.string().uuid()
    }),
    responses: {
      200: z28.object({ success: z28.boolean() }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Assign a destination compliance license to a partition (flote_admin only)"
  },
  // ===========================================================================
  // Transfer Template Endpoints (Metrc compliance — 1:1 with partitions)
  // ===========================================================================
  /**
   * Get the transfer template for a partition (if one exists).
   */
  getTransferTemplate: {
    method: "GET",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    responses: {
      200: z28.object({
        template: TransferTemplateDtoSchema.nullable(),
        segments: z28.array(TransferTemplateSegmentDtoSchema),
        handoffs: z28.array(TransferTemplateHandoffDtoSchema),
        layover: TransferTemplateLayoverDtoSchema.nullable(),
        assignedDriverId: z28.string().uuid().nullable()
      }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get transfer template for partition with structured children"
  },
  /**
   * Prepare a Metrc transfer manifest template for a partition.
   * Resolves all compliance data (licenses, driver, packages) and computes readiness.
   * Also assigns the selected driver to the partition for delivery.
   */
  prepareTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/prepare",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    body: PrepareTransferTemplateRequestSchema,
    responses: {
      200: z28.object({
        template: TransferTemplateDtoSchema,
        readiness: TransferTemplateReadinessDtoSchema
      }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Prepare transfer template for partition"
  },
  /**
   * Submit a prepared transfer template to Metrc.
   * Template must be in "ready" status.
   */
  submitTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/submit",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    body: z28.object({
      expectedVersion: z28.number().int().positive().optional()
    }),
    responses: {
      200: z28.object({ template: TransferTemplateDtoSchema }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Submit transfer template to Metrc"
  },
  /**
   * Update a submitted transfer template on Metrc.
   * Template must be in "submitted" status with a Metrc transfer ID.
   */
  updateTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/update",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    body: z28.object({
      expectedVersion: z28.number().int().positive().optional()
    }),
    responses: {
      200: z28.object({ template: TransferTemplateDtoSchema }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Update transfer template on Metrc"
  },
  /**
   * Void a submitted transfer template on Metrc.
   */
  voidTransferTemplate: {
    method: "POST",
    path: "/api/portal-admin/order-partitions/:partitionId/transfer-template/void",
    pathParams: z28.object({ partitionId: z28.string().uuid() }),
    body: z28.object({
      expectedVersion: z28.number().int().positive().optional()
    }),
    responses: {
      200: z28.object({ template: TransferTemplateDtoSchema }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Void transfer template on Metrc"
  },
  /**
   * Get compliance status for multiple partitions in a single batch query.
   * Used by Orders page to show compliance readiness badges.
   */
  getTransferTemplateBatchStatus: {
    method: "GET",
    path: "/api/portal-admin/transfer-templates/batch-status",
    query: z28.object({
      partitionIds: z28.string().min(1)
    }),
    responses: {
      200: z28.object({
        statuses: z28.record(z28.string(), TransferTemplateBatchStatusItemSchema)
      }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get transfer template compliance status for multiple partitions"
  },
  // ===========================================================================
  // Order Creation (supplier portal users with orders:create permission)
  // ===========================================================================
  /**
   * Create an order from the supplier portal.
   * Same partitioning logic as test orders but metadata.isTestOrder = false.
   * TODO(payment): Payment method hardcoded to COD.
   */
  createOrder: {
    method: "POST",
    path: "/api/portal-admin/orders",
    body: CreateTestOrderInputSchema,
    responses: {
      201: TestOrderDetailSchema,
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Create an order (requires orders:create permission)"
  },
  // ===========================================================================
  // Test Order Endpoints
  // ===========================================================================
  createTestOrder: {
    method: "POST",
    path: "/api/portal-admin/test-orders",
    body: CreateTestOrderInputSchema,
    responses: {
      201: TestOrderDetailSchema,
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Create a test order (flote_admin only)"
  },
  listTestOrders: {
    method: "GET",
    path: "/api/portal-admin/test-orders",
    query: z28.object({
      limit: z28.coerce.number().int().positive().max(100).optional().default(25),
      offset: z28.coerce.number().int().nonnegative().optional().default(0)
    }),
    responses: {
      200: TestOrderListResponseSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "List test orders (flote_admin only)"
  },
  getTestOrder: {
    method: "GET",
    path: "/api/portal-admin/test-orders/:id",
    pathParams: z28.object({ id: z28.string().uuid() }),
    responses: {
      200: TestOrderDetailSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get test order detail (flote_admin only)"
  },
  deleteTestOrder: {
    method: "DELETE",
    path: "/api/portal-admin/test-orders/:id",
    pathParams: z28.object({ id: z28.string().uuid() }),
    body: z28.undefined(),
    responses: {
      200: z28.object({ message: z28.string() }),
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Delete a test order (flote_admin only)"
  },
  // ===========================================================================
  // Customer Search Endpoint
  // ===========================================================================
  searchCustomers: {
    method: "GET",
    path: "/api/portal-admin/customers/search",
    query: z28.object({
      search: z28.string().min(1),
      limit: z28.coerce.number().int().positive().max(50).optional().default(20)
    }),
    responses: {
      200: z28.object({ customers: z28.array(CustomerSearchResultSchema) }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Search local customers by name or email (flote_admin only)"
  },
  // ===========================================================================
  // Customer Ordering Status Endpoints
  // ===========================================================================
  getCustomerOrderingStatus: {
    method: "GET",
    path: "/api/portal-admin/customers/:customerId/ordering-status",
    pathParams: z28.object({
      customerId: z28.coerce.number().int().positive()
    }),
    responses: {
      200: z28.object({
        customerId: z28.number(),
        companyName: z28.string().nullable(),
        email: z28.string(),
        disableOrdering: z28.boolean()
      }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Get ordering status for a customer (flote_admin only)"
  },
  updateCustomerOrderingStatus: {
    method: "PUT",
    path: "/api/portal-admin/customers/:customerId/ordering-status",
    pathParams: z28.object({
      customerId: z28.coerce.number().int().positive()
    }),
    body: z28.object({
      disableOrdering: z28.boolean()
    }),
    responses: {
      200: z28.object({
        customerId: z28.number(),
        disableOrdering: z28.boolean()
      }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Update ordering status for a customer (flote_admin only)"
  },
  // ===========================================================================
  // Package Allocation Tag Correction
  // ===========================================================================
  /**
   * Correct the package label on a package allocation.
   * Validates against Metrc API if configured. Blocks if inventory is consumed
   * or a manifest is already prepared/submitted.
   */
  // ===========================================================================
  // Legacy/Admin Metrc Package Compatibility Actions
  // ===========================================================================
  /**
   * Legacy/admin compatibility action for a human-reviewed finished Metrc package.
   * Product Detail sync must not call this as a generic reconciliation fallback.
   * Refuses when the package has active customer reservations.
   */
  markInventoryPackageFulfilled: {
    method: "POST",
    path: "/api/portal-admin/inventory-packages/:inventoryPackageId/mark-fulfilled",
    pathParams: z28.object({ inventoryPackageId: z28.string().uuid() }),
    body: z28.object({
      destinationLicenseNumber: z28.string().max(64).optional(),
      note: z28.string().max(500).optional()
    }),
    responses: {
      200: z28.object({ success: z28.literal(true) }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      409: z28.object({ code: z28.string(), message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Legacy/admin package fulfilled compatibility action"
  },
  /**
   * Legacy/admin incident compatibility action for human-confirmed physical package
   * loss. Active absence, 404, inactive, transferred, finished, discontinued, or
   * unknown Metrc state must not be treated as a physical loss incident by Product
   * Detail sync. Refuses when live reservations exist.
   */
  markInventoryPackageMissing: {
    method: "POST",
    path: "/api/portal-admin/inventory-packages/:inventoryPackageId/mark-missing",
    pathParams: z28.object({ inventoryPackageId: z28.string().uuid() }),
    body: z28.object({
      note: z28.string().max(500).optional()
    }),
    responses: {
      200: z28.object({ success: z28.literal(true) }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      409: z28.object({ code: z28.string(), message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Legacy/admin package incident compatibility action"
  },
  /**
   * Compatibility snapshot update for product_variants.metrc_item_id/name.
   * Durable package association belongs to Metrc item mapping authority.
   */
  relinkVariantMetrcItem: {
    method: "POST",
    path: "/api/portal-admin/product-variants/:variantId/relink-metrc",
    pathParams: z28.object({ variantId: z28.string().uuid() }),
    body: z28.object({
      metrcItemId: z28.number().int().positive(),
      metrcItemName: z28.string().min(1).max(255)
    }),
    responses: {
      200: z28.object({ success: z28.literal(true) }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Update variant Metrc item compatibility snapshot"
  },
  updatePackageAllocationMetrcTag: {
    method: "PATCH",
    path: "/api/portal-admin/package-allocations/:allocationId/metrc-tag",
    pathParams: z28.object({ allocationId: z28.string().uuid() }),
    body: z28.object({
      packageLabel: z28.string().max(24).nullable(),
      resolveConflict: z28.enum(["abort", "force_reassign"]).optional()
    }),
    responses: {
      200: AdminPackageAllocationMetrcTagUpdateResponseSchema,
      400: z28.object({ message: z28.string() }),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      409: AdminPackageAllocationMetrcTagConflictResponseSchema,
      422: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "Correct package label on a package allocation (flote_admin only)"
  },
  autoAssignPackageAllocations: {
    method: "POST",
    path: "/api/portal-admin/order-partition-items/:itemId/package-allocations",
    pathParams: z28.object({ itemId: z28.string().uuid() }),
    body: z28.object({
      mode: AutoAssignPackageAllocationsModeSchema
    }),
    responses: {
      200: AutoAssignPackageAllocationsResponseSchema,
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      404: z28.object({ message: z28.string() }),
      422: AutoAssignPackageAllocationsErrorResponseSchema,
      500: z28.object({ message: z28.string() })
    },
    summary: "Auto-assign Metrc package allocations to a partition item via the canonical reservation engine (FIFO)"
  },
  // ===========================================================================
  // Embed Configs (read-only listing for admin UI)
  // ===========================================================================
  listEmbedConfigs: {
    method: "GET",
    path: "/api/portal-admin/embed-configs",
    responses: {
      200: z28.array(EmbedConfigListItemDtoSchema),
      401: z28.object({ message: z28.string() }),
      403: z28.object({ message: z28.string() }),
      500: z28.object({ message: z28.string() })
    },
    summary: "List all embed configs with brand context (flote_admin only)"
  }
});

// src/http/licenses.contract.ts
import { initContract as initContract28 } from "@ts-rest/core";
import { z as z29 } from "zod";
import {
  LicenseDtoSchema,
  CreateLicenseDtoSchema,
  UpdateLicenseDtoSchema,
  LicenseStatusSchema,
  LicenseTypeSchema
} from "@flote/types/compliance";
var c28 = initContract28();
var licensesContract = c28.router({
  list: {
    method: "GET",
    path: "/api/compliance/licenses",
    query: z29.object({
      organizationId: z29.string().uuid().optional(),
      status: LicenseStatusSchema.optional(),
      licenseType: LicenseTypeSchema.optional()
    }),
    responses: {
      200: z29.array(LicenseDtoSchema),
      401: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "List licenses with optional filters"
  },
  getById: {
    method: "GET",
    path: "/api/compliance/licenses/:id",
    pathParams: z29.object({ id: z29.string().uuid() }),
    responses: {
      200: LicenseDtoSchema,
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Get a license by ID"
  },
  create: {
    method: "POST",
    path: "/api/compliance/licenses",
    body: CreateLicenseDtoSchema,
    responses: {
      201: LicenseDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      422: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Create a new license"
  },
  update: {
    method: "PATCH",
    path: "/api/compliance/licenses/:id",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: UpdateLicenseDtoSchema,
    responses: {
      200: LicenseDtoSchema,
      400: z29.object({ message: z29.string() }),
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      422: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Update an existing license"
  },
  delete: {
    method: "DELETE",
    path: "/api/compliance/licenses/:id",
    pathParams: z29.object({ id: z29.string().uuid() }),
    body: c28.noBody(),
    responses: {
      204: z29.void(),
      401: z29.object({ message: z29.string() }),
      404: z29.object({ message: z29.string() }),
      500: z29.object({ message: z29.string() })
    },
    summary: "Soft-delete a license"
  }
});

// src/http/promotions.contract.ts
import { initContract as initContract29 } from "@ts-rest/core";
import { z as z30 } from "zod";
import { BrandPromotionSpotlightDtoSchema, BrandCarouselItemDtoSchema } from "@flote/types/promotion";
var c29 = initContract29();
var promotionsContract = c29.router({
  getSpotlight: {
    method: "GET",
    path: "/api/promotions/spotlight",
    query: z30.object({ domain: z30.string().optional() }).optional(),
    responses: {
      200: BrandPromotionSpotlightDtoSchema.nullable(),
      500: z30.object({ message: z30.string() })
    },
    summary: "Get a randomly-selected active brand spotlight promotion"
  },
  getCarousel: {
    method: "GET",
    path: "/api/promotions/carousel",
    query: z30.object({ domain: z30.string().optional() }).optional(),
    responses: {
      200: z30.array(BrandCarouselItemDtoSchema),
      500: z30.object({ message: z30.string() })
    },
    summary: "Get all active brand promotions for the carousel"
  }
});

// src/http/organizations.contract.ts
import { initContract as initContract30 } from "@ts-rest/core";
import { z as z31 } from "zod";
import {
  OrganizationDtoSchema,
  OrganizationWithMembershipDtoSchema,
  OrganizationMemberDtoSchema,
  OrganizationLocationDtoSchema,
  OrganizationBankAccountDtoSchema,
  CreateOrganizationDtoSchema,
  UpdateOrganizationDtoSchema,
  CreateOrganizationLocationDtoSchema,
  UpdateOrganizationLocationDtoSchema,
  CreateOrganizationBankAccountDtoSchema,
  AddMemberDtoSchema,
  UpdateMemberRoleDtoSchema,
  OrganizationTypeSchema,
  OrgBrandWithDetailsDtoSchema,
  MemberStockLocationDtoSchema,
  MemberBrandDtoSchema,
  ScopeModeSchema,
  OnboardMemberDtoSchema,
  OnboardMemberResponseDtoSchema
} from "@flote/types/organization";
import {
  ProductStatusSchema,
  ProductTypeFilterSchema,
  ProductRealmSchema as ProductRealmSchema4,
  SupplierProductListingResponseSchema,
  ProductInventoryResponseSchema,
  ProductReservationsResponseSchema,
  BrandInventorySummaryResponseSchema,
  BrandProductInventoryResponseSchema,
  CreateProductInputSchema,
  CreatedProductDtoSchema,
  ProductCreationErrorSchema
} from "@flote/types/product";
import {
  StockLocationDetailDtoSchema as StockLocationDetailDtoSchema3,
  OrgBrandMetrcImportContextDtoSchema,
  StockLocationBrandAssignmentDtoSchema,
  UpdateStockLocationBrandAssignmentsDtoSchema,
  TransferListingResponseSchema as TransferListingResponseSchema2,
  InventoryTransferListingDtoSchema as InventoryTransferListingDtoSchema2,
  CreateInventoryTransferInputSchema as CreateInventoryTransferInputSchema2,
  UpdateTransferStatusInputSchema as UpdateTransferStatusInputSchema2,
  InventoryListingResponseSchema as InventoryListingResponseSchema2,
  CreateOrgStockLocationInputSchema,
  MetrcCsvImportInputSchema,
  MetrcCsvImportResponseSchema,
  MetrcPackageFetchResponseSchema,
  MetrcPackageListingQuerySchema,
  MetrcPackageListingResponseSchema,
  MetrcPackageRemoveRequestSchema,
  MetrcPackageRemoveResponseSchema
} from "@flote/types/inventory";
import {
  MetrcFindCandidatesRequestSchema,
  MetrcFindCandidatesResponseSchema,
  MetrcImportPackagesRequestSchema,
  MetrcImportResultResponseSchema
} from "@flote/types/metrc-inventory";
var c30 = initContract30();
var organizationsMeContract = c30.router({
  getMyOrganization: {
    method: "GET",
    path: "/api/organizations/me",
    responses: {
      200: OrganizationWithMembershipDtoSchema,
      401: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get the authenticated customer's organization and membership"
  },
  getMyMembers: {
    method: "GET",
    path: "/api/organizations/me/members",
    responses: {
      200: z31.array(OrganizationMemberDtoSchema),
      401: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List members of the authenticated customer's organization"
  },
  getMyLocations: {
    method: "GET",
    path: "/api/organizations/me/locations",
    responses: {
      200: z31.array(OrganizationLocationDtoSchema),
      401: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List locations (shipping destinations) for the authenticated customer's organization"
  },
  createMyLocation: {
    method: "POST",
    path: "/api/organizations/me/locations",
    body: CreateOrganizationLocationDtoSchema,
    responses: {
      201: OrganizationLocationDtoSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Create a location (org admin only)"
  },
  updateMyLocation: {
    method: "PUT",
    path: "/api/organizations/me/locations/:locationId",
    pathParams: z31.object({ locationId: z31.string().uuid() }),
    body: UpdateOrganizationLocationDtoSchema,
    responses: {
      200: OrganizationLocationDtoSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Update a location (org admin only)"
  },
  deleteMyLocation: {
    method: "DELETE",
    path: "/api/organizations/me/locations/:locationId",
    pathParams: z31.object({ locationId: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Delete a location (org admin only)"
  },
  getMyBankAccounts: {
    method: "GET",
    path: "/api/organizations/me/bank-accounts",
    responses: {
      200: z31.array(OrganizationBankAccountDtoSchema),
      401: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List shared bank accounts for the authenticated customer's organization"
  },
  createMyBankAccount: {
    method: "POST",
    path: "/api/organizations/me/bank-accounts",
    body: CreateOrganizationBankAccountDtoSchema,
    responses: {
      201: OrganizationBankAccountDtoSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Add a shared bank account (org admin only)"
  },
  deleteMyBankAccount: {
    method: "DELETE",
    path: "/api/organizations/me/bank-accounts/:bankAccountId",
    pathParams: z31.object({ bankAccountId: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Remove a shared bank account (org admin only)"
  }
});
var organizationsAdminContract = c30.router({
  list: {
    method: "GET",
    path: "/api/admin/organizations",
    query: z31.object({
      type: OrganizationTypeSchema.optional(),
      isActive: z31.coerce.boolean().optional(),
      search: z31.string().optional()
    }),
    responses: {
      200: z31.array(OrganizationDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List all organizations (admin)"
  },
  create: {
    method: "POST",
    path: "/api/admin/organizations",
    body: CreateOrganizationDtoSchema,
    responses: {
      201: OrganizationDtoSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Create a new organization (admin)"
  },
  getById: {
    method: "GET",
    path: "/api/admin/organizations/:id",
    pathParams: z31.object({ id: z31.string().uuid() }),
    responses: {
      200: OrganizationDtoSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get organization by ID (admin)"
  },
  update: {
    method: "PUT",
    path: "/api/admin/organizations/:id",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: UpdateOrganizationDtoSchema,
    responses: {
      200: OrganizationDtoSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Update an organization (admin)"
  },
  deactivate: {
    method: "DELETE",
    path: "/api/admin/organizations/:id",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Deactivate an organization (admin)"
  },
  getMembers: {
    method: "GET",
    path: "/api/admin/organizations/:id/members",
    pathParams: z31.object({ id: z31.string().uuid() }),
    responses: {
      200: z31.array(OrganizationMemberDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List members of an organization (admin)"
  },
  addMember: {
    method: "POST",
    path: "/api/admin/organizations/:id/members",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: AddMemberDtoSchema,
    responses: {
      201: OrganizationMemberDtoSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      409: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Add a member to an organization (admin)"
  },
  removeMember: {
    method: "DELETE",
    path: "/api/admin/organizations/:id/members/:memberId",
    pathParams: z31.object({ id: z31.string().uuid(), memberId: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Remove a member from an organization (admin)"
  },
  updateMemberRole: {
    method: "PUT",
    path: "/api/admin/organizations/:id/members/:memberId/role",
    pathParams: z31.object({ id: z31.string().uuid(), memberId: z31.string().uuid() }),
    body: UpdateMemberRoleDtoSchema,
    responses: {
      200: OrganizationMemberDtoSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Update a member's role (admin)"
  },
  getLocations: {
    method: "GET",
    path: "/api/admin/organizations/:id/locations",
    pathParams: z31.object({ id: z31.string().uuid() }),
    responses: {
      200: z31.array(OrganizationLocationDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List locations for an organization (admin)"
  },
  createLocation: {
    method: "POST",
    path: "/api/admin/organizations/:id/locations",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: CreateOrganizationLocationDtoSchema,
    responses: {
      201: OrganizationLocationDtoSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Add a location to an organization (admin)"
  },
  getOrgBrands: {
    method: "GET",
    path: "/api/admin/organizations/:id/brands",
    pathParams: z31.object({ id: z31.string().uuid() }),
    responses: {
      200: z31.array(OrgBrandWithDetailsDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List brands assigned to an organization (admin)"
  },
  addOrgBrand: {
    method: "PUT",
    path: "/api/admin/organizations/:id/brands/:brandId",
    pathParams: z31.object({ id: z31.string().uuid(), brandId: z31.string().uuid() }),
    body: z31.object({}),
    responses: {
      200: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      409: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Assign a brand to an organization (admin)"
  },
  removeOrgBrand: {
    method: "DELETE",
    path: "/api/admin/organizations/:id/brands/:brandId",
    pathParams: z31.object({ id: z31.string().uuid(), brandId: z31.string().uuid() }),
    body: z31.object({}),
    responses: {
      200: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Remove a brand from an organization (admin)"
  },
  onboardMember: {
    method: "POST",
    path: "/api/admin/organizations/:id/members/onboard",
    pathParams: z31.object({ id: z31.string().uuid() }),
    body: OnboardMemberDtoSchema,
    responses: {
      201: OnboardMemberResponseDtoSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      409: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Create a portal user and org member in one step (admin)"
  }
});
var organizationsPortalContract = c30.router({
  getOrgBrands: {
    method: "GET",
    path: "/api/organizations/:orgId/brands",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    responses: {
      200: z31.array(OrgBrandWithDetailsDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get brands associated with an organization (portal auth)"
  },
  getOrgBrandMetrcImportContext: {
    method: "GET",
    path: "/api/organizations/:orgId/brands/:brandId/metrc-import-context",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      brandId: z31.string().uuid()
    }),
    responses: {
      200: OrgBrandMetrcImportContextDtoSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Resolve METRC import context for an org brand (portal auth)"
  },
  getOrgStockLocationBrandAssignments: {
    method: "GET",
    path: "/api/organizations/:orgId/stock-locations/:locationId/brand-assignments",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      locationId: z31.string().uuid()
    }),
    responses: {
      200: z31.array(StockLocationBrandAssignmentDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get brand assignments for an org stock location (portal auth)"
  },
  updateOrgStockLocationBrandAssignments: {
    method: "PUT",
    path: "/api/organizations/:orgId/stock-locations/:locationId/brand-assignments",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      locationId: z31.string().uuid()
    }),
    body: UpdateStockLocationBrandAssignmentsDtoSchema,
    responses: {
      200: z31.array(StockLocationBrandAssignmentDtoSchema),
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Update brand assignments for an org stock location (portal auth)"
  },
  getMemberStockLocations: {
    method: "GET",
    path: "/api/organizations/:orgId/members/:memberId/stock-locations",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      memberId: z31.string().uuid()
    }),
    responses: {
      200: z31.array(MemberStockLocationDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get stock locations accessible to a member (portal auth)"
  },
  getOrgStockLocations: {
    method: "GET",
    path: "/api/organizations/:orgId/stock-locations",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    responses: {
      200: z31.array(StockLocationDetailDtoSchema3),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get stock locations accessible to current member with full details"
  },
  createOrgStockLocation: {
    method: "POST",
    path: "/api/organizations/:orgId/stock-locations",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    body: CreateOrgStockLocationInputSchema,
    responses: {
      201: StockLocationDetailDtoSchema3,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Create a stock location within an organization (portal auth)"
  },
  // =========================================================================
  // Member brand access
  // =========================================================================
  getMemberBrands: {
    method: "GET",
    path: "/api/organizations/:orgId/members/:memberId/brands",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      memberId: z31.string().uuid()
    }),
    responses: {
      200: z31.array(MemberBrandDtoSchema),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get brand access records for a member (portal auth)"
  },
  grantMemberBrandAccess: {
    method: "PUT",
    path: "/api/organizations/:orgId/members/:memberId/brands/:brandId",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      memberId: z31.string().uuid(),
      brandId: z31.string().uuid()
    }),
    body: z31.object({
      canView: z31.boolean().optional(),
      canEdit: z31.boolean().optional()
    }),
    responses: {
      200: MemberBrandDtoSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Grant a member access to a brand (portal auth, MEMBERS_MANAGE)"
  },
  revokeMemberBrandAccess: {
    method: "DELETE",
    path: "/api/organizations/:orgId/members/:memberId/brands/:brandId",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      memberId: z31.string().uuid(),
      brandId: z31.string().uuid()
    }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Revoke a member's access to a brand (portal auth, MEMBERS_MANAGE)"
  },
  updateMemberScope: {
    method: "PATCH",
    path: "/api/organizations/:orgId/members/:memberId/scope",
    pathParams: z31.object({
      orgId: z31.string().uuid(),
      memberId: z31.string().uuid()
    }),
    body: z31.object({
      brandScopeMode: ScopeModeSchema.optional(),
      locationScopeMode: ScopeModeSchema.optional()
    }),
    responses: {
      200: z31.object({
        id: z31.string(),
        brandScopeMode: ScopeModeSchema,
        locationScopeMode: ScopeModeSchema
      }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Update a member's brand/location scope modes (portal auth, MEMBERS_MANAGE)"
  },
  // =========================================================================
  // Org-scoped product and inventory endpoints
  // =========================================================================
  getOrgProducts: {
    method: "GET",
    path: "/api/organizations/:orgId/products",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    query: z31.object({
      page: z31.coerce.number().int().positive().optional().default(1),
      pageSize: z31.coerce.number().int().positive().max(100).optional().default(25),
      status: ProductStatusSchema.optional(),
      search: z31.string().optional(),
      brandId: z31.string().uuid().optional(),
      excludeLocationId: z31.string().uuid().optional(),
      productType: ProductTypeFilterSchema.optional(),
      realm: ProductRealmSchema4.optional()
    }),
    responses: {
      200: SupplierProductListingResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get paginated products for an organization (portal auth)"
  },
  getOrgProductInventory: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/inventory",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    responses: {
      200: ProductInventoryResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get product inventory across org-accessible locations (portal auth)"
  },
  getOrgProductReservations: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/reservations",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    query: z31.object({
      locationId: z31.string().uuid().optional(),
      inventoryPackageId: z31.string().uuid().optional()
    }),
    responses: {
      200: ProductReservationsResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get active inventory reservations for a product (portal auth)"
  },
  listProductMetrcPackages: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/metrc-packages",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    query: MetrcPackageListingQuerySchema,
    responses: {
      200: MetrcPackageListingResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List Metrc packages for a product, filtered by active/inactive status (portal auth)"
  },
  removeProductMetrcPackages: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/metrc-packages/remove",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: MetrcPackageRemoveRequestSchema,
    responses: {
      200: MetrcPackageRemoveResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }).and(z31.object({ missingPackageIds: z31.array(z31.string().uuid()).optional() }).partial()),
      409: z31.object({
        message: z31.string(),
        code: z31.string().optional(),
        catalogCode: z31.string().optional(),
        userMessage: z31.string().optional()
      }).and(
        z31.object({
          blockedPackageIds: z31.array(z31.string().uuid()).optional()
        }).partial()
      ),
      500: z31.object({ message: z31.string() })
    },
    summary: "Hard-delete Metrc packages in bulk. All-or-nothing: if any package has reservations, returns 409 with blockedPackageIds (portal auth, PRODUCTS_EDIT permission required)"
  },
  getOrgBrandInventorySummaries: {
    method: "GET",
    path: "/api/organizations/:orgId/brands/inventory",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    responses: {
      200: BrandInventorySummaryResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get brand-level inventory summaries for an organization (portal auth)"
  },
  getOrgBrandProductInventory: {
    method: "GET",
    path: "/api/organizations/:orgId/brands/:brandId/product-inventory",
    pathParams: z31.object({ orgId: z31.string().uuid(), brandId: z31.string().uuid() }),
    query: z31.object({
      page: z31.coerce.number().int().positive().optional().default(1),
      pageSize: z31.coerce.number().int().positive().max(100).optional().default(25),
      search: z31.string().optional()
    }),
    responses: {
      200: BrandProductInventoryResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get products with inventory for a brand within an organization (portal auth)"
  },
  // =========================================================================
  // Organization lookup for portal features (e.g., special pricing pickers).
  // Returns a narrow, safe projection — no member/location/brand data — gated
  // by feature-level permissions (not platform-admin). Lets a supplier pick an
  // org to scope things to without needing MEMBERS_VIEW.
  // =========================================================================
  searchOrganizations: {
    method: "GET",
    path: "/api/organizations/search",
    query: z31.object({
      q: z31.string().trim().min(1).optional(),
      type: OrganizationTypeSchema.optional(),
      // Picker loads all orgs client-side and filters locally; cap guards
      // against future pathological tenants. Switch to debounced server-side
      // search if tenants routinely exceed this.
      limit: z31.coerce.number().int().positive().max(1e3).optional().default(500)
    }),
    responses: {
      200: z31.object({
        organizations: z31.array(
          z31.object({
            id: z31.string().uuid(),
            name: z31.string(),
            slug: z31.string().nullable(),
            type: OrganizationTypeSchema
          })
        )
      }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Search active organizations for portal pickers (portal auth + feature permission)"
  },
  // =========================================================================
  // Buyer customers (members of a buyer org linked to a customer.customers row)
  // =========================================================================
  getBuyerCustomers: {
    method: "GET",
    path: "/api/organizations/:orgId/buyer-customers",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    query: z31.object({
      q: z31.string().trim().min(1).optional(),
      limit: z31.coerce.number().int().positive().max(50).optional().default(20)
    }),
    responses: {
      200: z31.object({
        customers: z31.array(
          z31.object({
            customerUuid: z31.string().uuid(),
            companyName: z31.string(),
            contactName: z31.string().nullable(),
            email: z31.string(),
            memberId: z31.string().uuid()
          })
        )
      }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Search customers within a buyer organization (portal auth)"
  },
  // =========================================================================
  // Org-scoped transfer endpoints
  // =========================================================================
  getOrgTransfers: {
    method: "GET",
    path: "/api/organizations/:orgId/transfers",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    query: z31.object({
      stockLocationId: z31.string().uuid().optional(),
      productId: z31.string().uuid().optional(),
      status: z31.enum(["pending", "in_transit", "completed", "cancelled"]).optional(),
      direction: z31.enum(["incoming", "outgoing", "all"]).optional().default("all"),
      page: z31.coerce.number().int().positive().optional().default(1),
      pageSize: z31.coerce.number().int().positive().max(100).optional().default(25)
    }),
    responses: {
      200: TransferListingResponseSchema2,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "List inventory transfers for member within an organization (portal auth)"
  },
  getOrgTransfer: {
    method: "GET",
    path: "/api/organizations/:orgId/transfers/:transferId",
    pathParams: z31.object({ orgId: z31.string().uuid(), transferId: z31.string().uuid() }),
    responses: {
      200: InventoryTransferListingDtoSchema2,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get a single inventory transfer (portal auth)"
  },
  createOrgTransfer: {
    method: "POST",
    path: "/api/organizations/:orgId/transfers",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    body: CreateInventoryTransferInputSchema2,
    responses: {
      201: InventoryTransferListingDtoSchema2,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      422: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Create an inventory transfer within an organization (portal auth)"
  },
  updateOrgTransferStatus: {
    method: "PATCH",
    path: "/api/organizations/:orgId/transfers/:transferId/status",
    pathParams: z31.object({ orgId: z31.string().uuid(), transferId: z31.string().uuid() }),
    body: UpdateTransferStatusInputSchema2,
    responses: {
      200: InventoryTransferListingDtoSchema2,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      409: z31.object({ message: z31.string() }),
      422: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Update transfer status within an organization (portal auth)"
  },
  // =========================================================================
  // Org-scoped product mutation endpoints
  // =========================================================================
  createOrgProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    body: CreateProductInputSchema,
    responses: {
      201: CreatedProductDtoSchema,
      400: ProductCreationErrorSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      422: ProductCreationErrorSchema,
      500: z31.object({ message: z31.string() })
    },
    summary: "Create a new product within an organization (portal auth)"
  },
  deactivateOrgProduct: {
    method: "DELETE",
    path: "/api/organizations/:orgId/products/:productId",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      502: z31.object({ message: z31.string() })
    },
    summary: "Deactivate a product within an organization (portal auth)"
  },
  reactivateOrgProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/reactivate",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      204: z31.void(),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      502: z31.object({ message: z31.string() })
    },
    summary: "Reactivate a product within an organization (portal auth)"
  },
  publishOrgProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/publish",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: c30.noBody(),
    responses: {
      200: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      409: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Publish a draft product within an organization (portal auth)"
  },
  // =========================================================================
  // Metrc CSV Import
  // =========================================================================
  importMetrcCsv: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/metrc-csv-import",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: MetrcCsvImportInputSchema,
    responses: {
      200: MetrcCsvImportResponseSchema,
      400: z31.object({ message: z31.string() }),
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      422: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Import Metrc CSV data to update product inventory (portal auth)"
  },
  fetchMetrcPackagesForProduct: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/metrc-package-fetch",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: z31.object({
      licenseNumber: z31.string().min(1),
      itemFilter: z31.string().min(1, "Item filter is required")
    }),
    responses: {
      200: MetrcPackageFetchResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      422: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Fetch active Metrc packages for a product via API (portal auth)"
  },
  /**
   * Layered Metrc matcher — tries a pinned item snapshot, then the raw product
   * title, then generated heuristic fallbacks. Returns candidate packages, drift
   * reconciliation rows for existing packages, and the "already imported" set in a single call.
   */
  findMetrcCandidatePackages: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/metrc-find-candidates",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    query: MetrcFindCandidatesRequestSchema,
    responses: {
      200: MetrcFindCandidatesResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      422: z31.object({ code: z31.string().optional(), message: z31.string() }),
      500: z31.object({ code: z31.string().optional(), message: z31.string() }),
      502: z31.object({ code: z31.string().optional(), message: z31.string() })
    },
    summary: "Find Metrc packages for a product via the layered matcher (portal auth)"
  },
  /**
   * Persist caller-selected package labels as local inventory packages. Re-fetches each
   * package label from Metrc and pins the variant to the discovered Metrc item on success.
   */
  importMetrcPackages: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/metrc-import-packages",
    pathParams: z31.object({ orgId: z31.string().uuid(), productId: z31.string().uuid() }),
    body: MetrcImportPackagesRequestSchema,
    responses: {
      200: MetrcImportResultResponseSchema,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      422: z31.object({ code: z31.string().optional(), message: z31.string() }),
      500: z31.object({ code: z31.string().optional(), message: z31.string() }),
      502: z31.object({ code: z31.string().optional(), message: z31.string() })
    },
    summary: "Import selected Metrc packages into inventory (portal auth)"
  },
  // =========================================================================
  // Org-Scoped Inventory Endpoints
  // =========================================================================
  // =========================================================================
  // Transporter license management
  // =========================================================================
  setTransporterLicense: {
    method: "POST",
    path: "/api/organizations/:orgId/transporter-license",
    pathParams: z31.object({ orgId: z31.string().uuid() }),
    body: z31.object({ licenseNumber: z31.string().min(1) }),
    responses: {
      200: OrganizationDtoSchema,
      400: z31.object({ message: z31.string() }),
      404: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Set the transporter license for an organization (portal auth)"
  },
  getOrgStockLocationInventory: {
    method: "GET",
    path: "/api/organizations/:orgId/stock-locations/:locationId/inventory",
    pathParams: z31.object({ orgId: z31.string().uuid(), locationId: z31.string().uuid() }),
    query: z31.object({
      brandId: z31.string().uuid().optional(),
      search: z31.string().optional(),
      productType: ProductTypeFilterSchema.optional(),
      page: z31.coerce.number().int().min(1).default(1),
      pageSize: z31.coerce.number().int().min(1).max(100).default(50)
    }),
    responses: {
      200: InventoryListingResponseSchema2,
      401: z31.object({ message: z31.string() }),
      403: z31.object({ message: z31.string() }),
      500: z31.object({ message: z31.string() })
    },
    summary: "Get inventory at a stock location filtered by org brands (portal auth)"
  }
});

// src/http/metrc.contract.ts
import { initContract as initContract31 } from "@ts-rest/core";
import { z as z32 } from "zod";
var c31 = initContract31();
var MetrcItemCategoryDtoSchema = z32.object({
  name: z32.string().nullable(),
  productCategoryType: z32.string().nullable(),
  quantityType: z32.string().nullable(),
  requiresStrain: z32.boolean().nullable(),
  requiresItemBrand: z32.boolean().nullable(),
  requiresAdministrationMethod: z32.boolean().nullable(),
  requiresUnitCbdPercent: z32.boolean().nullable(),
  requiresUnitCbdContent: z32.boolean().nullable(),
  requiresUnitThcPercent: z32.boolean().nullable(),
  requiresUnitThcContent: z32.boolean().nullable(),
  requiresUnitVolume: z32.boolean().nullable(),
  requiresUnitWeight: z32.boolean().nullable(),
  requiresServingSize: z32.boolean().nullable(),
  requiresSupplyDurationDays: z32.boolean().nullable(),
  requiresNumberOfDoses: z32.boolean().nullable(),
  requiresIngredients: z32.boolean().nullable(),
  requiresDescription: z32.boolean().nullable()
});
var MetrcStrainDtoSchema = z32.object({
  id: z32.number(),
  name: z32.string().nullable(),
  testingStatus: z32.string().nullable(),
  thcLevel: z32.number().nullable(),
  cbdLevel: z32.number().nullable(),
  indicaPercentage: z32.number(),
  sativaPercentage: z32.number(),
  isUsed: z32.boolean(),
  genetics: z32.string().nullable()
});
var MetrcItemDtoSchema = z32.object({
  id: z32.number(),
  name: z32.string().nullable(),
  productCategoryName: z32.string().nullable(),
  productCategoryType: z32.string().nullable(),
  quantityType: z32.string().nullable(),
  unitOfMeasureName: z32.string().nullable(),
  approvalStatus: z32.string().nullable(),
  strainId: z32.number().nullable(),
  strainName: z32.string().nullable(),
  unitThcPercent: z32.number().nullable(),
  unitCbdPercent: z32.number().nullable(),
  unitWeight: z32.number().nullable(),
  unitWeightUnitOfMeasureName: z32.string().nullable(),
  isUsed: z32.boolean().nullable(),
  /** Whether this item is active in Metrc (false = deactivated but may still have active packages) */
  isActive: z32.boolean()
});
var MetrcUnitOfMeasureDtoSchema = z32.object({
  name: z32.string(),
  quantityType: z32.string().nullable(),
  abbreviation: z32.string().nullable()
});
var MetrcFacilityLicenseDtoSchema = z32.object({
  licenseNumber: z32.string(),
  facilityName: z32.string().nullable(),
  displayName: z32.string().nullable(),
  isOwner: z32.boolean(),
  isManager: z32.boolean()
});
var ErrorResponseSchema3 = z32.object({ message: z32.string() });
var LicenseNumberQuerySchema = z32.object({
  licenseNumber: z32.string().min(1)
});
var metrcReferenceContract = c31.router({
  /** List METRC facilities/licenses available to the authenticated API user */
  listFacilities: {
    method: "GET",
    path: "/api/metrc/facilities",
    responses: {
      200: z32.array(MetrcFacilityLicenseDtoSchema),
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "List METRC facilities/licenses"
  },
  /** List METRC item categories for a license */
  listItemCategories: {
    method: "GET",
    path: "/api/metrc/item-categories",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z32.array(MetrcItemCategoryDtoSchema),
      400: ErrorResponseSchema3,
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "List METRC item categories"
  },
  /** List METRC strains for a license */
  listStrains: {
    method: "GET",
    path: "/api/metrc/strains",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z32.array(MetrcStrainDtoSchema),
      400: ErrorResponseSchema3,
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "List METRC strains"
  },
  /** List all facility catalog METRC items (active + inactive) for a license */
  listItems: {
    method: "GET",
    path: "/api/metrc/items",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z32.array(MetrcItemDtoSchema),
      400: ErrorResponseSchema3,
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "List METRC catalog items"
  },
  /** Deprecated: list METRC items that currently have active packages for a license */
  listImportableItems: {
    method: "GET",
    path: "/api/metrc/importable-items",
    query: LicenseNumberQuerySchema,
    responses: {
      410: ErrorResponseSchema3
    },
    summary: "Deprecated: use /api/metrc/items for item-catalog imports"
  },
  /** List METRC units of measure for a license */
  listUnitsOfMeasure: {
    method: "GET",
    path: "/api/metrc/units-of-measure",
    query: LicenseNumberQuerySchema,
    responses: {
      200: z32.array(MetrcUnitOfMeasureDtoSchema),
      400: ErrorResponseSchema3,
      401: ErrorResponseSchema3,
      403: ErrorResponseSchema3,
      500: ErrorResponseSchema3
    },
    summary: "List METRC units of measure"
  }
});

// src/http/metrc-inventory-engine.contract.ts
import { initContract as initContract32 } from "@ts-rest/core";
import {
  GetBestMetrcPackageMovementEvidenceInputSchema,
  CreateMetrcPackageHoldsInputSchema,
  ExpireMetrcPackageHoldsInputSchema,
  ListMetrcItemMappingsInputSchema,
  ListMetrcPackageHoldsInputSchema,
  ListMetrcPackageMovementEvidenceInputSchema,
  ListMetrcPackagePublicationsInputSchema,
  ListMetrcPackageStagingInputSchema,
  ListMetrcPackageStagingAggregatesInputSchema,
  MetrcPackageHoldListResponseSchema,
  MetrcPackageHoldOperationResultSchema,
  MetrcPackageHoldOwnerTypeSchema,
  MetrcPackageHoldReasonSchema,
  MetrcPackageHoldSourceSchema,
  MetrcPackageHoldStatusSchema,
  MetrcItemMappingListResponseSchema,
  MetrcItemMappingSchema,
  MetrcItemMappingSourceSchema,
  MetrcItemMappingStatusSchema,
  MetrcPackageMovementEvidenceListResponseSchema,
  MetrcPackageMovementEvidenceSchema,
  MetrcInventoryDiscrepancyClassSchema,
  MetrcInventoryDiscrepancyListSchema,
  MetrcInventoryDiscrepancyStatusSchema,
  MetrcInventoryComparisonReportSchema,
  MetrcPackagePublicationListResponseSchema,
  MetrcPackagePublicationOperationResultSchema,
  MetrcPackagePublicationSourceSchema,
  MetrcPackagePublicationStatusSchema,
  MetrcPackageStagingListResponseSchema,
  MetrcPackageStagingAggregatesResponseSchema,
  MetrcPackageStagingStateSchema,
  MetrcItemMappingUpsertInputSchema,
  PublishMetrcPackagesInputSchema,
  MetrcPackageSyncStateSchema,
  ReleaseMetrcPackageHoldsInputSchema,
  SyncActiveMetrcPackagesResultSchema,
  SyncMetrcFacilityPackageStatesResultSchema,
  SyncMetrcPackageStateResultSchema,
  SyncOutgoingTransferEvidenceInputSchema,
  SyncOutgoingTransferEvidenceResultSchema,
  TargetedMetrcPackageMovementEvidenceBackfillInputSchema,
  TargetedMetrcPackageMovementEvidenceBackfillResultSchema,
  UnpublishMetrcPackagesInputSchema
} from "@flote/types/metrc-inventory";
import { z as z33 } from "zod";
var c32 = initContract32();
var MetrcInventoryEngineErrorResponseSchema = z33.object({
  message: z33.string(),
  code: z33.string().optional()
});
var SyncActiveMetrcPackagesBodySchema = z33.object({
  mode: z33.enum(["full", "delta", "manual"]).default("manual"),
  windowStart: z33.string().datetime().optional(),
  windowEnd: z33.string().datetime().optional()
});
var FacilityPathParamsSchema = z33.object({
  orgId: z33.string().uuid(),
  facilityLicenseNumber: z33.string().min(1)
});
var PackageStatePathParamsSchema = FacilityPathParamsSchema.extend({
  metrcState: MetrcPackageSyncStateSchema
});
var PackageMovementEvidencePathParamsSchema = FacilityPathParamsSchema.extend({
  packageLabel: z33.string().min(1)
});
var ListMetrcInventoryDiscrepanciesQuerySchema = z33.object({
  status: MetrcInventoryDiscrepancyStatusSchema.optional(),
  discrepancyClass: MetrcInventoryDiscrepancyClassSchema.optional()
});
var optionalQueryArray = (itemSchema) => z33.preprocess((value) => {
  if (value === void 0 || value === null || value === "") return void 0;
  const values = (Array.isArray(value) ? value : [value]).flatMap((entry) => {
    if (typeof entry !== "string") return [entry];
    return entry.split(",").map((part) => part.trim()).filter(Boolean);
  }).filter((entry) => entry !== void 0 && entry !== null && entry !== "");
  return values.length > 0 ? values : void 0;
}, z33.array(itemSchema).optional());
var OptionalQueryBooleanSchema = z33.preprocess((value) => {
  if (value === void 0 || typeof value === "boolean") return value;
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
}, z33.boolean().optional());
var SyncOutgoingTransferEvidenceBodySchema = SyncOutgoingTransferEvidenceInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  memberId: true
}).extend({
  mode: z33.enum(["full", "delta", "manual"]).default("manual")
});
var TargetedMovementEvidenceBackfillBodySchema = TargetedMetrcPackageMovementEvidenceBackfillInputSchema.omit({
  organizationId: true,
  sourceFacilityLicenseNumber: true
});
var ListMovementEvidenceQuerySchema = ListMetrcPackageMovementEvidenceInputSchema.omit({
  organizationId: true,
  sourceFacilityLicenseNumber: true,
  transferId: true,
  deliveryId: true,
  pageNumber: true,
  pageSize: true
}).extend({
  transferId: z33.coerce.number().int().optional(),
  deliveryId: z33.coerce.number().int().optional(),
  pageNumber: z33.coerce.number().int().min(1).optional(),
  pageSize: z33.coerce.number().int().min(1).max(100).optional()
});
var GetBestMovementEvidenceQuerySchema = GetBestMetrcPackageMovementEvidenceInputSchema.pick({
  movementType: true
}).partial();
var UpsertMetrcItemMappingBodySchema = MetrcItemMappingUpsertInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  createdByMemberId: true,
  updatedByMemberId: true
});
var ListMetrcItemMappingsQuerySchema = ListMetrcItemMappingsInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  includeOrganizationWide: true,
  mappingStatuses: true,
  mappingSources: true,
  metrcItemIds: true,
  productIds: true,
  productVariantIds: true,
  pageNumber: true,
  pageSize: true
}).extend({
  includeOrganizationWide: OptionalQueryBooleanSchema,
  mappingStatuses: optionalQueryArray(MetrcItemMappingStatusSchema),
  mappingSources: optionalQueryArray(MetrcItemMappingSourceSchema),
  metrcItemIds: optionalQueryArray(z33.coerce.number().int()),
  productIds: optionalQueryArray(z33.string().uuid()),
  productVariantIds: optionalQueryArray(z33.string().uuid()),
  pageNumber: z33.coerce.number().int().min(1).optional(),
  pageSize: z33.coerce.number().int().min(1).max(100).optional()
});
var ListMetrcPackagePublicationsQuerySchema = ListMetrcPackagePublicationsInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  publicationStatuses: true,
  publicationSources: true,
  inventoryPackageIds: true,
  packageLabels: true,
  metrcItemIds: true,
  productVariantIds: true,
  pageNumber: true,
  pageSize: true
}).extend({
  publicationStatuses: optionalQueryArray(MetrcPackagePublicationStatusSchema),
  publicationSources: optionalQueryArray(MetrcPackagePublicationSourceSchema),
  inventoryPackageIds: optionalQueryArray(z33.string().uuid()),
  packageLabels: optionalQueryArray(z33.string().min(1)),
  metrcItemIds: optionalQueryArray(z33.coerce.number().int()),
  productVariantIds: optionalQueryArray(z33.string().uuid()),
  pageNumber: z33.coerce.number().int().min(1).optional(),
  pageSize: z33.coerce.number().int().min(1).max(100).optional()
});
var PublishMetrcPackagesBodySchema = PublishMetrcPackagesInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  publishedByMemberId: true
});
var UnpublishMetrcPackagesBodySchema = UnpublishMetrcPackagesInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  unpublishedByMemberId: true
});
var ListMetrcPackageStagingQuerySchema = ListMetrcPackageStagingInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  stagingStates: true,
  mappingStatuses: true,
  publicationStatuses: true,
  inventoryPackageIds: true,
  packageLabels: true,
  metrcItemIds: true,
  productIds: true,
  productVariantIds: true,
  searchText: true,
  heldOnly: true,
  excludedOnly: true,
  pageNumber: true,
  pageSize: true
}).extend({
  stagingStates: optionalQueryArray(MetrcPackageStagingStateSchema),
  mappingStatuses: optionalQueryArray(MetrcItemMappingStatusSchema),
  publicationStatuses: optionalQueryArray(MetrcPackagePublicationStatusSchema),
  inventoryPackageIds: optionalQueryArray(z33.string().uuid()),
  packageLabels: optionalQueryArray(z33.string().min(1)),
  metrcItemIds: optionalQueryArray(z33.coerce.number().int()),
  productIds: optionalQueryArray(z33.string().uuid()),
  productVariantIds: optionalQueryArray(z33.string().uuid()),
  searchText: z33.string().optional(),
  heldOnly: OptionalQueryBooleanSchema,
  excludedOnly: OptionalQueryBooleanSchema,
  pageNumber: z33.coerce.number().int().min(1).optional(),
  pageSize: z33.coerce.number().int().min(1).max(100).optional()
});
var ListMetrcPackageStagingAggregatesQuerySchema = ListMetrcPackageStagingAggregatesInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  stagingStates: true,
  mappingStatuses: true,
  publicationStatuses: true,
  inventoryPackageIds: true,
  packageLabels: true,
  metrcItemIds: true,
  productIds: true,
  productVariantIds: true,
  searchText: true,
  heldOnly: true,
  excludedOnly: true
}).extend({
  stagingStates: optionalQueryArray(MetrcPackageStagingStateSchema),
  mappingStatuses: optionalQueryArray(MetrcItemMappingStatusSchema),
  publicationStatuses: optionalQueryArray(MetrcPackagePublicationStatusSchema),
  inventoryPackageIds: optionalQueryArray(z33.string().uuid()),
  packageLabels: optionalQueryArray(z33.string().min(1)),
  metrcItemIds: optionalQueryArray(z33.coerce.number().int()),
  productIds: optionalQueryArray(z33.string().uuid()),
  productVariantIds: optionalQueryArray(z33.string().uuid()),
  searchText: z33.string().optional(),
  heldOnly: OptionalQueryBooleanSchema,
  excludedOnly: OptionalQueryBooleanSchema
});
var ListMetrcPackageHoldsQuerySchema = ListMetrcPackageHoldsInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  holdStatuses: true,
  holdReasons: true,
  holdSources: true,
  ownerTypes: true,
  inventoryPackageIds: true,
  packageLabels: true,
  metrcItemIds: true,
  productVariantIds: true,
  ownerMemberIds: true,
  ownerCustomerIds: true,
  ownerOrderIds: true,
  ownerOrderPartitionIds: true,
  pageNumber: true,
  pageSize: true
}).extend({
  holdStatuses: optionalQueryArray(MetrcPackageHoldStatusSchema),
  holdReasons: optionalQueryArray(MetrcPackageHoldReasonSchema),
  holdSources: optionalQueryArray(MetrcPackageHoldSourceSchema),
  ownerTypes: optionalQueryArray(MetrcPackageHoldOwnerTypeSchema),
  inventoryPackageIds: optionalQueryArray(z33.string().uuid()),
  packageLabels: optionalQueryArray(z33.string().min(1)),
  metrcItemIds: optionalQueryArray(z33.coerce.number().int()),
  productVariantIds: optionalQueryArray(z33.string().uuid()),
  ownerMemberIds: optionalQueryArray(z33.string().uuid()),
  ownerCustomerIds: optionalQueryArray(z33.string().uuid()),
  ownerOrderIds: optionalQueryArray(z33.string().uuid()),
  ownerOrderPartitionIds: optionalQueryArray(z33.string().uuid()),
  pageNumber: z33.coerce.number().int().min(1).optional(),
  pageSize: z33.coerce.number().int().min(1).max(100).optional()
});
var CreateMetrcPackageHoldsBodySchema = CreateMetrcPackageHoldsInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  heldByMemberId: true
});
var MetrcPackageHoldOperationTargetHttpSchema = z33.union([
  z33.object({
    id: z33.string().uuid(),
    inventoryPackageId: z33.string().uuid().optional(),
    packageLabel: z33.string().min(1).optional()
  }),
  z33.object({
    id: z33.string().uuid().optional(),
    inventoryPackageId: z33.string().uuid(),
    packageLabel: z33.string().min(1).optional()
  }),
  z33.object({
    id: z33.string().uuid().optional(),
    inventoryPackageId: z33.string().uuid().optional(),
    packageLabel: z33.string().min(1)
  })
]);
var ReleaseMetrcPackageHoldsBodySchema = ReleaseMetrcPackageHoldsInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  releasedByMemberId: true,
  holds: true
}).extend({
  holds: z33.array(MetrcPackageHoldOperationTargetHttpSchema).min(1)
});
var ExpireMetrcPackageHoldsBodySchema = ExpireMetrcPackageHoldsInputSchema.omit({
  organizationId: true,
  facilityLicenseNumber: true,
  holds: true
}).extend({
  holds: z33.array(MetrcPackageHoldOperationTargetHttpSchema).min(1).optional()
});
var errorResponses = {
  401: MetrcInventoryEngineErrorResponseSchema,
  403: MetrcInventoryEngineErrorResponseSchema,
  422: MetrcInventoryEngineErrorResponseSchema,
  500: MetrcInventoryEngineErrorResponseSchema
};
var metrcInventoryEngineContract = c32.router({
  syncActivePackages: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/sync-active-packages",
    pathParams: FacilityPathParamsSchema,
    body: SyncActiveMetrcPackagesBodySchema,
    responses: {
      200: SyncActiveMetrcPackagesResultSchema,
      ...errorResponses
    },
    summary: "Sync active Metrc package mirrors for a facility"
  },
  syncPackageState: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-states/:metrcState/sync",
    pathParams: PackageStatePathParamsSchema,
    body: SyncActiveMetrcPackagesBodySchema,
    responses: {
      200: SyncMetrcPackageStateResultSchema,
      ...errorResponses
    },
    summary: "Sync one Metrc package state mirror endpoint for a facility"
  },
  syncFacilityPackageStates: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-states/sync",
    pathParams: FacilityPathParamsSchema,
    body: SyncActiveMetrcPackagesBodySchema,
    responses: {
      200: SyncMetrcFacilityPackageStatesResultSchema,
      ...errorResponses
    },
    summary: "Sync active, inactive, and transferred Metrc package mirrors for a facility"
  },
  listDiscrepancies: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/discrepancies",
    pathParams: FacilityPathParamsSchema,
    query: ListMetrcInventoryDiscrepanciesQuerySchema,
    responses: {
      200: MetrcInventoryDiscrepancyListSchema,
      ...errorResponses
    },
    summary: "List persisted Metrc inventory discrepancies for a facility"
  },
  compareFacilityState: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/comparison",
    pathParams: FacilityPathParamsSchema,
    responses: {
      200: MetrcInventoryComparisonReportSchema,
      ...errorResponses
    },
    summary: "Compare Metrc package mirror truth against local inventory state"
  },
  syncOutgoingTransferEvidence: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/movement-evidence/outgoing-transfers/sync",
    pathParams: FacilityPathParamsSchema,
    body: SyncOutgoingTransferEvidenceBodySchema,
    responses: {
      200: SyncOutgoingTransferEvidenceResultSchema,
      ...errorResponses
    },
    summary: "Sync outgoing transfer movement evidence for a facility"
  },
  backfillOutgoingTransferEvidence: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/movement-evidence/outgoing-transfers/backfill",
    pathParams: FacilityPathParamsSchema,
    body: TargetedMovementEvidenceBackfillBodySchema,
    responses: {
      200: TargetedMetrcPackageMovementEvidenceBackfillResultSchema,
      ...errorResponses
    },
    summary: "Run a bounded targeted outgoing transfer movement evidence backfill"
  },
  listMovementEvidence: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/movement-evidence",
    pathParams: FacilityPathParamsSchema,
    query: ListMovementEvidenceQuerySchema,
    responses: {
      200: MetrcPackageMovementEvidenceListResponseSchema,
      ...errorResponses
    },
    summary: "List persisted package movement evidence for a facility"
  },
  getBestMovementEvidenceForPackage: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/packages/:packageLabel/movement-evidence/best",
    pathParams: PackageMovementEvidencePathParamsSchema,
    query: GetBestMovementEvidenceQuerySchema,
    responses: {
      200: MetrcPackageMovementEvidenceSchema.nullable(),
      ...errorResponses
    },
    summary: "Get the best known movement evidence for one package"
  },
  listMetrcItemMappings: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/item-mappings",
    pathParams: FacilityPathParamsSchema,
    query: ListMetrcItemMappingsQuerySchema,
    responses: {
      200: MetrcItemMappingListResponseSchema,
      ...errorResponses
    },
    summary: "List Metrc item mappings for a facility"
  },
  upsertMetrcItemMapping: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/item-mappings",
    pathParams: FacilityPathParamsSchema,
    body: UpsertMetrcItemMappingBodySchema,
    responses: {
      200: MetrcItemMappingSchema,
      ...errorResponses
    },
    summary: "Create or update Metrc item mapping authority for a facility"
  },
  listPackagePublications: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-publications",
    pathParams: FacilityPathParamsSchema,
    query: ListMetrcPackagePublicationsQuerySchema,
    responses: {
      200: MetrcPackagePublicationListResponseSchema,
      ...errorResponses
    },
    summary: "List Metrc package publication records for a facility"
  },
  publishPackages: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-publications/publish",
    pathParams: FacilityPathParamsSchema,
    body: PublishMetrcPackagesBodySchema,
    responses: {
      200: MetrcPackagePublicationOperationResultSchema,
      ...errorResponses
    },
    summary: "Publish local Metrc packages for sellable Flote availability"
  },
  unpublishPackages: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-publications/unpublish",
    pathParams: FacilityPathParamsSchema,
    body: UnpublishMetrcPackagesBodySchema,
    responses: {
      200: MetrcPackagePublicationOperationResultSchema,
      ...errorResponses
    },
    summary: "Unpublish local Metrc packages from sellable Flote availability"
  },
  listPackageStaging: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-staging",
    pathParams: FacilityPathParamsSchema,
    query: ListMetrcPackageStagingQuerySchema,
    responses: {
      200: MetrcPackageStagingListResponseSchema,
      ...errorResponses
    },
    summary: "List derived Metrc package staging states for remediation"
  },
  listPackageStagingAggregates: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-staging/aggregates",
    pathParams: FacilityPathParamsSchema,
    query: ListMetrcPackageStagingAggregatesQuerySchema,
    responses: {
      200: MetrcPackageStagingAggregatesResponseSchema,
      ...errorResponses
    },
    summary: "Aggregate counters across the filtered staging scope \u2014 powers the summary cards and never page-bounded"
  },
  listPackageHolds: {
    method: "GET",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-holds",
    pathParams: FacilityPathParamsSchema,
    query: ListMetrcPackageHoldsQuerySchema,
    responses: {
      200: MetrcPackageHoldListResponseSchema,
      ...errorResponses
    },
    summary: "List Metrc package holds for a facility"
  },
  createPackageHolds: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-holds",
    pathParams: FacilityPathParamsSchema,
    body: CreateMetrcPackageHoldsBodySchema,
    responses: {
      200: MetrcPackageHoldOperationResultSchema,
      ...errorResponses
    },
    summary: "Create Metrc package holds for a facility"
  },
  releasePackageHolds: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-holds/release",
    pathParams: FacilityPathParamsSchema,
    body: ReleaseMetrcPackageHoldsBodySchema,
    responses: {
      200: MetrcPackageHoldOperationResultSchema,
      ...errorResponses
    },
    summary: "Release Metrc package holds for a facility"
  },
  expirePackageHolds: {
    method: "POST",
    path: "/api/organizations/:orgId/metrc-inventory-engine/facilities/:facilityLicenseNumber/package-holds/expire",
    pathParams: FacilityPathParamsSchema,
    body: ExpireMetrcPackageHoldsBodySchema,
    responses: {
      200: MetrcPackageHoldOperationResultSchema,
      ...errorResponses
    },
    summary: "Expire Metrc package holds for a facility"
  }
});

// src/http/metrc-integration.contract.ts
import { initContract as initContract33 } from "@ts-rest/core";
import { z as z34 } from "zod";
import {
  MetrcIntegrationStatusSchema,
  MetrcIntegrationFacilitySchema
} from "@flote/types/organization";
var c33 = initContract33();
var StoreMetrcIntegrationBodySchema = z34.object({
  userApiKey: z34.string().min(1, "User API key is required"),
  stateCode: z34.string().min(1).max(4).optional().default("mt")
});
var MetrcIntegrationStatusResponseSchema = z34.object({
  status: MetrcIntegrationStatusSchema,
  stateCode: z34.string(),
  lastValidatedAt: z34.string().datetime().nullable(),
  validationError: z34.string().nullable(),
  accessibleFacilities: z34.array(MetrcIntegrationFacilitySchema),
  configuredAt: z34.string().datetime().nullable()
});
var TestMetrcIntegrationResponseSchema = z34.object({
  valid: z34.boolean(),
  facilities: z34.array(MetrcIntegrationFacilitySchema),
  error: z34.string().optional()
});
var MemberKeyStatusEntrySchema = z34.object({
  memberId: z34.string().uuid(),
  memberName: z34.string().nullable(),
  memberEmail: z34.string().nullable(),
  keyStatus: z34.enum(["active", "pending_validation", "invalid", "revoked", "not_configured"]),
  lastValidatedAt: z34.string().datetime().nullable(),
  configuredAt: z34.string().datetime().nullable()
});
var metrcIntegrationAdminContract = c33.router({
  storeIntegration: {
    method: "POST",
    path: "/api/admin/organizations/:id/metrc-integration",
    pathParams: z34.object({ id: z34.string().uuid() }),
    body: StoreMetrcIntegrationBodySchema,
    responses: {
      200: MetrcIntegrationStatusResponseSchema,
      400: z34.object({ message: z34.string() }),
      401: z34.object({ message: z34.string() }),
      403: z34.object({ message: z34.string() }),
      500: z34.object({ message: z34.string() })
    },
    summary: "Store or update a Metrc User API Key for an organization (admin)"
  },
  testIntegration: {
    method: "POST",
    path: "/api/admin/organizations/:id/metrc-integration/test",
    pathParams: z34.object({ id: z34.string().uuid() }),
    body: c33.noBody(),
    responses: {
      200: TestMetrcIntegrationResponseSchema,
      401: z34.object({ message: z34.string() }),
      403: z34.object({ message: z34.string() }),
      404: z34.object({ message: z34.string() }),
      500: z34.object({ message: z34.string() })
    },
    summary: "Validate the stored Metrc key by fetching facilities (admin)"
  },
  getIntegrationStatus: {
    method: "GET",
    path: "/api/admin/organizations/:id/metrc-integration",
    pathParams: z34.object({ id: z34.string().uuid() }),
    responses: {
      200: MetrcIntegrationStatusResponseSchema,
      401: z34.object({ message: z34.string() }),
      403: z34.object({ message: z34.string() }),
      404: z34.object({ message: z34.string() }),
      500: z34.object({ message: z34.string() })
    },
    summary: "Get the Metrc integration status for an organization (admin)"
  },
  listMemberKeyStatuses: {
    method: "GET",
    path: "/api/admin/organizations/:id/metrc-integration/members",
    pathParams: z34.object({ id: z34.string().uuid() }),
    responses: {
      200: z34.object({ members: z34.array(MemberKeyStatusEntrySchema) }),
      401: z34.object({ message: z34.string() }),
      403: z34.object({ message: z34.string() }),
      500: z34.object({ message: z34.string() })
    },
    summary: "List all members' Metrc key statuses for an organization (admin)"
  },
  revokeIntegration: {
    method: "DELETE",
    path: "/api/admin/organizations/:id/metrc-integration",
    pathParams: z34.object({ id: z34.string().uuid() }),
    body: c33.noBody(),
    responses: {
      204: z34.void(),
      401: z34.object({ message: z34.string() }),
      403: z34.object({ message: z34.string() }),
      404: z34.object({ message: z34.string() }),
      500: z34.object({ message: z34.string() })
    },
    summary: "Revoke the Metrc integration for an organization (admin)"
  }
});

// src/http/metrc-member-key.contract.ts
import { initContract as initContract34 } from "@ts-rest/core";
import { z as z35 } from "zod";
import {
  MetrcIntegrationStatusSchema as MetrcIntegrationStatusSchema2,
  MetrcIntegrationFacilitySchema as MetrcIntegrationFacilitySchema2
} from "@flote/types/organization";
var c34 = initContract34();
var StoreMyKeyBodySchema = z35.object({
  userApiKey: z35.string().min(1, "User API key is required"),
  stateCode: z35.string().min(1).max(4).optional().default("mt")
});
var MyKeyStatusResponseSchema = z35.object({
  status: MetrcIntegrationStatusSchema2,
  stateCode: z35.string(),
  lastValidatedAt: z35.string().datetime().nullable(),
  validationError: z35.string().nullable(),
  accessibleFacilities: z35.array(MetrcIntegrationFacilitySchema2),
  configuredAt: z35.string().datetime().nullable()
});
var TestMyKeyResponseSchema = z35.object({
  valid: z35.boolean(),
  facilities: z35.array(MetrcIntegrationFacilitySchema2),
  error: z35.string().optional()
});
var metrcMemberKeyContract = c34.router({
  storeMyKey: {
    method: "POST",
    path: "/api/metrc/my-key",
    body: StoreMyKeyBodySchema,
    responses: {
      200: MyKeyStatusResponseSchema,
      401: z35.object({ message: z35.string() }),
      500: z35.object({ message: z35.string() })
    },
    summary: "Store or update the authenticated member's Metrc API key"
  },
  testMyKey: {
    method: "POST",
    path: "/api/metrc/my-key/test",
    body: c34.noBody(),
    responses: {
      200: TestMyKeyResponseSchema,
      401: z35.object({ message: z35.string() }),
      404: z35.object({ message: z35.string() }),
      500: z35.object({ message: z35.string() })
    },
    summary: "Validate the authenticated member's stored Metrc key"
  },
  getMyKeyStatus: {
    method: "GET",
    path: "/api/metrc/my-key",
    responses: {
      200: MyKeyStatusResponseSchema,
      401: z35.object({ message: z35.string() }),
      404: z35.object({ message: z35.string() }),
      500: z35.object({ message: z35.string() })
    },
    summary: "Get the authenticated member's Metrc key status"
  },
  revokeMyKey: {
    method: "DELETE",
    path: "/api/metrc/my-key",
    body: c34.noBody(),
    responses: {
      204: z35.void(),
      401: z35.object({ message: z35.string() }),
      404: z35.object({ message: z35.string() }),
      500: z35.object({ message: z35.string() })
    },
    summary: "Revoke the authenticated member's Metrc key"
  }
});

// src/http/org-products.contract.ts
import { initContract as initContract35 } from "@ts-rest/core";
import { z as z36 } from "zod";
import {
  BulkCreateProductsInputSchema,
  BulkCreateProductsResponseSchema,
  LinkedMetrcItemIdsResponseSchema
} from "@flote/types/product";
var c35 = initContract35();
var ErrorResponseSchema4 = z36.object({ message: z36.string() });
var orgProductsContract = c35.router({
  bulkCreateOrgProducts: {
    method: "POST",
    path: "/api/organizations/:orgId/products/bulk",
    pathParams: z36.object({ orgId: z36.string().uuid() }),
    body: BulkCreateProductsInputSchema,
    responses: {
      200: BulkCreateProductsResponseSchema,
      400: ErrorResponseSchema4,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Bulk create products within an organization"
  },
  getLinkedMetrcItemIds: {
    method: "GET",
    path: "/api/organizations/:orgId/products/linked-metrc-item-ids",
    pathParams: z36.object({ orgId: z36.string().uuid() }),
    responses: {
      200: LinkedMetrcItemIdsResponseSchema,
      401: ErrorResponseSchema4,
      403: ErrorResponseSchema4,
      500: ErrorResponseSchema4
    },
    summary: "Get Metrc item IDs already linked to products in this org"
  }
});

// src/http/product-reviews.contract.ts
import { initContract as initContract36 } from "@ts-rest/core";
import { z as z37 } from "zod";
var c36 = initContract36();
var ErrorResponseSchema5 = z37.object({ message: z37.string() });
var ReviewCategorySchema = z37.enum([
  // Image categories
  "resolution",
  "background",
  "composition",
  "quality",
  "format",
  "file_size",
  "aspect_ratio",
  "content_mismatch",
  // Variant categories
  "weight",
  "units_per_case",
  "pricing",
  "naming",
  "differentiation",
  "order_constraints",
  // Product info categories
  "description",
  "category_assignment",
  "title",
  // Compliance categories
  "metrc_tracking",
  "metrc_item_name",
  "metrc_unit_of_measure",
  "realm_mismatch",
  // Inventory hygiene
  "sku",
  "barcode"
]);
var ReviewIssueSchema = z37.object({
  severity: z37.enum(["critical", "warning", "suggestion"]),
  category: ReviewCategorySchema,
  message: z37.string(),
  suggestion: z37.string().optional(),
  field: z37.string().optional(),
  variantIndex: z37.number().optional(),
  imageIndex: z37.number().optional()
});
var SectionReviewSchema = z37.object({
  score: z37.number().min(0).max(100),
  issues: z37.array(ReviewIssueSchema)
});
var ProductReviewDtoSchema = z37.object({
  id: z37.string().uuid(),
  runId: z37.string().uuid(),
  productId: z37.string().uuid().nullable(),
  orgId: z37.string().uuid(),
  overallScore: z37.number().min(0).max(100),
  overallSummary: z37.string(),
  imageReview: SectionReviewSchema.nullable(),
  variantReview: SectionReviewSchema,
  infoReview: SectionReviewSchema,
  complianceReview: SectionReviewSchema.nullable(),
  reviewedAt: z37.string().datetime(),
  dismissedAt: z37.string().datetime().nullable(),
  dismissedBy: z37.string().uuid().nullable(),
  createdAt: z37.string().datetime(),
  updatedAt: z37.string().datetime()
});
var productReviewsContract = c36.router({
  getProductReview: {
    method: "GET",
    path: "/api/organizations/:orgId/products/:productId/review",
    pathParams: z37.object({
      orgId: z37.string().uuid(),
      productId: z37.string().uuid()
    }),
    responses: {
      200: ProductReviewDtoSchema.nullable(),
      401: ErrorResponseSchema5,
      403: ErrorResponseSchema5,
      500: ErrorResponseSchema5
    },
    summary: "Get the latest AI product review for a product"
  },
  batchGetProductReviews: {
    method: "GET",
    path: "/api/organizations/:orgId/products/reviews/batch",
    pathParams: z37.object({
      orgId: z37.string().uuid()
    }),
    query: z37.object({
      // Comma-separated list of product UUIDs (up to 200).
      productIds: z37.string().transform(
        (val) => val.split(",").map((id) => id.trim()).filter((id) => id.length > 0)
      )
    }),
    responses: {
      200: z37.object({
        reviews: z37.array(ProductReviewDtoSchema)
      }),
      401: ErrorResponseSchema5,
      403: ErrorResponseSchema5,
      500: ErrorResponseSchema5
    },
    summary: "Batch-fetch the latest review for multiple products"
  },
  dismissProductReview: {
    method: "POST",
    path: "/api/organizations/:orgId/products/:productId/review/:reviewId/dismiss",
    pathParams: z37.object({
      orgId: z37.string().uuid(),
      productId: z37.string().uuid(),
      reviewId: z37.string().uuid()
    }),
    body: z37.object({}),
    responses: {
      200: z37.object({ success: z37.literal(true) }),
      401: ErrorResponseSchema5,
      403: ErrorResponseSchema5,
      404: ErrorResponseSchema5,
      500: ErrorResponseSchema5
    },
    summary: "Dismiss an AI product review"
  }
});

// src/http/supplier-analytics.contract.ts
import { initContract as initContract37 } from "@ts-rest/core";
import { z as z38 } from "zod";
var c37 = initContract37();
var DateRangeQuerySchema = z38.object({
  fromDate: z38.string().describe("ISO date string (YYYY-MM-DD)"),
  toDate: z38.string().describe("ISO date string (YYYY-MM-DD)")
}).refine(
  (data) => new Date(data.toDate) >= new Date(data.fromDate),
  { message: "toDate must be on or after fromDate" }
).refine(
  (data) => {
    const from = new Date(data.fromDate);
    const to = new Date(data.toDate);
    const diffDays = (to.getTime() - from.getTime()) / (1e3 * 60 * 60 * 24);
    return diffDays <= 366;
  },
  { message: "Date range must not exceed 366 days" }
);
var GranularitySchema = z38.enum(["day", "week", "month"]);
var SortBySchema = z38.enum(["revenue", "quantity"]);
var RevenueModeSchema = z38.enum(["gross", "net"]);
var ExcludeBuyerOrgIdsSchema = z38.preprocess(
  (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === "string") return val.length === 0 ? [] : val.split(",");
    return void 0;
  },
  z38.array(z38.string()).optional()
);
var TopProductSummarySchema = z38.object({
  productName: z38.string(),
  sku: z38.string().nullable(),
  totalRevenue: z38.number(),
  totalQuantity: z38.number().int()
});
var TopCustomerSummarySchema = z38.object({
  buyerOrganizationId: z38.string().nullable(),
  buyerName: z38.string(),
  totalRevenue: z38.number(),
  orderCount: z38.number().int()
});
var AnalyticsSummaryResponseSchema = z38.object({
  totalRevenue: z38.number(),
  revenueChange: z38.number(),
  totalOrders: z38.number().int(),
  ordersChange: z38.number(),
  averageOrderValue: z38.number(),
  aovChange: z38.number(),
  topProducts: z38.array(TopProductSummarySchema),
  topCustomers: z38.array(TopCustomerSummarySchema),
  period: z38.object({
    from: z38.string(),
    to: z38.string()
  })
});
var OrderTimeBucketSchema = z38.object({
  period: z38.string(),
  orderCount: z38.number().int(),
  revenue: z38.number(),
  averageOrderValue: z38.number()
});
var PeriodSummarySchema = z38.object({
  totalOrders: z38.number().int(),
  totalRevenue: z38.number(),
  averageOrderValue: z38.number()
});
var OrdersOverTimeResponseSchema = z38.object({
  buckets: z38.array(OrderTimeBucketSchema),
  summary: PeriodSummarySchema,
  priorPeriod: PeriodSummarySchema
});
var ProductSalesRowSchema = z38.object({
  productId: z38.string(),
  productName: z38.string(),
  variantTitle: z38.string().nullable(),
  sku: z38.string().nullable(),
  brandName: z38.string().nullable(),
  totalQuantity: z38.number().int(),
  totalRevenue: z38.number(),
  orderCount: z38.number().int()
});
var ProductSalesResponseSchema = z38.object({
  products: z38.array(ProductSalesRowSchema)
});
var CategorySalesRowSchema = z38.object({
  categoryId: z38.string(),
  categoryName: z38.string(),
  parentCategoryId: z38.string().nullable(),
  parentCategoryName: z38.string().nullable(),
  productCount: z38.number().int(),
  totalQuantity: z38.number().int(),
  totalRevenue: z38.number(),
  orderCount: z38.number().int()
});
var CategorySalesResponseSchema = z38.object({
  categories: z38.array(CategorySalesRowSchema)
});
var InventoryStatusSchema = z38.enum(["critical", "low", "healthy", "overstock", "dead"]);
var InventoryHealthRowSchema = z38.object({
  productVariantId: z38.string(),
  sku: z38.string().nullable(),
  productTitle: z38.string(),
  brandId: z38.string().nullable(),
  brandName: z38.string().nullable(),
  totalStocked: z38.number(),
  totalReserved: z38.number(),
  totalAvailable: z38.number(),
  sold30d: z38.number().int(),
  avgDailyUnits: z38.number(),
  daysOfSupply: z38.number().nullable(),
  status: InventoryStatusSchema
});
var InventoryHealthResponseSchema = z38.object({
  rows: z38.array(InventoryHealthRowSchema),
  summary: z38.object({
    totalSkus: z38.number().int(),
    statusCounts: z38.object({
      critical: z38.number().int(),
      low: z38.number().int(),
      healthy: z38.number().int(),
      overstock: z38.number().int(),
      dead: z38.number().int()
    })
  })
});
var DiscountCodePerformanceRowSchema = z38.object({
  codeId: z38.string(),
  code: z38.string(),
  discountType: z38.string(),
  discountValue: z38.number(),
  isActive: z38.boolean(),
  redemptionCount: z38.number().int(),
  uniqueCustomers: z38.number().int(),
  totalDiscountGiven: z38.number(),
  totalOrderValue: z38.number(),
  avgOrderValue: z38.number(),
  effectiveDiscountPct: z38.number()
});
var DiscountPerformanceResponseSchema = z38.object({
  codes: z38.array(DiscountCodePerformanceRowSchema),
  summary: z38.object({
    totalRedemptions: z38.number().int(),
    totalDiscountGiven: z38.number(),
    totalOrderValueDriven: z38.number(),
    redeemedCodesCount: z38.number().int()
  })
});
var OrderHeatmapCellSchema = z38.object({
  dayOfWeek: z38.number().int().min(0).max(6),
  hour: z38.number().int().min(0).max(23),
  orderCount: z38.number().int(),
  revenue: z38.number()
});
var OrderHeatmapResponseSchema = z38.object({
  cells: z38.array(OrderHeatmapCellSchema),
  timezone: z38.string(),
  totalOrders: z38.number().int(),
  totalRevenue: z38.number()
});
var CustomerSalesRowSchema = z38.object({
  buyerOrganizationId: z38.string().nullable(),
  buyerName: z38.string(),
  orderCount: z38.number().int(),
  totalRevenue: z38.number(),
  totalQuantity: z38.number().int(),
  firstOrderDate: z38.string().nullable(),
  lastOrderDate: z38.string().nullable(),
  daysSinceLastOrder: z38.number().int().nullable()
});
var SalesByCustomerResponseSchema = z38.object({
  customers: z38.array(CustomerSalesRowSchema)
});
var FulfillmentTypeSummarySchema = z38.object({
  fulfillmentType: z38.string(),
  orderCount: z38.number().int(),
  revenue: z38.number(),
  fees: z38.number(),
  effectiveRate: z38.number()
});
var FulfillmentEconomicsBucketSchema = z38.object({
  period: z38.string(),
  byType: z38.array(FulfillmentTypeSummarySchema)
});
var FulfillmentEconomicsTotalsSchema = z38.object({
  totalRevenue: z38.number(),
  totalFees: z38.number(),
  effectiveRate: z38.number(),
  selfDeliverySavings: z38.number()
});
var FulfillmentEconomicsResponseSchema = z38.object({
  buckets: z38.array(FulfillmentEconomicsBucketSchema),
  summary: FulfillmentEconomicsTotalsSchema,
  priorPeriod: FulfillmentEconomicsTotalsSchema
});
var RetentionBuyerSchema = z38.object({
  buyerOrganizationId: z38.string().nullable(),
  buyerName: z38.string(),
  firstOrderDate: z38.string(),
  lastOrderDate: z38.string(),
  totalOrders: z38.number().int(),
  totalRevenue: z38.number(),
  daysSinceLastOrder: z38.number().int(),
  status: z38.enum(["active", "at_risk", "churned"])
});
var RetentionMonthlyBreakdownSchema = z38.object({
  period: z38.string(),
  newBuyerRevenue: z38.number(),
  returningBuyerRevenue: z38.number(),
  newBuyerCount: z38.number().int(),
  returningBuyerCount: z38.number().int()
});
var RetentionSummarySchema = z38.object({
  totalBuyers: z38.number().int(),
  repeatBuyers: z38.number().int(),
  repeatRate: z38.number(),
  newBuyers: z38.number().int(),
  churnedBuyers: z38.number().int()
});
var CustomerRetentionResponseSchema = z38.object({
  summary: RetentionSummarySchema,
  buyers: z38.array(RetentionBuyerSchema),
  monthlyBreakdown: z38.array(RetentionMonthlyBreakdownSchema)
});
var BrandComparisonEntrySchema = z38.object({
  brandId: z38.string(),
  brandName: z38.string(),
  revenue: z38.number(),
  orders: z38.number().int(),
  averageOrderValue: z38.number(),
  unitsSold: z38.number().int(),
  avgFulfillmentHours: z38.number().nullable(),
  selfDeliveryPct: z38.number(),
  topProductName: z38.string().nullable()
});
var BrandComparisonSummarySchema = z38.object({
  activeBrands: z38.number().int(),
  topBrandName: z38.string().nullable(),
  topBrandRevenue: z38.number(),
  revenueConcentration: z38.number()
});
var BrandComparisonResponseSchema = z38.object({
  summary: BrandComparisonSummarySchema,
  brands: z38.array(BrandComparisonEntrySchema)
});
var ErrorResponseSchema6 = z38.object({ message: z38.string() });
var supplierAnalyticsContract = c37.router({
  getSummary: {
    method: "GET",
    path: "/api/supplier/analytics/summary",
    query: z38.object({
      periodDays: z38.coerce.number().int().positive().max(366).optional().default(30),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: AnalyticsSummaryResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get analytics summary for the dashboard (last 30 days with period-over-period change)"
  },
  getOrdersOverTime: {
    method: "GET",
    path: "/api/supplier/analytics/orders-over-time",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      granularity: GranularitySchema.optional().default("month"),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: OrdersOverTimeResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get orders over time with configurable granularity"
  },
  getProductSales: {
    method: "GET",
    path: "/api/supplier/analytics/product-sales",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      limit: z38.coerce.number().int().positive().max(100).optional().default(25),
      sortBy: SortBySchema.optional().default("revenue"),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: ProductSalesResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get top products by revenue or quantity sold"
  },
  getInventoryHealth: {
    method: "GET",
    path: "/api/supplier/analytics/inventory-health",
    query: z38.object({
      brandId: z38.string().uuid().optional()
    }),
    responses: {
      200: InventoryHealthResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Per-SKU inventory health: days of supply + status (critical/low/healthy/overstock/dead)"
  },
  getDiscountPerformance: {
    method: "GET",
    path: "/api/supplier/analytics/discount-performance",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      brandId: z38.string().uuid().optional()
    }),
    responses: {
      200: DiscountPerformanceResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get discount-code redemption performance scoped to caller orgs"
  },
  getOrdersHeatmap: {
    method: "GET",
    path: "/api/supplier/analytics/orders-heatmap",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: OrderHeatmapResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get orders bucketed by day-of-week and hour-of-day (America/Denver TZ)"
  },
  getCategorySales: {
    method: "GET",
    path: "/api/supplier/analytics/category-sales",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      limit: z38.coerce.number().int().positive().max(100).optional().default(25),
      sortBy: SortBySchema.optional().default("revenue"),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: CategorySalesResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get top product categories by revenue or quantity sold"
  },
  getSalesByCustomer: {
    method: "GET",
    path: "/api/supplier/analytics/sales-by-customer",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      limit: z38.coerce.number().int().positive().max(500).optional().default(25),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: SalesByCustomerResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get sales breakdown by buyer organization"
  },
  getCustomerRetention: {
    method: "GET",
    path: "/api/supplier/analytics/customer-retention",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: CustomerRetentionResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get customer retention metrics and buyer health"
  },
  getFulfillmentEconomics: {
    method: "GET",
    path: "/api/supplier/analytics/fulfillment-economics",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      granularity: GranularitySchema.optional().default("month"),
      brandId: z38.string().uuid().optional(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: FulfillmentEconomicsResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Get fulfillment economics breakdown by delivery method"
  },
  getBrandComparison: {
    method: "GET",
    path: "/api/supplier/analytics/brand-comparison",
    query: z38.object({
      fromDate: z38.string(),
      toDate: z38.string(),
      revenueMode: RevenueModeSchema.optional().default("gross"),
      excludeBuyerOrgIds: ExcludeBuyerOrgIdsSchema
    }),
    responses: {
      200: BrandComparisonResponseSchema,
      401: ErrorResponseSchema6,
      403: ErrorResponseSchema6,
      500: ErrorResponseSchema6
    },
    summary: "Compare performance across brands (no brand filter \u2014 compares all)"
  }
});

// src/http/agent-analytics.contract.ts
import { initContract as initContract38 } from "@ts-rest/core";
import { z as z39 } from "zod";
var c38 = initContract38();
var DaysQuerySchema = z39.object({
  days: z39.coerce.number().int().min(1).max(365).default(30)
});
var HeadlineStatsSchema = z39.object({
  totalRuns: z39.number().int(),
  completedRuns: z39.number().int(),
  failedRuns: z39.number().int(),
  totalCostUsd: z39.number(),
  totalInputTokens: z39.number().int(),
  totalOutputTokens: z39.number().int(),
  avgCostPerRunUsd: z39.number(),
  avgDurationMs: z39.number().nullable(),
  priorPeriodCostUsd: z39.number(),
  costChangePercent: z39.number().nullable()
});
var SpendByDayEntrySchema = z39.object({
  day: z39.string(),
  modelId: z39.string(),
  costUsd: z39.number(),
  runCount: z39.number().int()
});
var RunVolumeByDayEntrySchema = z39.object({
  day: z39.string(),
  status: z39.enum(["completed", "failed"]),
  count: z39.number().int()
});
var CostByAgentEntrySchema = z39.object({
  agentId: z39.string(),
  runCount: z39.number().int(),
  totalCostUsd: z39.number(),
  avgCostPerRunUsd: z39.number()
});
var TopOrgSpendEntrySchema = z39.object({
  orgId: z39.string(),
  orgName: z39.string().nullable(),
  runCount: z39.number().int(),
  totalCostUsd: z39.number(),
  avgCostPerRunUsd: z39.number()
});
var RecentRunEntrySchema = z39.object({
  runId: z39.string(),
  agentId: z39.string(),
  modelId: z39.string().nullable(),
  status: z39.enum(["pending", "running", "completed", "failed"]),
  entityType: z39.string().nullable(),
  entityId: z39.string().nullable(),
  orgId: z39.string().nullable(),
  orgName: z39.string().nullable(),
  inputTokens: z39.number().int().nullable(),
  outputTokens: z39.number().int().nullable(),
  totalCostUsd: z39.number().nullable(),
  durationMs: z39.number().nullable(),
  createdAt: z39.string(),
  errorMessage: z39.string().nullable()
});
var agentAnalyticsContract = c38.router({
  getHeadlineStats: {
    method: "GET",
    path: "/api/admin/agent-analytics/headline",
    query: DaysQuerySchema,
    responses: {
      200: HeadlineStatsSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Headline agent spend and volume stats for the last N days"
  },
  getSpendByDay: {
    method: "GET",
    path: "/api/admin/agent-analytics/spend-by-day",
    query: DaysQuerySchema,
    responses: {
      200: z39.object({ entries: z39.array(SpendByDayEntrySchema) }),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Daily agent spend grouped by model"
  },
  getRunVolumeByDay: {
    method: "GET",
    path: "/api/admin/agent-analytics/run-volume",
    query: DaysQuerySchema,
    responses: {
      200: z39.object({ entries: z39.array(RunVolumeByDayEntrySchema) }),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Daily run volume by completion status"
  },
  getCostByAgent: {
    method: "GET",
    path: "/api/admin/agent-analytics/cost-by-agent",
    query: DaysQuerySchema,
    responses: {
      200: z39.object({ entries: z39.array(CostByAgentEntrySchema) }),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Cost breakdown by agent type"
  },
  getTopOrgsBySpend: {
    method: "GET",
    path: "/api/admin/agent-analytics/top-orgs",
    query: DaysQuerySchema.extend({ limit: z39.coerce.number().int().min(1).max(50).default(10) }),
    responses: {
      200: z39.object({ entries: z39.array(TopOrgSpendEntrySchema) }),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Top organizations by agent spend"
  },
  getRecentRuns: {
    method: "GET",
    path: "/api/admin/agent-analytics/recent-runs",
    query: z39.object({ limit: z39.coerce.number().int().min(1).max(100).default(20) }),
    responses: {
      200: z39.object({ entries: z39.array(RecentRunEntrySchema) }),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      500: ErrorResponseSchema
    },
    summary: "Most recent agent runs"
  }
});

// src/http/customer-capabilities.contract.ts
import { initContract as initContract39 } from "@ts-rest/core";
import { z as z40 } from "zod";
import { AllowedPaymentMethodsSchema } from "@flote/types/customer-capabilities";
var c39 = initContract39();
var CustomerPaymentCapabilitiesDtoSchema = z40.object({
  customerId: z40.number().int().positive(),
  allowedPaymentMethods: AllowedPaymentMethodsSchema,
  /** Map of host_domain → allowed methods. Absent keys fall back to allowedPaymentMethods. */
  embedPaymentOverrides: z40.record(z40.string().min(1), AllowedPaymentMethodsSchema)
});
var SetEmbedPaymentOverrideBodySchema = z40.object({
  hostDomain: z40.string().min(1),
  allowedPaymentMethods: AllowedPaymentMethodsSchema.nullable()
});
var customerCapabilitiesContract = c39.router({
  getForCustomer: {
    method: "GET",
    path: "/api/supplier/customers/:customerId/payment-capabilities",
    pathParams: z40.object({
      customerId: z40.coerce.number().int().positive()
    }),
    responses: {
      200: CustomerPaymentCapabilitiesDtoSchema,
      400: z40.object({ message: z40.string() }),
      401: z40.object({ message: z40.string() }),
      403: z40.object({ message: z40.string() }),
      404: z40.object({ message: z40.string() }),
      500: z40.object({ message: z40.string() })
    },
    summary: "Get a customer payment capabilities including per-embed overrides"
  },
  setEmbedOverride: {
    method: "PUT",
    path: "/api/supplier/customers/:customerId/payment-capabilities/embed-override",
    pathParams: z40.object({
      customerId: z40.coerce.number().int().positive()
    }),
    body: SetEmbedPaymentOverrideBodySchema,
    responses: {
      200: CustomerPaymentCapabilitiesDtoSchema,
      400: z40.object({ message: z40.string() }),
      401: z40.object({ message: z40.string() }),
      403: z40.object({ message: z40.string() }),
      404: z40.object({ message: z40.string() }),
      500: z40.object({ message: z40.string() })
    },
    summary: "Set or clear a per-embed payment-method override for a customer"
  }
});

// src/http/member-notification-preferences.contract.ts
import { initContract as initContract40 } from "@ts-rest/core";
import { z as z41 } from "zod";
import {
  MemberNotificationPreferenceDtoSchema,
  BulkUpdateNotificationPreferencesInputSchema
} from "@flote/types/notification";
var c40 = initContract40();
var PreferencesResponseSchema = z41.object({
  preferences: z41.array(MemberNotificationPreferenceDtoSchema),
  hasPhone: z41.boolean()
});
var memberNotificationPreferencesContract = c40.router({
  getMyPreferences: {
    method: "GET",
    path: "/api/portal/me/notification-preferences",
    responses: {
      200: PreferencesResponseSchema,
      401: z41.object({ message: z41.string() })
    },
    summary: "Get the authenticated member's notification preferences"
  },
  updateMyPreferences: {
    method: "PUT",
    path: "/api/portal/me/notification-preferences",
    body: BulkUpdateNotificationPreferencesInputSchema,
    responses: {
      200: PreferencesResponseSchema,
      400: z41.object({ message: z41.string() }),
      401: z41.object({ message: z41.string() })
    },
    summary: "Update the authenticated member's notification preferences"
  },
  getMyProfile: {
    method: "GET",
    path: "/api/portal/me/profile",
    responses: {
      200: z41.object({
        memberId: z41.string(),
        firstName: z41.string(),
        lastName: z41.string(),
        email: z41.string(),
        phone: z41.string().nullable()
      }),
      401: z41.object({ message: z41.string() })
    },
    summary: "Get the authenticated member's profile"
  },
  updateMyPhone: {
    method: "PATCH",
    path: "/api/portal/me/phone",
    body: z41.object({
      phone: z41.string().min(1, "Phone number is required").max(20)
    }),
    responses: {
      200: z41.object({ phone: z41.string() }),
      400: z41.object({ message: z41.string() }),
      401: z41.object({ message: z41.string() })
    },
    summary: "Update the authenticated member's phone number"
  }
});

// src/http/back-in-stock.contract.ts
import { initContract as initContract41 } from "@ts-rest/core";
import { z as z42 } from "zod";
import {
  BackInStockSubscriptionDtoSchema,
  BackInStockStatusSchema
} from "@flote/types/notifications";
var c41 = initContract41();
var SubscribeBodySchema = z42.object({
  productId: z42.string().uuid().optional(),
  b2bwaveProductId: z42.number().int().positive().optional(),
  sourceHostDomain: z42.string().min(1).max(255),
  sourceEmbedConfigId: z42.number().int().optional()
}).refine((d) => d.productId != null || d.b2bwaveProductId != null, {
  message: "Either productId (uuid) or b2bwaveProductId (number) is required",
  path: ["productId"]
});
var SubscribeResponseSchema = z42.object({
  subscription: BackInStockSubscriptionDtoSchema,
  created: z42.boolean()
});
var ListResponseSchema2 = z42.object({
  subscriptions: BackInStockSubscriptionDtoSchema.array()
});
var UnsubscribeBodySchema = z42.object({
  token: z42.string().min(1)
});
var UnsubscribeResponseSchema = z42.object({
  cancelled: z42.boolean()
});
var backInStockContract = c41.router({
  subscribe: {
    method: "POST",
    path: "/api/back-in-stock/subscriptions",
    body: SubscribeBodySchema,
    responses: {
      201: SubscribeResponseSchema,
      200: SubscribeResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      422: ErrorResponseSchema
    },
    summary: "Subscribe to back-in-stock alerts for a product"
  },
  cancelMine: {
    method: "DELETE",
    path: "/api/back-in-stock/subscriptions/:subscriptionId",
    pathParams: z42.object({ subscriptionId: z42.string().uuid() }),
    body: z42.object({}).optional(),
    responses: {
      200: z42.object({ cancelled: z42.boolean() }),
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema
    },
    summary: "Cancel one of my pending subscriptions"
  },
  listMine: {
    method: "GET",
    path: "/api/back-in-stock/subscriptions",
    query: z42.object({ status: BackInStockStatusSchema.optional() }),
    responses: {
      200: ListResponseSchema2,
      401: ErrorResponseSchema
    },
    summary: "List my back-in-stock subscriptions"
  },
  unsubscribeByToken: {
    method: "POST",
    path: "/api/back-in-stock/unsubscribe",
    body: UnsubscribeBodySchema,
    responses: {
      200: UnsubscribeResponseSchema,
      400: ErrorResponseSchema,
      410: ErrorResponseSchema
    },
    summary: "Cancel a subscription via the email magic-link token"
  }
});

// src/http/admin-operations.contract.ts
import { initContract as initContract42 } from "@ts-rest/core";
import { z as z43 } from "zod";
import {
  MutationDiffSchema,
  AdminOperationLogDtoSchema
} from "@flote/types/admin-operations";
var c42 = initContract42();
var PreviewQuerySchema = z43.object({
  preview: z43.union([
    z43.boolean(),
    z43.enum(["true", "false"]).transform((v) => v === "true")
  ]).default(false)
});
var BaseMutationBodySchema = z43.object({
  clientRequestId: z43.string().uuid().optional(),
  reason: z43.string().min(1).max(500).optional()
});
var PartitionItemTargetedBodySchema = BaseMutationBodySchema.extend({
  partitionItemId: z43.string().uuid(),
  partitionItemUpdatedAt: z43.string().datetime(),
  alsoAdjustOrderSide: z43.boolean().default(true)
});
var AssignFifoTagsBodySchema = PartitionItemTargetedBodySchema.extend({
  // FIFO assignment does not affect customer-side order totals — assigning
  // tags fills an existing reservation count, never changes quantity. The
  // alsoAdjustOrderSide flag is inherited but ignored by the service.
});
var ReplacePartitionItemTagBodySchema = PartitionItemTargetedBodySchema.extend({
  reservationId: z43.string().uuid(),
  newInventoryPackageId: z43.string().uuid()
});
var DeletePartitionItemUnitBodySchema = PartitionItemTargetedBodySchema.extend({
  /**
   * Specific package label the admin wants to release. Must reference a live
   * reservation on this line item.
   *
   * Pass `null` for the orphan-reservation case: when the line item has
   * `reserved_quantity > 0` but no live reservation rows back it (e.g.
   * detected by anomaly check #1). The service decrements the line item's
   * quantity + reserved counters without touching reservation or package
   * rows. Rejected if the line item HAS live reservations and `tagToRelease`
   * is null — that would silently misuse the orphan path.
   */
  tagToRelease: z43.string().min(1).nullable()
});
var DeletePartitionItemBodySchema = PartitionItemTargetedBodySchema;
var AddPartitionItemBodySchema = BaseMutationBodySchema.extend({
  partitionId: z43.string().uuid(),
  productVariantId: z43.string().uuid(),
  quantity: z43.number().int().min(1),
  unitPrice: z43.string().regex(/^\d+(\.\d{1,2})?$/),
  allocateViaFifo: z43.boolean().default(true),
  alsoAdjustOrderSide: z43.boolean().default(true),
  /** Set to true to skip the duplicate-variant-on-partition guard. */
  allowDuplicate: z43.boolean().default(false)
});
var UpdatePackageStatusBodySchema = BaseMutationBodySchema.extend({
  inventoryPackageId: z43.string().uuid(),
  newStatus: z43.enum(["active", "missing", "fulfilled", "transferred"]),
  destinationLicenseNumber: z43.string().nullable().optional(),
  note: z43.string().max(1e3).optional(),
  /**
   * When transitioning `active → fulfilled` or `active → transferred`, also
   * consume any live reservations against the package atomically (consume the
   * reservation row, decrement parent partition_item.reserved_quantity).
   * Default `true` because stranding reservations on retired packages is the
   * root cause of unconsumed/orphan anomalies. Set to `false` only for edge
   * cases like recall/destruction where reservations should release instead.
   */
  consumeReservationsOnRetire: z43.boolean().default(true)
});
var BulkUpdatePackageStatusBodySchema = BaseMutationBodySchema.extend({
  inventoryPackageIds: z43.array(z43.string().uuid()).min(1).max(500),
  newStatus: z43.enum(["active", "missing", "fulfilled", "transferred"]),
  destinationLicenseNumber: z43.string().nullable().optional(),
  note: z43.string().max(1e3).optional(),
  /** See `UpdatePackageStatusBodySchema.consumeReservationsOnRetire`. */
  consumeReservationsOnRetire: z43.boolean().default(true)
});
var ReassignTaglessPackageLabelBodySchema = BaseMutationBodySchema.extend({
  inventoryPackageId: z43.string().uuid(),
  newPackageLabel: z43.string().min(1)
});
var SealDeliveredPartitionLifecycleBodySchema = BaseMutationBodySchema.extend({
  partitionId: z43.string().uuid(),
  /** OCC token from any partition_item on the partition (service picks the freshest). */
  partitionItemUpdatedAt: z43.string().datetime()
});
var ReleaseStaleReservationBodySchema = BaseMutationBodySchema.extend({
  reservationId: z43.string().uuid()
});
var ReleaseOrphanReservationBodySchema = BaseMutationBodySchema.extend({
  partitionItemId: z43.string().uuid(),
  /** OCC token from the partition_item being cleared. */
  partitionItemUpdatedAt: z43.string().datetime()
});
var ReleaseAllOrphansOnPartitionBodySchema = BaseMutationBodySchema.extend({
  partitionId: z43.string().uuid(),
  /** OCC token from any partition_item on the partition (service picks the freshest). */
  partitionItemUpdatedAt: z43.string().datetime()
});
var OperationResponseShape = z43.object({
  diff: MutationDiffSchema,
  /** null for preview=true; uuid for committed or idempotent_replay. */
  auditLogId: z43.string().uuid().nullable(),
  /** Discriminator so the frontend can render "Applied" vs "Already applied" vs "Preview". */
  kind: z43.enum(["committed", "previewed", "idempotent_replay"]),
  requestId: z43.string()
});
var MutationErrorResponses = {
  400: ErrorResponseSchema,
  401: ErrorResponseSchema,
  403: ErrorResponseSchema,
  404: ErrorResponseSchema,
  409: ErrorResponseSchema,
  422: ErrorResponseSchema
};
var AnomalyTypeSchema = z43.enum([
  "orphan_reservation",
  "tagless_with_live_reservations",
  "unconsumed_on_delivered",
  "counter_drift",
  "stale_on_done_partition"
]);
var ReservationViewSchema = z43.object({
  id: z43.string().uuid(),
  inventoryPackageId: z43.string().uuid(),
  packageLabel: z43.string().nullable(),
  productionBatchNumberSnapshot: z43.string().nullable(),
  receivedDateSnapshot: z43.string().nullable(),
  reservedQuantity: z43.number().int(),
  releasedQuantity: z43.number().int(),
  consumedQuantity: z43.number().int(),
  reservedAt: z43.string().datetime().nullable(),
  consumedAt: z43.string().datetime().nullable()
});
var PartitionItemForOperationsViewSchema = z43.object({
  id: z43.string().uuid(),
  productVariantId: z43.string().uuid(),
  productId: z43.string().uuid().nullable(),
  productName: z43.string().nullable(),
  sku: z43.string().nullable(),
  inventoryItemId: z43.string().uuid().nullable(),
  quantity: z43.number().int(),
  reservedQuantity: z43.number().int(),
  fulfilledQuantity: z43.number().int(),
  unitPrice: z43.string(),
  lineTotal: z43.string(),
  stockDeductedAt: z43.string().datetime().nullable(),
  reservedAt: z43.string().datetime().nullable(),
  /** OCC token returned on read; the frontend must echo this back on mutate. */
  updatedAt: z43.string().datetime(),
  reservations: z43.array(ReservationViewSchema),
  rowAnomalies: z43.array(AnomalyTypeSchema)
});
var PartitionForOperationsResponseSchema = z43.object({
  partition: z43.object({
    id: z43.string().uuid(),
    trackingId: z43.string(),
    displayReference: z43.string().nullable(),
    fulfillmentStatus: z43.string(),
    preparationStatus: z43.string(),
    paymentStatus: z43.string().nullable(),
    stockLocationId: z43.string().uuid().nullable(),
    stockLocationName: z43.string().nullable(),
    brandId: z43.string().uuid(),
    brandName: z43.string().nullable(),
    organizationId: z43.string().uuid().nullable(),
    destinationOrganizationLocationId: z43.string().uuid().nullable(),
    /** Buyer organization name (resolved via destination location). */
    buyerOrganizationName: z43.string().nullable(),
    /** Friendly delivery destination location name. */
    destinationLocationName: z43.string().nullable(),
    /** Compact "City, ST" for the destination. */
    destinationCityState: z43.string().nullable(),
    createdAt: z43.string().datetime(),
    updatedAt: z43.string().datetime()
  }),
  lineItems: z43.array(PartitionItemForOperationsViewSchema),
  /** Anomalies that apply to the partition as a whole (not row-scoped). */
  partitionAnomalies: z43.array(AnomalyTypeSchema)
});
var PackageForOperationsViewSchema = z43.object({
  id: z43.string().uuid(),
  fifoRank: z43.number().int(),
  productionBatchNumber: z43.string().nullable(),
  packageLabel: z43.string().nullable(),
  status: z43.string(),
  quantity: z43.number().int(),
  /** Cached counter on the legacy inventory_batches.reserved_quantity column. May drift from reality. */
  reservedQuantity: z43.number().int(),
  /** Actual sum of active reservations against this package. Truth when cached counter disagrees. */
  computedReservedQuantity: z43.number().int(),
  availableQuantity: z43.number().int(),
  receivedDate: z43.string().nullable(),
  manufactureDate: z43.string().nullable(),
  labTestStatus: z43.string().nullable(),
  stockLocationId: z43.string().uuid(),
  stockLocationName: z43.string().nullable(),
  /** @deprecated Misnamed — actually a sum of active reservation quantities. Use `computedReservedQuantity`. */
  liveReservationCount: z43.number().int(),
  isTagless: z43.boolean(),
  hasCounterDrift: z43.boolean()
});
var InventoryForOperationsResponseSchema = z43.object({
  product: z43.object({
    productId: z43.string().uuid(),
    productName: z43.string(),
    variantId: z43.string().uuid(),
    sku: z43.string().nullable(),
    brandId: z43.string().uuid(),
    brandName: z43.string().nullable(),
    inventoryItemId: z43.string().uuid()
  }),
  healthSummary: z43.object({
    activeCount: z43.number().int(),
    missingCount: z43.number().int(),
    fulfilledCount: z43.number().int(),
    transferredCount: z43.number().int(),
    totalStocked: z43.number().int(),
    totalReserved: z43.number().int(),
    totalAvailable: z43.number().int(),
    taglessCount: z43.number().int(),
    driftCount: z43.number().int()
  }),
  packages: z43.array(PackageForOperationsViewSchema),
  nextCursor: z43.string().nullable()
});
var ReconAnomalyDetailSchema = z43.object({
  label: z43.string(),
  value: z43.string()
});
var ReconAnomalySchema = z43.object({
  type: AnomalyTypeSchema,
  severity: z43.enum(["low", "medium", "high"]),
  scope: z43.enum(["partition", "product", "tag", "reservation", "package"]),
  targetId: z43.string(),
  targetLabel: z43.string(),
  /** Plain-English explanation of what's wrong. No jargon. */
  summary: z43.string(),
  /** Inline key/value context so the admin doesn't have to navigate to understand. */
  details: z43.array(ReconAnomalyDetailSchema),
  /** Brand the anomaly belongs to — drives the client-side multi-select filter. */
  brandId: z43.string().nullable(),
  brandName: z43.string().nullable(),
  /** Pre-filled deep-link params for the frontend's jump-to-fix CTA. */
  jumpTo: z43.object({
    view: z43.enum(["partition", "inventory"]),
    partition: z43.string().optional(),
    productId: z43.string().uuid().optional(),
    tag: z43.string().optional()
  })
});
var ReconciliationReportResponseSchema = z43.object({
  /** Unique scan invocation id — used by the frontend to query the matching triage result. */
  scanId: z43.string().uuid(),
  lastRefreshedAt: z43.string().datetime(),
  anomalies: z43.array(ReconAnomalySchema)
});
var AuditLogPageResponseSchema = z43.object({
  entries: z43.array(AdminOperationLogDtoSchema),
  nextCursor: z43.string().nullable()
});
var TriageSuggestedActionSchema = z43.enum([
  "release_orphan_partition_item",
  "release_all_orphans_on_partition",
  "seal_delivered_partition_lifecycle",
  "release_stale_reservation",
  "reassign_tagless_package_label",
  "update_package_status_fulfilled",
  "manual_review",
  "no_action_needed"
]);
var ReconTriageClusterSchema = z43.object({
  id: z43.string(),
  title: z43.string(),
  description: z43.string(),
  anomalyTargetIds: z43.array(z43.string()),
  severity: z43.enum(["low", "medium", "high"]),
  suggestedAction: TriageSuggestedActionSchema,
  autoSafe: z43.boolean(),
  confidence: z43.number().min(0).max(1)
});
var ReconTriageRunResponseSchema = z43.object({
  id: z43.string().uuid(),
  runId: z43.string().uuid(),
  scanId: z43.string().uuid(),
  totalAnomalies: z43.number().int(),
  autoSafeCount: z43.number().int(),
  needsReviewCount: z43.number().int(),
  summary: z43.string(),
  clusters: z43.array(ReconTriageClusterSchema),
  reviewedAt: z43.string().datetime()
});
var adminOperationsContract = c42.router({
  // ── Mutations (10) ──
  // Preview strategy per spec §6:
  //   - pure-read preview (single-row): 9 ops below except bulkUpdatePackageStatus
  //   - rollback preview (commit-then-abort): bulkUpdatePackageStatus ONLY
  // Idempotency: all 10 catch Postgres 23505 on idx_admin_op_log_client_request
  // and translate it to kind: 'idempotent_replay' in the response body.
  /** FIFO-allocate tags onto a line item. Pure-read preview. */
  assignFifoTagsToPartitionItem: {
    method: "POST",
    path: "/api/admin/operations/assignFifoTagsToPartitionItem",
    query: PreviewQuerySchema,
    body: AssignFifoTagsBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "FIFO-allocate packages to fill a partition_item.reserved_quantity."
  },
  /** Swap a specific reservation onto a different inventory package. Pure-read preview. */
  replacePartitionItemTag: {
    method: "POST",
    path: "/api/admin/operations/replacePartitionItemTag",
    query: PreviewQuerySchema,
    body: ReplacePartitionItemTagBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Repoint a reservation onto a different inventory package."
  },
  /** Decrement a multi-unit line item by 1, releasing the named tag. Pure-read preview. */
  deletePartitionItemUnit: {
    method: "POST",
    path: "/api/admin/operations/deletePartitionItemUnit",
    query: PreviewQuerySchema,
    body: DeletePartitionItemUnitBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Remove one unit from a multi-unit line item, releasing a chosen tag."
  },
  /** Soft-delete an entire line item (deleted_at = now()); release all its reservations. Pure-read preview. */
  deletePartitionItem: {
    method: "POST",
    path: "/api/admin/operations/deletePartitionItem",
    query: PreviewQuerySchema,
    body: DeletePartitionItemBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Soft-delete a partition_item; release all reservations."
  },
  /** Insert a new line item on an existing partition (optionally FIFO-allocate). Pure-read preview. */
  addPartitionItem: {
    method: "POST",
    path: "/api/admin/operations/addPartitionItem",
    query: PreviewQuerySchema,
    body: AddPartitionItemBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Add a new line item to an existing partition."
  },
  /** Override a single package's lifecycle status. Pure-read preview. */
  updatePackageStatus: {
    method: "POST",
    path: "/api/admin/operations/updatePackageStatus",
    query: PreviewQuerySchema,
    body: UpdatePackageStatusBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Override a single inventory package lifecycle status."
  },
  /**
   * Bulk package lifecycle override. ROLLBACK PREVIEW: opens the transaction,
   * runs the mutation, captures the diff, then throws a sentinel to roll
   * back. Locks the touched package rows for the duration of the preview —
   * fine for small package sets (≤500 ids enforced by Zod), but callers should
   * preview only the packages they intend to commit.
   */
  bulkUpdatePackageStatus: {
    method: "POST",
    path: "/api/admin/operations/bulkUpdatePackageStatus",
    query: PreviewQuerySchema,
    body: BulkUpdatePackageStatusBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Bulk-override multiple inventory package statuses (rollback preview)."
  },
  /** Assign a package label to a tagless active package. Pure-read preview. */
  reassignTaglessPackageLabel: {
    method: "POST",
    path: "/api/admin/operations/reassignTaglessPackageLabel",
    query: PreviewQuerySchema,
    body: ReassignTaglessPackageLabelBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Set a package label on a tagless package row (supplier-cleared repair)."
  },
  /**
   * Seal the consumption + stock-deducted lifecycle on a delivered partition
   * whose reservations never fired consumption. Pure-read preview. Per-reservation
   * updates set consumed_quantity + consumed_at; the partition_item.stock_deducted_at
   * is set ONCE.
   */
  sealDeliveredPartitionLifecycle: {
    method: "POST",
    path: "/api/admin/operations/sealDeliveredPartitionLifecycle",
    query: PreviewQuerySchema,
    body: SealDeliveredPartitionLifecycleBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Seal consumed/stock_deducted timestamps on a delivered partition."
  },
  /** Release a stale live reservation (reserved - released - consumed > 0). Pure-read preview. */
  releaseStaleReservation: {
    method: "POST",
    path: "/api/admin/operations/releaseStaleReservation",
    query: PreviewQuerySchema,
    body: ReleaseStaleReservationBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Release a stale live reservation on a done partition."
  },
  /**
   * Clear the cached reserved_quantity on an orphan partition_item — one
   * where the counter says reserved>0 but NO live reservation row backs it.
   * Pure counter resync; no package rows or reservation rows touched.
   */
  releaseOrphanReservation: {
    method: "POST",
    path: "/api/admin/operations/releaseOrphanReservation",
    query: PreviewQuerySchema,
    body: ReleaseOrphanReservationBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Clear the cached reserved counter on an orphan partition_item."
  },
  /**
   * Partition-wide version of `releaseOrphanReservation`: walks every line
   * item on the partition that has a cached reserved>0 but no live
   * reservations, and clears them all in one transaction with one audit row.
   */
  releaseAllOrphansOnPartition: {
    method: "POST",
    path: "/api/admin/operations/releaseAllOrphansOnPartition",
    query: PreviewQuerySchema,
    body: ReleaseAllOrphansOnPartitionBodySchema,
    responses: { 200: OperationResponseShape, ...MutationErrorResponses },
    summary: "Clear cached reserved counters on every orphan line item of a partition."
  },
  // ── Reads (4) ──
  /**
   * Resolve a partition by UUID, tracking_id (FLT-XXXXXX), or display_reference
   * (5902-DIME). Returns the partition + line items + reservations + anomaly
   * flags ready to render in the Partition Inspector view.
   */
  getPartitionForOperations: {
    method: "GET",
    path: "/api/admin/operations/partition/:partitionResolver",
    pathParams: z43.object({ partitionResolver: z43.string().min(1) }),
    responses: {
      200: PartitionForOperationsResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema
    },
    summary: "Fetch a partition + line items for the Partition Inspector view."
  },
  /**
   * Product-scoped package browser data. Returns product header, health summary,
   * and paginated FIFO-ranked packages.
   */
  getInventoryForOperations: {
    method: "GET",
    path: "/api/admin/operations/inventory/:productId",
    // `productId` is polymorphic: accepts a UUID (product or variant), a
    // variant SKU/external code, or a product-name search term. Resolution
    // happens server-side. Kept named `productId` for URL-stability — the
    // recon-report Fix-this CTAs already write variant UUIDs into this slot.
    pathParams: z43.object({ productId: z43.string().min(1) }),
    query: z43.object({
      stockLocationId: z43.string().uuid().optional(),
      statusFilter: z43.enum(["active", "missing", "fulfilled", "transferred", "all"]).default("all"),
      cursor: z43.string().optional(),
      limit: z43.coerce.number().int().min(1).max(100).default(50)
    }),
    responses: {
      200: InventoryForOperationsResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema
    },
    summary: "Fetch product/variant package list for the Inventory Manager view."
  },
  /**
   * Run all 5 anomaly checks on demand. Admin-opt-in only — never auto-polled.
   */
  getReconciliationReport: {
    method: "GET",
    path: "/api/admin/operations/reconciliation",
    query: z43.object({
      anomalyType: AnomalyTypeSchema.optional(),
      brandId: z43.string().uuid().optional(),
      stockLocationId: z43.string().uuid().optional()
    }),
    responses: {
      200: ReconciliationReportResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema
    },
    summary: "Run all anomaly checks and return a flat worklist of instances."
  },
  /**
   * Fetch the Anomaly Triage Agent's result for a given scanId. Returns 404
   * while the agent is still processing — the frontend polls until completed.
   */
  getReconTriage: {
    method: "GET",
    path: "/api/admin/operations/recon-triage/:scanId",
    pathParams: z43.object({ scanId: z43.string().uuid() }),
    responses: {
      200: ReconTriageRunResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
      404: ErrorResponseSchema
    },
    summary: "Fetch the Anomaly Triage Agent result for a scan."
  },
  /**
   * Paginated audit log feed for the Recent Operations affordance. Cursor
   * format is `<executedAt-iso>:<id>` for stable composite keying.
   */
  getAuditLog: {
    method: "GET",
    path: "/api/admin/operations/audit-log",
    query: z43.object({
      cursor: z43.string().optional(),
      limit: z43.coerce.number().int().min(1).max(100).default(50),
      partitionId: z43.string().uuid().optional(),
      inventoryItemId: z43.string().uuid().optional(),
      operation: z43.string().optional()
    }),
    responses: {
      200: AuditLogPageResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema
    },
    summary: "Paginated admin.operation_log feed for Recent Operations."
  }
});

// src/http/index.ts
var c43 = initContract43();
var commerceHttpRoutes = {
  analytics: analyticsContract,
  brands: brandsContract,
  products: productsContract,
  productSync: productSyncContract,
  categories: categoriesContract,
  orders: ordersContract,
  customers: customersContract,
  addresses: addressesContract,
  checkout: checkoutContract,
  bankAccounts: bankAccountsContract,
  scheduledChecks: scheduledChecksContract,
  discountCodes: discountCodesContract,
  fulfillmentOffers: fulfillmentOffersContract,
  transactions: transactionsContract,
  promotions: promotionsContract,
  licenses: licensesContract,
  b2bwaveBrands: b2bwaveBrandsContract,
  metrcReference: metrcReferenceContract,
  orgProducts: orgProductsContract,
  backInStock: backInStockContract
};
var authHttpRoutes = {
  embedConfig: embedConfigContract,
  auth: authContract,
  portalAuth: portalAuthContract,
  email: emailContract,
  permissions: permissionsContract
};
var organizationHttpRoutes = {
  inventory: inventoryContract,
  inventoryAccess: inventoryAccessContract,
  productManagement: productManagementContract,
  variantBuyerPrices: variantBuyerPricesContract,
  portalAdmin: portalAdminContract,
  organizationsMe: organizationsMeContract,
  organizationsAdmin: organizationsAdminContract,
  organizationsPortal: organizationsPortalContract,
  metrcIntegrationAdmin: metrcIntegrationAdminContract,
  metrcInventoryEngine: metrcInventoryEngineContract,
  metrcMemberKey: metrcMemberKeyContract,
  supplierAnalytics: supplierAnalyticsContract,
  customerCapabilities: customerCapabilitiesContract,
  memberNotificationPreferences: memberNotificationPreferencesContract,
  productReviews: productReviewsContract,
  agentAnalytics: agentAnalyticsContract
  // admin-only, guarded by Permission.MEMBERS_VIEW
};
var adminHttpRoutes = {
  adminOperations: adminOperationsContract
  // admin-only, guarded by requireFloteStaffAdmin
};
var operationsHttpRoutes = {
  signnow: signnowContract,
  telnyx: telnyxContract,
  assignmentQueue: assignmentQueueContract,
  drivers: supplierDriversContract,
  deliveryTeam: supplierDeliveryTeamContract,
  vehicles: supplierVehiclesContract,
  deliveryRoutes: supplierRoutesContract,
  supplierShipmentLegs: shipmentLegsContract,
  routePlans: supplierRoutePlansContract
};
var rootHttpRoutes = {
  ...commerceHttpRoutes,
  ...authHttpRoutes,
  ...organizationHttpRoutes,
  ...operationsHttpRoutes,
  ...adminHttpRoutes
};
var rootHttpContract = c43.router(
  rootHttpRoutes
);
var commerceHttpContract = c43.router(commerceHttpRoutes);
var authHttpContract = c43.router(authHttpRoutes);
var organizationHttpContract = c43.router(organizationHttpRoutes);
var operationsHttpContract = c43.router(operationsHttpRoutes);
var adminHttpContract = c43.router(adminHttpRoutes);
var legacyRootHttpContract = rootHttpContract;
var modularHttpContractGroups = {
  commerce: commerceHttpContract,
  auth: authHttpContract,
  organization: organizationHttpContract,
  operations: operationsHttpContract,
  admin: adminHttpContract
};
export {
  AbortOptimizationResponseSchema,
  AccessibleEmbedSchema,
  AddDeliveryTeamManagerRequestSchema,
  AddHubSplitRequestSchema,
  AddHubSplitResponseSchema,
  AdminOrderPartitionDetailSchema,
  AdminOrderPartitionSchema,
  AdminPackageAllocationMetrcTagConflictCodeSchema,
  AdminPackageAllocationMetrcTagConflictResponseSchema,
  AdminPackageAllocationMetrcTagConflictSchema,
  AdminPackageAllocationMetrcTagUpdateResponseSchema,
  AdminPartitionDetailSchema,
  AdminPartitionFulfillmentStatusSchema,
  AdminPartitionFulfillmentTypeSchema,
  AdminPartitionItemDetailSchema,
  AdminPartitionItemPackageAllocationSchema,
  AdminPartitionItemSchema,
  AdminPartitionListItemSchema,
  AdminPartitionListResponseSchema,
  AdminProductListingDtoSchema,
  AdminProductListingResponseSchema,
  AdminStockLocationDtoSchema,
  AdminStockLocationListResponseSchema,
  AnalyticsBatchEventSchema,
  AnalyticsBatchRequestSchema,
  AnalyticsCaptureEventSchema,
  AnalyticsErrorResponseSchema,
  AnalyticsGroupIdentifySchema,
  AnalyticsIdentifySchema,
  AnalyticsSuccessResponseSchema,
  AnalyticsSummaryResponseSchema,
  AnomalyTypeSchema,
  AssignDestinationLicenseRequestSchema,
  AssignDestinationLicenseResponseSchema,
  AssignDriverToPartitionRequestSchema,
  AssignDriverToShipmentLegRequestSchema,
  AssignDriverToShipmentLegResponseSchema,
  AssignTaskRequestSchema,
  AssignVehicleRequestSchema,
  AssignVehicleToDriverRequestSchema,
  AuditLogPageResponseSchema,
  AuthCustomerSchema,
  AuthValidationResponseSchema,
  AutoAssignPackageAllocationsErrorCodeSchema,
  AutoAssignPackageAllocationsErrorResponseSchema,
  AutoAssignPackageAllocationsModeSchema,
  AutoAssignPackageAllocationsResponseSchema,
  AutoEnqueueRequestSchema,
  AutoEnqueueResponseSchema,
  B2BWaveCategoryDtoSchema,
  B2BWaveOrderProductSummarySchema,
  B2BWaveOrderSummarySchema,
  B2BWaveProductCustomerPriceDtoSchema,
  B2BWaveProductDiscountDtoSchema,
  B2BWaveProductDtoSchema,
  B2BWaveProductFileDtoSchema,
  B2BWaveProductPriceDtoSchema,
  B2BWaveProductVariantOptionSchema,
  B2BWaveProductVariantSchema,
  B2BWaveWarehouseQuantitySchema,
  BankAccountDtoSchema,
  BatchInsertHubRequestSchema,
  BatchInsertHubResponseSchema,
  BatchRoutesResponseSchema,
  BrandComparisonResponseSchema,
  BuyerPriceMatchSchema,
  BuyerPriceTierSchema,
  CancelQueueEntryResponseSchema,
  CategorySalesResponseSchema,
  CheckCarrierTrackingMetricsSchema,
  CheckCarrierTrackingResponseSchema,
  CompletionRequirementsSchema,
  CreateAuxiliaryTaskBodySchema,
  CreateAuxiliaryTaskResponseSchema,
  CreateDestinationAddressSchema,
  CreateDestinationRequestSchema,
  CreateDriverRequestSchema,
  CreateDriverVehicleInputSchema,
  CreateHubAddressSchema,
  CreateHubRequestSchema,
  CreateLinkedTasksRequestSchema,
  CreateMetrcPackageHoldsBodySchema,
  CreateOnfleetWebhookRequestSchema,
  CreateOrderPartitionNoteRequestSchema,
  CreatePartitionTaskRequestSchema,
  CreateRecipientRequestSchema,
  CreateRoutePlanInputSchema,
  CreateShipmentFromPartitionsConflictSchema,
  CreateShipmentFromPartitionsRequestSchema,
  CreateShipmentFromPartitionsResponseSchema,
  CreateShipmentPlanQueueErrorSchema,
  CreateShipmentPlanRequestSchema,
  CreateShipmentPlanResponseSchema,
  CreateSupplierDriverInputSchema,
  CreateSupplierLocationTeamRequestSchema,
  CreateSupplierVehicleInputSchema,
  CreateTaskRequestSchema,
  CreateTeamRequestSchema,
  CreateTestOrderInputSchema,
  CreateTestOrderItemSchema,
  CreateVehicleRequestSchema,
  CreditApplicationSchema,
  CustomerPaymentCapabilitiesDtoSchema,
  CustomerRetentionResponseSchema,
  CustomerSearchResultSchema,
  DashboardStatsSchema,
  DeleteShipmentLegRequestSchema,
  DeleteShipmentLegResponseSchema,
  DeleteShipmentRequestSchema,
  DeleteShipmentResponseSchema,
  DeliveryTaskSchema,
  DeliveryTaskStatusSchema,
  DeliveryTaskTypeSchema,
  DeliveryTeamHubOptionSchema,
  DeliveryTeamManagerSchema,
  DestinationAddressSchema,
  DestinationLocationSchema,
  DestinationSchema,
  DiscountPerformanceResponseSchema,
  DispatchShipmentRequestSchema,
  DriverAnalyticsQuerySchema,
  DriverAnalyticsSchema,
  DriverPoolQuerySchema,
  DriverPoolResponseSchema,
  DriverPositionSchema,
  DriverReconcileMetricsSchema,
  DriverSchema,
  DriverStatusSchema,
  DriverTasksQuerySchema,
  EmbedBrandingSchema,
  EmbedConfigListItemDtoSchema,
  EmbedConfigResponseSchema,
  EnqueuePartitionRequestSchema,
  EnqueuePartitionResponseSchema,
  EnrichedB2BWaveProductSchema,
  EnrichedQueueEntrySchema,
  ErrorResponseSchema,
  ExpireMetrcPackageHoldsBodySchema,
  FileAttachmentSchema,
  FulfillmentEconomicsResponseSchema,
  GeoLocationSchema,
  GetAssignmentQueueStatsQuerySchema,
  GetB2BWaveCategoriesInputDtoSchema,
  GetB2BWaveCustomersInputDtoSchema,
  GetB2BWaveProductCustomerPricesInputDtoSchema,
  GetB2BWaveProductsInputDtoSchema,
  GetRoutesQuerySchema,
  GetShipmentDriverPositionsResponseSchema,
  GetShipmentLegManifestResponseSchema,
  GetSupplierRoutesQuerySchema,
  GetTeamTasksQuerySchema,
  HubAddressSchema,
  HubLocationSchema,
  HubSchema,
  InitializeOptimizationRequestSchema,
  InitializeOptimizationResponseSchema,
  InsertWaypointRequestSchema,
  InsertWaypointResponseSchema,
  InternalDatabaseFailoverStatusResponseSchema,
  InternalDatabaseFailoverSwitchResponseSchema,
  InternalDatabaseHealthSchema,
  InternalDatabaseStatusSchema,
  InternalDatabaseSwitchRequestSchema,
  InternalDatabaseSwitchResultSchema,
  InventoryForOperationsResponseSchema,
  InventoryHealthResponseSchema,
  LegConsistencyIssueSchema,
  LinkedTasksResponseSchema,
  ListAssignmentQueueQuerySchema,
  ListDestinationsQuerySchema,
  ListDriversQuerySchema,
  ListOrderPartitionNotesResponseSchema,
  ListOrdersQuerySchema,
  ListPartitionsQuerySchema,
  ListRecipientsQuerySchema,
  ListRoutePlansQuerySchema,
  ListShipmentLegQueueQuerySchema,
  ListShipmentSummariesQuerySchema,
  ListSupplierDriversQuerySchema,
  ListSupplierVehiclesQuerySchema,
  ListTasksQuerySchema,
  ListVehiclesQuerySchema,
  MemberSchema,
  MetrcFacilityLicenseDtoSchema,
  MetrcItemCategoryDtoSchema,
  MetrcItemDtoSchema,
  MetrcStrainDtoSchema,
  MetrcUnitOfMeasureDtoSchema,
  OnfleetWebhookSchema,
  OnfleetWebhookTriggerSchema,
  OperationResponseShape as OperationResponseSchema,
  OptimizationIssueSchema,
  OptimizationMetricsSchema,
  OptimizationResultSummarySchema,
  OptimizationStatusResponseSchema,
  OptimizationWorkerMetricsSchema,
  OptimizeShipmentRouteRequestSchema,
  OptimizeShipmentRouteResponseSchema,
  OptimizeShipmentRouteResponseSegmentSchema,
  OrderExportResponseSchema,
  OrderExportRowSchema,
  OrderHeatmapResponseSchema,
  OrderPartitionNoteDtoSchema,
  OrdersOverTimeResponseSchema,
  PackageForOperationsViewSchema,
  PaginatedPartitionsResponseSchema,
  PartitionForOperationsResponseSchema,
  PartitionItemForOperationsViewSchema,
  PartitionTaskResultSchema,
  PartitionTaskSkippedSchema,
  PhotoUploadResponseSchema,
  PollDriverLocationRequestSchema,
  PollDriverLocationResponseSchema,
  PortalBrandSchema,
  PortalUserRoleSchema,
  PortalUserSchema,
  PrepareShipmentLegManifestRequestSchema,
  PrepareShipmentLegManifestResponseSchema,
  PrepareShipmentManifestsRequestSchema,
  PrepareShipmentManifestsResponseSchema,
  ProductReviewDtoSchema,
  ProductSalesResponseSchema,
  PublicTrackingResponseSchema,
  PublishMetrcPackagesBodySchema,
  QueueListResponseSchema,
  RecipientSchema,
  RecipientSearchQuerySchema,
  ReconAnomalySchema,
  ReconcileDriversResponseSchema,
  ReconcileFulfillmentsMetricsSchema,
  ReconcileFulfillmentsRequestSchema,
  ReconcileFulfillmentsResponseSchema,
  ReconcileShipmentLegMetrcRefsRequestSchema,
  ReconcileShipmentLegMetrcRefsResponseSchema,
  ReconcileShipmentLegMetrcRefsScopeSchema,
  ReconciliationReportResponseSchema,
  ReleaseMetrcPackageHoldsBodySchema,
  RemoveHubSplitRequestSchema,
  RemoveHubSplitResponseSchema,
  ReorderStopsRequestSchema,
  ReorderStopsResponseSchema,
  ResendCreateEmailResponseSchema,
  ReservationViewSchema,
  ReviewCategorySchema,
  RouteBoundsSchema,
  RouteOptimizationModeSchema,
  RouteOptimizationParamsSchema,
  RoutePlanSchema,
  RoutePlanSummarySchema,
  RoutePointSchema,
  SalesByCustomerResponseSchema,
  SendVerificationRequestSchema,
  SendVerificationResponseSchema,
  SetDefaultBankAccountRequestSchema,
  SetEmbedPaymentOverrideBodySchema,
  ShipmentDetailResponseSchema,
  ShipmentLegManifestActionResponseSchema,
  ShipmentLegQueueListResponseSchema,
  ShipmentManifestActionResponseSchema,
  ShipmentQueueSummariesResponseSchema,
  SignNowDocumentGroupTemplateSchema,
  SignNowDocumentGroupTemplatesResponseSchema,
  SignNowEmbeddedInviteLinkSchema,
  SignNowSigningLinkSchema,
  SignNowTemplateSchema,
  SignNowThumbnailSchema,
  StoreBankAccountRequestSchema,
  SubmitShipmentLegManifestRequestSchema,
  SubmitShipmentManifestRequestSchema,
  SupplierDeliveryTeamSchema,
  SupplierLocationTeamSchema,
  SupplierLocationTeamWithDetailsSchema,
  SyncActiveMetrcPackagesBodySchema,
  SyncDeliveryProofAssetRequestSchema,
  SyncDeliveryProofAssetResponseSchema,
  SyncOutgoingTransferEvidenceBodySchema,
  SyncResponseSchema,
  SyncTeamResultSchema,
  TargetedMovementEvidenceBackfillBodySchema,
  TaskAddressSchema,
  TaskAssignmentResultSchema,
  TaskRouteSchema,
  TeamAutoDispatchRequestSchema,
  TeamAutoDispatchResponseSchema,
  TeamMembersSchema,
  TeamSchema,
  TelnyxErrorSchema,
  TestOrderDetailSchema,
  TestOrderListItemSchema,
  TestOrderListResponseSchema,
  TimelineEntrySchema,
  UnpublishMetrcPackagesBodySchema,
  UpdateDriverRequestSchema,
  UpdateDriverTeamsInputSchema,
  UpdateHubMetadataRequestSchema,
  UpdateHubMetadataResponseSchema,
  UpdateHubRequestSchema,
  UpdateOrderPartitionNoteRequestSchema,
  UpdatePartitionRequestSchema,
  UpdatePriorityRequestSchema,
  UpdateRecipientRequestSchema,
  UpdateRoutePlanTasksInputSchema,
  UpdateShipmentLegManifestRequestSchema,
  UpdateShipmentLegRequestSchema,
  UpdateShipmentLegResponseSchema,
  UpdateSupplierDeliveryTeamRequestSchema,
  UpdateSupplierDriverInputSchema,
  UpdateSupplierVehicleInputSchema,
  UpdateTaskRequestSchema,
  UpdateTeamRequestSchema,
  UpdateVehicleRequestSchema,
  UpsertMetrcItemMappingBodySchema,
  VEHICLE_TYPES_REQUIRING_MAKE_MODEL,
  VehicleSchema,
  VehicleStatusSchema,
  VehicleTypeSchema,
  VerifyCodeRequestSchema,
  VerifyCodeResponseSchema,
  VoidShipmentLegManifestRequestSchema,
  addressesContract,
  adminAuthContract,
  adminDashboardContract,
  adminDestinationsContract,
  adminDriversContract,
  adminHttpContract,
  adminHttpRoutes,
  adminHubsContract,
  adminOnfleetWebhooksContract,
  adminOperationsContract,
  adminOrdersContract,
  adminPartitionsContract,
  adminRecipientsContract,
  adminRouteOptimizationContract,
  adminRoutesContract,
  adminTasksContract,
  adminTeamsContract,
  adminVehiclesContract,
  agentAnalyticsContract,
  analyticsContract,
  assignmentQueueContract,
  authContract,
  authHttpContract,
  authHttpRoutes,
  auxiliaryTasksContract,
  b2bwaveBrandsContract,
  backInStockContract,
  bankAccountsContract,
  brandsContract,
  categoriesContract,
  checkoutContract,
  commerceHttpContract,
  commerceHttpRoutes,
  customerCapabilitiesContract,
  customersContract,
  deliveryGatewayContract,
  discountCodesContract,
  emailContract,
  embedConfigContract,
  fulfillmentOffersContract,
  internalAssignmentQueueContract,
  internalDatabaseFailoverContract,
  internalPartitionTasksContract,
  inventoryAccessContract,
  inventoryContract,
  jobsContract,
  legacyRootHttpContract,
  licensesContract,
  memberNotificationPreferencesContract,
  metrcIntegrationAdminContract,
  metrcInventoryEngineContract,
  metrcMemberKeyContract,
  metrcReferenceContract,
  modularHttpContractGroups,
  operationsHttpContract,
  operationsHttpRoutes,
  ordersContract,
  orgProductsContract,
  organizationHttpContract,
  organizationHttpRoutes,
  organizationsAdminContract,
  organizationsMeContract,
  organizationsPortalContract,
  permissionsContract,
  portalAdminContract,
  portalAuthContract,
  productManagementContract,
  productReviewsContract,
  productSyncContract,
  productsContract,
  promotionsContract,
  rootHttpContract,
  rootHttpRoutes,
  scheduledChecksContract,
  shipmentLegsContract,
  signnowContract,
  supplierAnalyticsContract,
  supplierDeliveryTeamContract,
  supplierDriversContract,
  supplierRoutePlansContract,
  supplierRoutesContract,
  supplierVehiclesContract,
  telnyxContract,
  trackingContract,
  transactionsContract,
  variantBuyerPricesContract,
  vehicleTypeRequiresMakeAndModel,
  webhooksContract
};
